import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {"fetchPolicy":"no-cache"} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: string; output: string; }
  ExpectedError: { input: any; output: any; }
  GeoJSON: { input: any; output: any; }
  JSON: { input: any; output: any; }
  UUID: { input: string; output: string; }
  Upload: { input: any; output: any; }
  image: { input: any; output: any; }
};

export type AccountAttributeInput = {
  enabled: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
};

export type AccountAttributeResponseType = {
  __typename?: 'AccountAttributeResponseType';
  attributes?: Maybe<Array<AccountAttributeStateType>>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type AccountAttributeStateType = {
  __typename?: 'AccountAttributeStateType';
  defaultEnabled: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type AccountResponseType = {
  __typename?: 'AccountResponseType';
  account: AccountType;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type AccountSubscriptionType = {
  __typename?: 'AccountSubscriptionType';
  id: Scalars['ID']['output'];
  isManuallySet: Scalars['Boolean']['output'];
  stripeCancelAtPeriodEnd: Scalars['Boolean']['output'];
  stripeCurrentPeriodEnd?: Maybe<Scalars['Date']['output']>;
  stripeRenewalFailed: Scalars['Boolean']['output'];
  subscriptionPlan: SubscriptionPlanType;
};

export type AccountType = {
  __typename?: 'AccountType';
  createdAt: Scalars['DateTime']['output'];
  devices: Array<DeviceType>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  subscriptionPlan: SubscriptionPlanType;
};

export type AlertMessageType = {
  __typename?: 'AlertMessageType';
  ackTime?: Maybe<Scalars['DateTime']['output']>;
  eventDevice: EventDeviceType;
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  sendTime: Scalars['DateTime']['output'];
  sender?: Maybe<BaseUserType>;
};

export type AllMutationsWithSuperuser = {
  __typename?: 'AllMutationsWithSuperuser';
  acceptPolicies: ResponseType;
  addEventDeviceToWorkspaces: WorkspacesResponseType;
  addWorkspaceEventDevice: WorkspaceResponseType;
  analyzeEventDevice: AnalyzeEventDeviceResponseType;
  applyCollectionToWorkspace: WorkspaceResponseType;
  applyImportChannelSelections: ImportSessionResponseType;
  applyImportTrack: ImportSessionResponseType;
  /**
   * Archive account and revoke refresh tokens.
   *
   *     User must be verified and confirm password.
   *
   */
  archiveAccount: MutationNormalOutput;
  authorizeOauthApplication: AuthorizeOAuthApplicationResponseType;
  cancelImportSession: ImportSessionResponseType;
  /**
   * Creates a brand-new captcha. Returns a base64 encoded string of the
   *         captcha. And uuid representing the captcha id in the database. When you
   *         will try to log in or register You will need submit that uuid With the
   *         user input.
   *
   *         **The captcha will be invoked when the timeout expires**.
   *
   */
  captcha: CaptchaType;
  createDevice: DeviceResponseType;
  createEvent: PodiumEventResponseType;
  createEventDevice: EventDeviceResponseType;
  createImportSession: CreateImportSessionResponseType;
  createPreset: PresetResponseType;
  createTelemetryExport: CreateTelemetryExportResponseType;
  createTelemetryImport: CreateTelemetryImportResponseType;
  createUser: UserResponseType;
  createVenue: VenueResponseType;
  createVenueSectorScheme: SectorSchemeResponseType;
  createWorkspace: WorkspaceResponseType;
  /**
   * Delete account permanently or make `user.is_active=False`.
   *
   *     The behavior is defined on settings. Anyway user refresh tokens are
   *     revoked.
   *
   *     User must be verified and confirm password.
   *
   */
  deleteAccount: MutationNormalOutput;
  deleteApiKey: OkResponseType;
  deleteDevice: OkResponseType;
  deleteEvent: ResponseType;
  deleteEventDevice: OkResponseType;
  deleteOauthApplication: OkResponseType;
  deletePreset: OkResponseType;
  deleteTelemetryExport: ResponseType;
  deleteTelemetryImport: ResponseType;
  deleteVenue: ResponseType;
  deleteVenueSectorScheme: ResponseType;
  deleteWorkspace: ResponseType;
  deselectWorkspaceLap: WorkspaceResponseType;
  finalizeImport: ImportSessionResponseType;
  followUser: ResponseType;
  generateApiKey: GenerateApiKeyResponseType;
  generateSourceFileDownloadLink: GenerateSourceFileDownloadLinkResponseType;
  generateTelemetryExportFileDownloadLink: GenerateTelemetryExportFileDownloadLinkResponseType;
  labelWorkspaceEventDevice: WorkspaceResponseType;
  /**
   * Change account password when user knows the old password.
   *
   *     A new token and refresh token are sent. User must be verified.
   *
   */
  passwordChange: ObtainJsonWebTokenType;
  /**
   * Change user password without old password.
   *
   *     Receive the token that was sent by email.
   *
   *     If token and new passwords are valid, update user password and in
   *     case of using refresh tokens, revoke all of them.
   *
   *     Also, if user has not been verified yet, verify it.
   *
   */
  passwordReset: MutationNormalOutput;
  /**
   *
   *     Set user password - for password-less registration
   *
   *     Receive the token that was sent by email.
   *
   *     If token and new passwords are valid, set
   *     user password and in case of using refresh
   *     tokens, revoke all of them.
   *
   *     Also, if user has not been verified yet, verify it.
   *
   */
  passwordSet: MutationNormalOutput;
  ratePreset: ResponseType;
  recordHelpProgress: HelpProgressResponseType;
  /**
   * ### refreshToken to generate a new login token:
   *
   *     *Use this only if `JWT_LONG_RUNNING_REFRESH_TOKEN` is True*
   *
   *     using the refresh-token you already got during authorization, and
   *     obtain a brand-new token (and possibly a new refresh token if you
   *     revoked the previous). This is an alternative to log in when your
   *     token expired.
   *
   */
  refreshToken: TokenAuthResponseType;
  regenerateVenueSectorScheme: SectorSchemeResponseType;
  /**
   * Register user with fields defined in the settings. If the email field of
   *     the user model is part of the registration fields (default), check if there
   *     is no user with that email.
   *
   *     If it exists, it does not register the user, even if the email field
   *     is not defined as unique (default of the default django user model).
   *
   *     When creating the user, it also creates a `UserStatus` related to
   *     that user, making it possible to track if the user is archived /
   *     verified.
   *
   *     Send account verification email.
   *
   *     If allowed to not verified users login, return token.
   *
   */
  register: MutationNormalOutput;
  registerOauthApplication: RegisterOAuthApplicationResponseType;
  /**
   * Register user with fields defined in the settings. If the email field of
   *     the user model is part of the registration fields (default), check if there
   *     is no user with that email.
   *
   *     If it exists, it does not register the user, even if the email field
   *     is not defined as unique (default of the default django user model).
   *
   *     When creating the user, it also creates a `UserStatus` related to
   *     that user, making it possible to track if the user is archived /
   *     verified.
   *
   *     Send account verification email.
   *
   *     If allowed to not verified users login, return token.
   *
   */
  registerWithAccount: MutationNormalOutput;
  removeWorkspaceEventDevice: WorkspaceResponseType;
  renameWorkspace: WorkspaceResponseType;
  reorderWorkspaceEventDevices: WorkspaceResponseType;
  reportPreset: ResponseType;
  /**
   * Sends activation email.
   *
   *     It is called resend because theoretically the first activation email
   *     was sent when the user registered.
   *
   *     If there is no user with the requested email, a successful response
   *     is returned.
   *
   */
  resendActivationEmail: MutationNormalOutput;
  resetUserPreference: UserPreferenceResponseType;
  revokeApiKey: ApiKeyResponseType;
  revokeOauthApplicationAccess: OkResponseType;
  /**
   * ### Suspends a refresh token.
   *
   *     *token must exist to be revoked.*
   *
   */
  revokeToken: RevokeRefreshTokenType;
  selectWorkspaceLap: WorkspaceResponseType;
  /**
   * Send password reset email.
   *
   *     For non verified users, send an activation email instead.
   *
   *     If there is no user with the requested email, a successful response
   *     is returned.
   *
   */
  sendPasswordResetEmail: MutationNormalOutput;
  setMarketingConsent: ResponseType;
  setPrimarySectorScheme: SectorSchemeResponseType;
  setWorkspaceEventDeviceLive: WorkspaceResponseType;
  setWorkspaceScreens: WorkspaceResponseType;
  startImportConversion: ImportSessionResponseType;
  subscriptionManagmentSessionUrl: StripeSessionResponseType;
  superuserClearPresetReports: OkResponseType;
  superuserCreateAccount: SuperuserAccountResponseType;
  superuserCreatePolicyDocument: SuperuserPolicyDocumentResponseType;
  superuserCreatePreset: SuperuserPresetResponseType;
  superuserCreatePresetType: SuperuserPresetTypeResponseType;
  superuserCreateUser: SuperuserUserResponseType;
  superuserDeactivateUser: SuperuserUserResponseType;
  superuserDeleteAccount: OkResponseType;
  superuserDeleteEvent: ResponseType;
  superuserDeleteEventDevice: OkResponseType;
  superuserDeletePolicyDocument: ResponseType;
  superuserDeletePreset: OkResponseType;
  superuserDeletePresetType: ResponseType;
  superuserDeleteTelemetryExport: OkResponseType;
  superuserDeleteTelemetryImport: OkResponseType;
  superuserDeleteUser: OkResponseType;
  superuserDeleteUserFeatureFlag: ResponseType;
  superuserDowngradeUser: OkResponseType;
  superuserElevateUser: OkResponseType;
  superuserExportPublicVenueLeaderboards: PublicVenueLeaderboardExportResultType;
  superuserGenerateTelemetryExportDownloadLink: GenerateTelemetryExportDownloadLinkResponseType;
  superuserGenerateTelemetryImportDownloadLink: GenerateTelemetryImportDownloadLinkResponseType;
  superuserGetEventDeviceDataSegmentDownloadLink: SuperuserEventDeviceDataSegmentDownloadLinkResponseType;
  superuserGetLegacyArchiveDownloadLink: SuperuserLegacyArchiveDownloadLinkResponseType;
  superuserPublishPolicyDocument: SuperuserPolicyDocumentResponseType;
  superuserReactivateUser: SuperuserUserResponseType;
  superuserRegenerateVenueGeometry: VenueGeometryRegenResponseType;
  superuserResetHelpProgress: ResponseType;
  superuserRetryTelemetryImport: OkResponseType;
  superuserSetAccountAttributes: AccountAttributeResponseType;
  superuserSetUserFeatureFlag: FeatureFlagAssignmentResponseType;
  superuserUnpublishPolicyDocument: SuperuserPolicyDocumentResponseType;
  superuserUpdateAccount: SuperuserAccountResponseType;
  superuserUpdateAccountSubscription: SuperuserAccountSubscriptionResponseType;
  superuserUpdateEvent: SuperuserPodiumEventResponseType;
  superuserUpdateLegalEntitySettings: SuperuserLegalEntitySettingsResponseType;
  superuserUpdatePolicyDocument: SuperuserPolicyDocumentResponseType;
  superuserUpdatePreset: SuperuserPresetResponseType;
  superuserUpdatePresetType: SuperuserPresetTypeResponseType;
  superuserUpdateUser: SuperuserUserResponseType;
  /**
   * Obtain JSON web token for given user.
   *
   *     Allow to perform login with different fields, The fields are defined
   *     on settings.
   *
   *     Not verified users can log in by default. This can be changes on
   *     settings.
   *
   *     If user is archived, make it unarchived and return
   *     `unarchiving=True` on OutputBase.
   *
   */
  tokenAuth: TokenAuthResponseType;
  touchWorkspace: WorkspaceResponseType;
  unfollowUser: ResponseType;
  updateAccount: AccountResponseType;
  updateApiKey: ApiKeyResponseType;
  updateDevice: DeviceResponseType;
  updateEvent: PodiumEventResponseType;
  updateEventDevice: EventDeviceResponseType;
  updateOauthApplication: OAuthApplicationResponseType;
  updatePreset: PresetResponseType;
  updateUser: UserResponseType;
  updateUserMe: UserResponseType;
  updateUserPreference: UserPreferenceResponseType;
  updateVenue: VenueResponseType;
  updateVenueSectorScheme: SectorSchemeResponseType;
  validateEventId: OkResponseType;
  validateEventdeviceId: OkResponseType;
  validateEventdeviceOwnership: OkResponseType;
  /**
   * Verify user account.
   *
   *     Receive the token that was sent by email. If the token is valid,
   *     make the user verified by making the `user.status.verified` field
   *     true.
   *
   */
  verifyAccount: MutationNormalOutput;
  /**
   * ### Checks if a token is not expired and correct.
   *
   *     *Note that this is not for refresh tokens.*
   *
   */
  verifyToken: VerifyTokenType;
};


export type AllMutationsWithSuperuserAcceptPoliciesArgs = {
  acceptances: Array<PolicyAcceptanceInput>;
};


export type AllMutationsWithSuperuserAddEventDeviceToWorkspacesArgs = {
  eventDeviceId: Scalars['UUID']['input'];
  workspaceIds: Array<Scalars['UUID']['input']>;
};


export type AllMutationsWithSuperuserAddWorkspaceEventDeviceArgs = {
  eventDeviceId: Scalars['UUID']['input'];
  workspaceId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserAnalyzeEventDeviceArgs = {
  eventDeviceId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserApplyCollectionToWorkspaceArgs = {
  presetId: Scalars['UUID']['input'];
  workspaceId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserApplyImportChannelSelectionsArgs = {
  adjustments: Scalars['JSON']['input'];
  excludedChannels?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserApplyImportTrackArgs = {
  id: Scalars['UUID']['input'];
  track: Scalars['JSON']['input'];
};


export type AllMutationsWithSuperuserArchiveAccountArgs = {
  password: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserAuthorizeOauthApplicationArgs = {
  allow: Scalars['Boolean']['input'];
  request: Scalars['String']['input'];
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type AllMutationsWithSuperuserCancelImportSessionArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserCreateDeviceArgs = {
  isPrivate: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
};


export type AllMutationsWithSuperuserCreateEventArgs = {
  endAt: Scalars['DateTime']['input'];
  isPrivate: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  startAt: Scalars['DateTime']['input'];
  venueId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllMutationsWithSuperuserCreateEventDeviceArgs = {
  competitorNumber?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  eventId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserCreateImportSessionArgs = {
  filename: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
};


export type AllMutationsWithSuperuserCreatePresetArgs = {
  isPrivate?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  presetData: Scalars['String']['input'];
  presetTypeId?: InputMaybe<Scalars['UUID']['input']>;
  presetTypeKey?: InputMaybe<Scalars['String']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  previewImageData?: InputMaybe<Scalars['String']['input']>;
  previewImageName?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserCreateTelemetryExportArgs = {
  eventDeviceId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserCreateTelemetryImportArgs = {
  deviceId: Scalars['UUID']['input'];
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  fileName: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserCreateUserArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isAdmin: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserCreateVenueArgs = {
  configuration?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  finish?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  location: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sectorPoints?: InputMaybe<Scalars['String']['input']>;
  startFinish?: InputMaybe<Scalars['String']['input']>;
  trackMap?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserCreateVenueSectorSchemeArgs = {
  copyFrom?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  venueId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserCreateWorkspaceArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  venueId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllMutationsWithSuperuserDeleteAccountArgs = {
  password: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserDeleteApiKeyArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserDeleteDeviceArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserDeleteEventArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserDeleteEventDeviceArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserDeleteOauthApplicationArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserDeletePresetArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserDeleteTelemetryExportArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserDeleteTelemetryImportArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserDeleteVenueArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserDeleteVenueSectorSchemeArgs = {
  key: Scalars['String']['input'];
  venueId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserDeleteWorkspaceArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserDeselectWorkspaceLapArgs = {
  lapId: Scalars['UUID']['input'];
  workspaceId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserFinalizeImportArgs = {
  deviceId: Scalars['UUID']['input'];
  eventEnd?: InputMaybe<Scalars['DateTime']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  eventStart?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserFollowUserArgs = {
  slug: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserGenerateApiKeyArgs = {
  name: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserGenerateSourceFileDownloadLinkArgs = {
  telemetryImportId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserGenerateTelemetryExportFileDownloadLinkArgs = {
  telemetryExportId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserLabelWorkspaceEventDeviceArgs = {
  label: Scalars['String']['input'];
  workspaceEventDeviceId: Scalars['UUID']['input'];
  workspaceId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserPasswordChangeArgs = {
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserPasswordResetArgs = {
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserPasswordSetArgs = {
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserRatePresetArgs = {
  presetId: Scalars['UUID']['input'];
  rating: Scalars['Int']['input'];
  report?: InputMaybe<Scalars['Int']['input']>;
};


export type AllMutationsWithSuperuserRecordHelpProgressArgs = {
  event: HelpEvent;
  key: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserRefreshTokenArgs = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  revokeRefreshToken: Scalars['Boolean']['input'];
};


export type AllMutationsWithSuperuserRegenerateVenueSectorSchemeArgs = {
  key: Scalars['String']['input'];
  venueId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserRegisterArgs = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserRegisterOauthApplicationArgs = {
  allowedOrigins?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedScopes: Array<Scalars['String']['input']>;
  clientType?: OAuthClientType;
  name: Scalars['String']['input'];
  redirectUris: Array<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserRegisterWithAccountArgs = {
  acceptedPolicies?: InputMaybe<Array<PolicyAcceptanceInput>>;
  accountName: Scalars['String']['input'];
  ageConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserRemoveWorkspaceEventDeviceArgs = {
  workspaceEventDeviceId: Scalars['UUID']['input'];
  workspaceId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserRenameWorkspaceArgs = {
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserReorderWorkspaceEventDevicesArgs = {
  workspaceEventDeviceIds: Array<Scalars['UUID']['input']>;
  workspaceId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserReportPresetArgs = {
  presetId: Scalars['UUID']['input'];
  report: Scalars['Int']['input'];
};


export type AllMutationsWithSuperuserResendActivationEmailArgs = {
  email: Scalars['String']['input'];
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserResetUserPreferenceArgs = {
  key: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserRevokeApiKeyArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserRevokeOauthApplicationAccessArgs = {
  applicationId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserRevokeTokenArgs = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserSelectWorkspaceLapArgs = {
  lapId: Scalars['UUID']['input'];
  workspaceId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSendPasswordResetEmailArgs = {
  email: Scalars['String']['input'];
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserSetMarketingConsentArgs = {
  granted: Scalars['Boolean']['input'];
};


export type AllMutationsWithSuperuserSetPrimarySectorSchemeArgs = {
  key: Scalars['String']['input'];
  venueId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSetWorkspaceEventDeviceLiveArgs = {
  enabled: Scalars['Boolean']['input'];
  eventDeviceId: Scalars['UUID']['input'];
  workspaceId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSetWorkspaceScreensArgs = {
  screens: Scalars['JSON']['input'];
  workspaceId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserStartImportConversionArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSubscriptionManagmentSessionUrlArgs = {
  isMonthly?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionPlanId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserClearPresetReportsArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserCreateAccountArgs = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserSuperuserCreatePolicyDocumentArgs = {
  body: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  effectiveDate: Scalars['Date']['input'];
};


export type AllMutationsWithSuperuserSuperuserCreatePresetArgs = {
  isPrivate?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  presetData: Scalars['String']['input'];
  presetTypeId: Scalars['UUID']['input'];
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
};


export type AllMutationsWithSuperuserSuperuserCreatePresetTypeArgs = {
  description: Scalars['String']['input'];
  prettyName: Scalars['String']['input'];
  typeKey: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserSuperuserCreateUserArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserSuperuserDeactivateUserArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserDeleteAccountArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserDeleteEventArgs = {
  force?: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserDeleteEventDeviceArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserDeletePolicyDocumentArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserDeletePresetArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserDeletePresetTypeArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserDeleteTelemetryExportArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserDeleteTelemetryImportArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserDeleteUserArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserDeleteUserFeatureFlagArgs = {
  flagKey: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserDowngradeUserArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserElevateUserArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserExportPublicVenueLeaderboardsArgs = {
  force?: Scalars['Boolean']['input'];
  skipImages?: Scalars['Boolean']['input'];
};


export type AllMutationsWithSuperuserSuperuserGenerateTelemetryExportDownloadLinkArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserGenerateTelemetryImportDownloadLinkArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserGetEventDeviceDataSegmentDownloadLinkArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserGetLegacyArchiveDownloadLinkArgs = {
  eventDeviceId: Scalars['UUID']['input'];
  path: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserSuperuserPublishPolicyDocumentArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserReactivateUserArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserRegenerateVenueGeometryArgs = {
  force?: Scalars['Boolean']['input'];
  limit?: Scalars['Int']['input'];
};


export type AllMutationsWithSuperuserSuperuserResetHelpProgressArgs = {
  keyPrefix?: InputMaybe<Scalars['String']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserRetryTelemetryImportArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserSetAccountAttributesArgs = {
  accountId: Scalars['UUID']['input'];
  attributes: Array<AccountAttributeInput>;
};


export type AllMutationsWithSuperuserSuperuserSetUserFeatureFlagArgs = {
  enabled: Scalars['Boolean']['input'];
  flagKey: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserUnpublishPolicyDocumentArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserUpdateAccountArgs = {
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserSuperuserUpdateAccountSubscriptionArgs = {
  accountId: Scalars['UUID']['input'];
  subscriptionPlanId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserUpdateEventArgs = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['UUID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeRangeAutoAdjustable?: InputMaybe<Scalars['Boolean']['input']>;
  venueId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllMutationsWithSuperuserSuperuserUpdateLegalEntitySettingsArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  euRepresentative?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserSuperuserUpdatePolicyDocumentArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserSuperuserUpdatePresetArgs = {
  id: Scalars['UUID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  presetData?: InputMaybe<Scalars['String']['input']>;
  presetTypeId?: InputMaybe<Scalars['UUID']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
};


export type AllMutationsWithSuperuserSuperuserUpdatePresetTypeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  prettyName?: InputMaybe<Scalars['String']['input']>;
  typeKey?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserSuperuserUpdateUserArgs = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<Scalars['String']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['Upload']['input']>;
};


export type AllMutationsWithSuperuserTokenAuthArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserTouchWorkspaceArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserUnfollowUserArgs = {
  slug: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserUpdateAccountArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserUpdateApiKeyArgs = {
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type AllMutationsWithSuperuserUpdateDeviceArgs = {
  id: Scalars['UUID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
};


export type AllMutationsWithSuperuserUpdateEventArgs = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['UUID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  venueId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllMutationsWithSuperuserUpdateEventDeviceArgs = {
  competitorNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserUpdateOauthApplicationArgs = {
  allowedOrigins?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedScopes?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  redirectUris?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type AllMutationsWithSuperuserUpdatePresetArgs = {
  id: Scalars['UUID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  presetData?: InputMaybe<Scalars['String']['input']>;
  presetTypeId?: InputMaybe<Scalars['UUID']['input']>;
  presetTypeKey?: InputMaybe<Scalars['String']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  previewImageData?: InputMaybe<Scalars['String']['input']>;
  previewImageName?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserUpdateUserArgs = {
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<Scalars['String']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['Upload']['input']>;
};


export type AllMutationsWithSuperuserUpdateUserMeArgs = {
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<Scalars['String']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['Upload']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserUpdateUserPreferenceArgs = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserUpdateVenueArgs = {
  configuration?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  finish?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  length?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sectorPoints?: InputMaybe<Scalars['String']['input']>;
  startFinish?: InputMaybe<Scalars['String']['input']>;
  trackMap?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsWithSuperuserUpdateVenueSectorSchemeArgs = {
  key: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  points: Array<SectorPointInput>;
  venueId: Scalars['UUID']['input'];
};


export type AllMutationsWithSuperuserValidateEventIdArgs = {
  eventId: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserValidateEventdeviceIdArgs = {
  eventdeviceId: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserValidateEventdeviceOwnershipArgs = {
  eventdeviceId: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserVerifyAccountArgs = {
  token: Scalars['String']['input'];
};


export type AllMutationsWithSuperuserVerifyTokenArgs = {
  token: Scalars['String']['input'];
};

export type AllQueriesWithSuperuser = {
  __typename?: 'AllQueriesWithSuperuser';
  accountSubscription?: Maybe<AccountSubscriptionType>;
  accounts: Array<AccountType>;
  accountsByName: Array<AccountType>;
  activeEventDevices: Array<EventDeviceType>;
  alertMessages: Array<AlertMessageType>;
  apiKeyById: ApiKeyType;
  apiKeyScopes: Array<ApiKeyScopeType>;
  apiKeys: Array<ApiKeyType>;
  authorizedOauthApplications: Array<AuthorizedOAuthApplicationType>;
  consentStatus: ConsentStatusType;
  currentPolicies: Array<PolicyDocumentType>;
  deviceById: DeviceType;
  eventById: PodiumEventType;
  eventDeviceById: EventDeviceType;
  eventDeviceLapSummaries: Array<EventDeviceLapSummaryType>;
  eventDeviceTelemetrySummary?: Maybe<EventDeviceTelemetrySummaryType>;
  eventDevices: Array<EventDeviceType>;
  events: PodiumEventTypePaginatedResponseType;
  features: Array<FeatureType>;
  feed: PodiumEventTypePaginatedResponseType;
  followers: Array<FriendshipType>;
  following: Array<FriendshipType>;
  importFormats: Array<ImportFormatType>;
  importSession: ImportSessionType;
  importSessions: Array<ImportSessionType>;
  isFollowing: Scalars['Boolean']['output'];
  lapById: LapType;
  laps: Array<LapType>;
  legalEntitySettings: LegalEntitySettingsType;
  liveEventIds: Array<Scalars['UUID']['output']>;
  me: UserType;
  myAccount: AccountType;
  myDevices: Array<DeviceType>;
  myEvents: PodiumEventTypePaginatedResponseType;
  myPreferences: Array<UserPreferenceType>;
  myPresets: Array<PresetType>;
  myVenues: VenueTypePaginatedResponseType;
  myWorkspaces: Array<WorkspaceType>;
  oauthApplicationById: OAuthApplicationType;
  oauthApplications: Array<OAuthApplicationType>;
  oauthAuthorizationRequest: OAuthAuthorizationRequestResponseType;
  policyDocument?: Maybe<PolicyDocumentType>;
  preferenceCategories: Array<UserPreferenceCategoryType>;
  presetById: PresetType;
  presetTypeById: PresetTypeType;
  presetTypes: Array<PresetTypeType>;
  presets: Array<PresetType>;
  presetsPaginated: PresetTypePaginatedResponseType;
  /** Returns the current user if he is not anonymous. */
  publicUser?: Maybe<UserType>;
  publicUserEvents: PodiumEventTypePaginatedResponseType;
  publicUserFollowers: PublicUserTypePaginatedResponseType;
  publicUserFollowing: PublicUserTypePaginatedResponseType;
  publicUserVenues: VenueTypePaginatedResponseType;
  subscriptionPlans: Array<SubscriptionPlanType>;
  superuserAccountAttributes: Array<AccountAttributeStateType>;
  superuserAccountById: AccountType;
  superuserAccounts: Array<AccountType>;
  superuserActiveEventDevices: Array<EventDeviceType>;
  superuserDeviceById: DeviceType;
  superuserDevices: DeviceTypePaginatedResponseType;
  superuserEventById: PodiumEventType;
  superuserEventDeviceById: PodiumEventDeviceType;
  superuserEventDeviceDataSegment: EventDeviceDataSegmentType;
  superuserEventDeviceDataSegments: Array<EventDeviceDataSegmentType>;
  superuserEventDeviceLegacyStatus: SuperuserEventDeviceLegacyStatusType;
  superuserEventDeviceRedisTimeline: SuperuserRedisTimelineType;
  superuserEventDeviceTelemetrySummary?: Maybe<EventDeviceTelemetrySummaryType>;
  superuserEventDevices: Array<PodiumEventDeviceType>;
  superuserEvents: PodiumEventTypePaginatedResponseType;
  superuserFeatureFlagAssignments: Array<FeatureFlagAssignmentType>;
  superuserFeatureFlags: Array<FeatureFlagType>;
  superuserHelpProgress: Array<HelpProgressType>;
  superuserHelpProgressStats: Array<HelpProgressStatType>;
  superuserLap: LapType;
  superuserLaps: Array<LapType>;
  superuserLegacyArchives: Array<SuperuserLegacyArchiveType>;
  superuserPolicyDocument?: Maybe<PolicyDocumentType>;
  superuserPolicyDocuments: Array<PolicyDocumentType>;
  superuserPresetById: PresetType;
  superuserPresetTypeById: PresetTypeType;
  superuserPresetTypes: Array<PresetTypeType>;
  superuserPresets: PresetTypePaginatedResponseType;
  superuserPublicVenueLeaderboardExportState: PublicVenueLeaderboardExportJobStateType;
  superuserRedisHealth: SuperuserRedisHealthType;
  superuserSummary: SuperuserSummaryType;
  superuserTelemetryExportById: TelemetryExportType;
  superuserTelemetryExports: TelemetryExportTypePaginatedResponseType;
  superuserTelemetryImportById: TelemetryImportType;
  superuserTelemetryImports: TelemetryImportTypePaginatedResponseType;
  superuserUserById: BaseUserType;
  superuserUserFeatureFlags: Array<FeatureFlagAssignmentType>;
  superuserUsers: BaseUserTypePaginatedResponseType;
  superuserUsersByAccountId: Array<BaseUserType>;
  superuserVenueGeometryStatus: VenueGeometryStatusType;
  telemetryExports: Array<TelemetryExportType>;
  telemetryImportById: TelemetryImportType;
  telemetryImports: TelemetryImportTypePaginatedResponseType;
  user: BaseUserType;
  userById: BaseUserType;
  userBySlug: PublicUserType;
  userMe: BaseUserType;
  users: Array<BaseUserType>;
  venueById: VenueType;
  venues: VenueTypePaginatedResponseType;
  venuesByName: Array<VenueType>;
  videoStreamSessions: Array<VideoStreamSessionType>;
  videoViewerAccess: VideoViewerAccessType;
  viewerAccountAttributes: Array<Scalars['String']['output']>;
  viewerCapabilities: Array<Scalars['String']['output']>;
  viewerFeatures: Array<Scalars['String']['output']>;
  viewerHelpProgress: Array<HelpProgressType>;
  workspace: WorkspaceType;
  workspaceQuota: WorkspaceQuotaType;
  workspacesForEventDevice: Array<WorkspaceAlternativeType>;
};


export type AllQueriesWithSuperuserAccountsByNameArgs = {
  nameSearch: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserAlertMessagesArgs = {
  eventDeviceId: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserApiKeyByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserDeviceByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserEventByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserEventDeviceByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserEventDeviceLapSummariesArgs = {
  eventId: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserEventDeviceTelemetrySummaryArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  eventDeviceId: Scalars['UUID']['input'];
  maxPoints?: Scalars['Int']['input'];
};


export type AllQueriesWithSuperuserEventDevicesArgs = {
  eventId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllQueriesWithSuperuserEventsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  timeFilter?: InputMaybe<EventTimeFilter>;
  venueId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllQueriesWithSuperuserFeedArgs = {
  location?: InputMaybe<LocationInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type AllQueriesWithSuperuserImportSessionArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserImportSessionsArgs = {
  limit?: Scalars['Int']['input'];
};


export type AllQueriesWithSuperuserIsFollowingArgs = {
  slug: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserLapByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserLapsArgs = {
  eventDeviceId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllQueriesWithSuperuserMyEventsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  timeFilter?: InputMaybe<EventTimeFilter>;
  venueId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllQueriesWithSuperuserMyPreferencesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
};


export type AllQueriesWithSuperuserMyPresetsArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  presetTypeKey?: InputMaybe<Scalars['String']['input']>;
  publicOnly?: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AllQueriesWithSuperuserMyVenuesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type AllQueriesWithSuperuserOauthApplicationByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserOauthAuthorizationRequestArgs = {
  request: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserPolicyDocumentArgs = {
  documentType: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


export type AllQueriesWithSuperuserPresetByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserPresetTypeByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserPresetsArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  mine?: Scalars['Boolean']['input'];
  orderBy?: PresetOrderBy;
  presetTypeKey?: InputMaybe<Scalars['String']['input']>;
  publicOnly?: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AllQueriesWithSuperuserPresetsPaginatedArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  mine?: Scalars['Boolean']['input'];
  orderBy?: PresetOrderBy;
  page?: InputMaybe<Scalars['Int']['input']>;
  presetTypeKey?: InputMaybe<Scalars['String']['input']>;
  publicOnly?: Scalars['Boolean']['input'];
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AllQueriesWithSuperuserPublicUserEventsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserPublicUserFollowersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserPublicUserFollowingArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserPublicUserVenuesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserSuperuserAccountAttributesArgs = {
  accountId: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserAccountByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserDeviceByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserDevicesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type AllQueriesWithSuperuserSuperuserEventByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserEventDeviceByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserEventDeviceDataSegmentArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserEventDeviceDataSegmentsArgs = {
  eventDeviceId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllQueriesWithSuperuserSuperuserEventDeviceLegacyStatusArgs = {
  eventDeviceId: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserEventDeviceRedisTimelineArgs = {
  endTime: Scalars['DateTime']['input'];
  eventDeviceId: Scalars['UUID']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type AllQueriesWithSuperuserSuperuserEventDeviceTelemetrySummaryArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  eventDeviceId: Scalars['UUID']['input'];
  maxPoints?: Scalars['Int']['input'];
};


export type AllQueriesWithSuperuserSuperuserEventDevicesArgs = {
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllQueriesWithSuperuserSuperuserEventsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type AllQueriesWithSuperuserSuperuserFeatureFlagAssignmentsArgs = {
  flagKey: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserSuperuserHelpProgressArgs = {
  userId: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserHelpProgressStatsArgs = {
  keyPrefix?: InputMaybe<Scalars['String']['input']>;
};


export type AllQueriesWithSuperuserSuperuserLapArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserLapsArgs = {
  eventDeviceId: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserLegacyArchivesArgs = {
  eventDeviceId: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserPolicyDocumentArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserPolicyDocumentsArgs = {
  documentType?: InputMaybe<Scalars['String']['input']>;
};


export type AllQueriesWithSuperuserSuperuserPresetByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserPresetTypeByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserPresetsArgs = {
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  reported?: InputMaybe<Scalars['Boolean']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type AllQueriesWithSuperuserSuperuserTelemetryExportByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserTelemetryExportsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AllQueriesWithSuperuserSuperuserTelemetryImportByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserTelemetryImportsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AllQueriesWithSuperuserSuperuserUserByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserUserFeatureFlagsArgs = {
  userId: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserUsersArgs = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AllQueriesWithSuperuserSuperuserUsersByAccountIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserTelemetryExportsArgs = {
  eventDeviceId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllQueriesWithSuperuserTelemetryImportByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserTelemetryImportsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type AllQueriesWithSuperuserUserArgs = {
  email: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserUserByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserUserBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserVenueByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserVenuesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Array<LocationInputType>>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type AllQueriesWithSuperuserVenuesByNameArgs = {
  name: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserVideoStreamSessionsArgs = {
  eventDeviceId: Scalars['UUID']['input'];
  overlapsEnd?: InputMaybe<Scalars['DateTime']['input']>;
  overlapsStart?: InputMaybe<Scalars['DateTime']['input']>;
};


export type AllQueriesWithSuperuserVideoViewerAccessArgs = {
  eventDeviceId: Scalars['UUID']['input'];
  preferHls?: Scalars['Boolean']['input'];
};


export type AllQueriesWithSuperuserWorkspaceArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserWorkspacesForEventDeviceArgs = {
  eventDeviceId: Scalars['UUID']['input'];
};

export type AnalyzeEventDeviceResponseType = {
  __typename?: 'AnalyzeEventDeviceResponseType';
  added: Scalars['Boolean']['output'];
  alternatives: Array<WorkspaceAlternativeType>;
  created: Scalars['Boolean']['output'];
  errors: Array<ErrorType>;
  followedLive: Scalars['Boolean']['output'];
  ok: Scalars['Boolean']['output'];
  workspace?: Maybe<WorkspaceType>;
};

export type ApiKeyResponseType = {
  __typename?: 'ApiKeyResponseType';
  apiKey?: Maybe<ApiKeyType>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type ApiKeyScopeType = {
  __typename?: 'ApiKeyScopeType';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ApiKeyType = {
  __typename?: 'ApiKeyType';
  account: AccountType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: BaseUserType;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  keyPrefix: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  scopes: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ArchiveHeldType = {
  __typename?: 'ArchiveHeldType';
  message: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  since: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ArchiverPassType = {
  __typename?: 'ArchiverPassType';
  backlogged?: Maybe<Scalars['Int']['output']>;
  completedAt: Scalars['DateTime']['output'];
  devices?: Maybe<Scalars['Int']['output']>;
  elapsedMs?: Maybe<Scalars['Float']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  finished?: Maybe<Scalars['Int']['output']>;
  flushed?: Maybe<Scalars['Int']['output']>;
  heldBack?: Maybe<Scalars['Int']['output']>;
  noMetadata?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AuthorizeOAuthApplicationResponseType = {
  __typename?: 'AuthorizeOAuthApplicationResponseType';
  error?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  redirectUri?: Maybe<Scalars['String']['output']>;
};

export type AuthorizedOAuthApplicationType = {
  __typename?: 'AuthorizedOAuthApplicationType';
  application: OAuthApplicationPublicType;
  authorizedAt?: Maybe<Scalars['DateTime']['output']>;
  scopes: Array<Scalars['String']['output']>;
};

export type BaseUserType = {
  __typename?: 'BaseUserType';
  account: AccountType;
  avatarLarge?: Maybe<Scalars['String']['output']>;
  avatarMedium?: Maybe<Scalars['String']['output']>;
  avatarSmall?: Maybe<Scalars['String']['output']>;
  bio: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  devices: Array<DeviceType>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  links: Array<Scalars['String']['output']>;
  profilePictureLarge?: Maybe<Scalars['String']['output']>;
  profilePictureMedium?: Maybe<Scalars['String']['output']>;
  profilePictureSmall?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type BaseUserTypePaginatedResponseType = {
  __typename?: 'BaseUserTypePaginatedResponseType';
  items: Array<BaseUserType>;
  metadata: PaginationMetadata;
};

export type CaptchaType = {
  __typename?: 'CaptchaType';
  image: DjangoImageType;
  /** returns the b64 encoded image. */
  pilImage: Scalars['image']['output'];
  uuid: Scalars['UUID']['output'];
};

export type ConsentStatusType = {
  __typename?: 'ConsentStatusType';
  pendingPolicies: Array<PolicyDocumentType>;
  requiresReconsent: Scalars['Boolean']['output'];
};

export type CreateImportSessionResponseType = {
  __typename?: 'CreateImportSessionResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  session?: Maybe<ImportSessionType>;
  uploadForm?: Maybe<PresignedPostType>;
  /** @deprecated Use uploadForm: a PUT URL cannot bound the upload size. */
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type CreateTelemetryExportResponseType = {
  __typename?: 'CreateTelemetryExportResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  telemetryExport?: Maybe<TelemetryExportType>;
};

export type CreateTelemetryImportResponseType = {
  __typename?: 'CreateTelemetryImportResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  /** @deprecated Use uploadForm: a PUT URL cannot bound the upload size. */
  presignedUrl?: Maybe<Scalars['String']['output']>;
  telemetryImport?: Maybe<TelemetryImportType>;
  uploadForm?: Maybe<PresignedPostType>;
};

export type DeviceResponseType = {
  __typename?: 'DeviceResponseType';
  device?: Maybe<DeviceType>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type DeviceType = {
  __typename?: 'DeviceType';
  account: AccountType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: BaseUserType;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isOwner: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  previewImageLarge?: Maybe<Scalars['String']['output']>;
  previewImageMedium?: Maybe<Scalars['String']['output']>;
  previewImageSmall?: Maybe<Scalars['String']['output']>;
  streamingKey: Scalars['String']['output'];
};

export type DeviceTypePaginatedResponseType = {
  __typename?: 'DeviceTypePaginatedResponseType';
  items: Array<DeviceType>;
  metadata: PaginationMetadata;
};

export type DjangoImageType = {
  __typename?: 'DjangoImageType';
  height: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type DjangoModelType = {
  __typename?: 'DjangoModelType';
  pk: Scalars['ID']['output'];
};

export type ErrorType = {
  __typename?: 'ErrorType';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type EventDeviceDataSegmentType = {
  __typename?: 'EventDeviceDataSegmentType';
  end: Scalars['DateTime']['output'];
  eventDevice: EventDeviceType;
  filePath: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  start: Scalars['DateTime']['output'];
};

export type EventDeviceLapSummaryType = {
  __typename?: 'EventDeviceLapSummaryType';
  bestLapTime?: Maybe<Scalars['Float']['output']>;
  eventDeviceId: Scalars['UUID']['output'];
  lapCount: Scalars['Int']['output'];
  lastLapTime?: Maybe<Scalars['Float']['output']>;
};

export type EventDeviceResponseType = {
  __typename?: 'EventDeviceResponseType';
  errors: Array<ErrorType>;
  eventDevice?: Maybe<EventDeviceType>;
  ok: Scalars['Boolean']['output'];
};

export type EventDeviceTelemetrySummaryType = {
  __typename?: 'EventDeviceTelemetrySummaryType';
  bucketSeconds: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  summaryData: Scalars['String']['output'];
  verifiedThrough?: Maybe<Scalars['DateTime']['output']>;
};

export type EventDeviceType = {
  __typename?: 'EventDeviceType';
  competitorNumber: Scalars['String']['output'];
  device: DeviceType;
  deviceSn: Scalars['String']['output'];
  endTime: Scalars['DateTime']['output'];
  event: EventType;
  id: Scalars['UUID']['output'];
  liveTransport?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['JSON']['output'];
  processorInstanceHost: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceVer: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
};

export enum EventTimeFilter {
  All = 'ALL',
  InProgress = 'IN_PROGRESS',
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export type EventType = {
  __typename?: 'EventType';
  account: AccountType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: BaseUserType;
  endAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isLive: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  startAt: Scalars['DateTime']['output'];
  timeRangeAutoAdjustable: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FeatureFlagAssignmentResponseType = {
  __typename?: 'FeatureFlagAssignmentResponseType';
  assignment?: Maybe<FeatureFlagAssignmentType>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type FeatureFlagAssignmentType = {
  __typename?: 'FeatureFlagAssignmentType';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: BaseUserType;
};

export type FeatureFlagType = {
  __typename?: 'FeatureFlagType';
  defaultEnabled: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type FeatureType = {
  __typename?: 'FeatureType';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type FriendshipType = {
  __typename?: 'FriendshipType';
  createdAt: Scalars['DateTime']['output'];
  followed: PublicUserType;
  follower: PublicUserType;
};

export type GenerateApiKeyResponseType = {
  __typename?: 'GenerateApiKeyResponseType';
  apiKey?: Maybe<ApiKeyType>;
  errors: Array<ErrorType>;
  key?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GenerateSourceFileDownloadLinkResponseType = {
  __typename?: 'GenerateSourceFileDownloadLinkResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  presignedUrl?: Maybe<Scalars['String']['output']>;
};

export type GenerateTelemetryExportDownloadLinkResponseType = {
  __typename?: 'GenerateTelemetryExportDownloadLinkResponseType';
  downloadLink?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type GenerateTelemetryExportFileDownloadLinkResponseType = {
  __typename?: 'GenerateTelemetryExportFileDownloadLinkResponseType';
  downloadLink?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type GenerateTelemetryImportDownloadLinkResponseType = {
  __typename?: 'GenerateTelemetryImportDownloadLinkResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  presignedUrl?: Maybe<Scalars['String']['output']>;
};

export enum HelpEvent {
  Completed = 'COMPLETED',
  Dismissed = 'DISMISSED',
  Played = 'PLAYED',
  Seen = 'SEEN'
}

export type HelpProgressResponseType = {
  __typename?: 'HelpProgressResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  progress?: Maybe<HelpProgressType>;
};

export type HelpProgressStatType = {
  __typename?: 'HelpProgressStatType';
  completed: Scalars['Int']['output'];
  dismissed: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  played: Scalars['Int']['output'];
  seen: Scalars['Int']['output'];
};

export type HelpProgressType = {
  __typename?: 'HelpProgressType';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  key: Scalars['String']['output'];
  playedAt?: Maybe<Scalars['DateTime']['output']>;
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ImportFormatType = {
  __typename?: 'ImportFormatType';
  description: Scalars['String']['output'];
  extensions: Array<Scalars['String']['output']>;
  key: Scalars['String']['output'];
};

export type ImportSessionResponseType = {
  __typename?: 'ImportSessionResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  session?: Maybe<ImportSessionType>;
};

export type ImportSessionType = {
  __typename?: 'ImportSessionType';
  createdAt: Scalars['DateTime']['output'];
  describeResult?: Maybe<Scalars['JSON']['output']>;
  deviceId?: Maybe<Scalars['UUID']['output']>;
  errorMessage: Scalars['String']['output'];
  eventId?: Maybe<Scalars['UUID']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lapPreview?: Maybe<Scalars['JSON']['output']>;
  normalizerResult?: Maybe<Scalars['JSON']['output']>;
  operations: Scalars['JSON']['output'];
  progressPct: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  resultEventDeviceId?: Maybe<Scalars['UUID']['output']>;
  resultLogfileKey: Scalars['String']['output'];
  sourceBytes: Scalars['Int']['output'];
  sourceFilename: Scalars['String']['output'];
  status: Scalars['String']['output'];
  suggestedEventStart?: Maybe<Scalars['DateTime']['output']>;
  trackMatchResult?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LapType = {
  __typename?: 'LapType';
  aggregates: Scalars['JSON']['output'];
  endTime: Scalars['DateTime']['output'];
  eventDevice: EventDeviceType;
  id: Scalars['UUID']['output'];
  lapData: Scalars['String']['output'];
  lapNumber?: Maybe<Scalars['Int']['output']>;
  lapTime?: Maybe<Scalars['Float']['output']>;
  startTime: Scalars['DateTime']['output'];
  venue?: Maybe<VenueType>;
};


export type LapTypeLapDataArgs = {
  channels?: Array<Scalars['String']['input']>;
};

export type LegalEntitySettingsType = {
  __typename?: 'LegalEntitySettingsType';
  address: Scalars['String']['output'];
  contactEmail: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  euRepresentative: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LocationInputType = {
  lat: Scalars['Float']['input'];
  long: Scalars['Float']['input'];
};

export type MutationNormalOutput = {
  __typename?: 'MutationNormalOutput';
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  success: Scalars['Boolean']['output'];
};

export type OAuthApplicationPublicType = {
  __typename?: 'OAuthApplicationPublicType';
  clientId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isSelfRegistered: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  skipAuthorization: Scalars['Boolean']['output'];
};

export type OAuthApplicationResponseType = {
  __typename?: 'OAuthApplicationResponseType';
  application?: Maybe<OAuthApplicationType>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type OAuthApplicationType = {
  __typename?: 'OAuthApplicationType';
  account?: Maybe<AccountType>;
  allowedOrigins: Array<Scalars['String']['output']>;
  allowedScopes: Array<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  clientType: OAuthClientType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<BaseUserType>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isSelfRegistered: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  redirectUris: Array<Scalars['String']['output']>;
  skipAuthorization: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OAuthAuthorizationRequestResponseType = {
  __typename?: 'OAuthAuthorizationRequestResponseType';
  authorizationRequest?: Maybe<OAuthAuthorizationRequestType>;
  error?: Maybe<Scalars['String']['output']>;
  errorRedirectUri?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type OAuthAuthorizationRequestType = {
  __typename?: 'OAuthAuthorizationRequestType';
  application: OAuthApplicationPublicType;
  redirectUri: Scalars['String']['output'];
  scopes: Array<OAuthScopeType>;
  state?: Maybe<Scalars['String']['output']>;
};

export enum OAuthClientType {
  Confidential = 'CONFIDENTIAL',
  Public = 'PUBLIC'
}

export type OAuthScopeType = {
  __typename?: 'OAuthScopeType';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/**
 *
 *     encapsulates token data, and refresh token data if `JWT_LONG_RUNNING_REFRESH_TOKEN` is on.
 *     with an output interface.
 *
 */
export type ObtainJsonWebTokenType = OutputInterface & {
  __typename?: 'ObtainJSONWebTokenType';
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  refreshToken?: Maybe<RefreshTokenType>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<TokenType>;
  user?: Maybe<UserType>;
};

export type OkResponseType = {
  __typename?: 'OkResponseType';
  ok: Scalars['Boolean']['output'];
};

export type OutputInterface = {
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PaginationMetadata = {
  __typename?: 'PaginationMetadata';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PodiumEventDeviceType = {
  __typename?: 'PodiumEventDeviceType';
  competitorNumber: Scalars['String']['output'];
  device: DeviceType;
  deviceSn: Scalars['String']['output'];
  endTime: Scalars['DateTime']['output'];
  event: PodiumEventType;
  id: Scalars['UUID']['output'];
  liveTransport?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['JSON']['output'];
  processorInstanceHost: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceVer: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type PodiumEventResponseType = {
  __typename?: 'PodiumEventResponseType';
  errors: Array<ErrorType>;
  event?: Maybe<PodiumEventType>;
  ok: Scalars['Boolean']['output'];
};

export type PodiumEventType = {
  __typename?: 'PodiumEventType';
  account: AccountType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: BaseUserType;
  endAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isLive: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  startAt: Scalars['DateTime']['output'];
  timeRangeAutoAdjustable: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  venue?: Maybe<VenueType>;
  venueClearable: Scalars['Boolean']['output'];
  venueLocked: Scalars['Boolean']['output'];
  venueSource: VenueSourceType;
};

export type PodiumEventTypePaginatedResponseType = {
  __typename?: 'PodiumEventTypePaginatedResponseType';
  items: Array<PodiumEventType>;
  metadata: PaginationMetadata;
};

export type PolicyAcceptanceInput = {
  documentType: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type PolicyDocumentType = {
  __typename?: 'PolicyDocumentType';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  documentType: Scalars['String']['output'];
  effectiveDate: Scalars['Date']['output'];
  id: Scalars['UUID']['output'];
  isPublished: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export enum PresetOrderBy {
  CreatedAt = 'CREATED_AT',
  Rating = 'RATING'
}

export type PresetResponseType = {
  __typename?: 'PresetResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  preset?: Maybe<PresetType>;
};

export type PresetType = {
  __typename?: 'PresetType';
  account: AccountType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: BaseUserType;
  id: Scalars['UUID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  presetData?: Maybe<Scalars['JSON']['output']>;
  presetType: PresetTypeType;
  previewImageLarge?: Maybe<Scalars['String']['output']>;
  previewImageMedium?: Maybe<Scalars['String']['output']>;
  previewImageSmall?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  ratingCount: Scalars['Int']['output'];
  reportCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PresetTypePaginatedResponseType = {
  __typename?: 'PresetTypePaginatedResponseType';
  items: Array<PresetType>;
  metadata: PaginationMetadata;
};

export type PresetTypeType = {
  __typename?: 'PresetTypeType';
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  prettyName: Scalars['String']['output'];
  typeKey: Scalars['String']['output'];
};

export type PresignedPostFieldType = {
  __typename?: 'PresignedPostFieldType';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PresignedPostType = {
  __typename?: 'PresignedPostType';
  fields: Array<PresignedPostFieldType>;
  url: Scalars['String']['output'];
};

export type PublicUserType = {
  __typename?: 'PublicUserType';
  avatarLarge?: Maybe<Scalars['String']['output']>;
  avatarMedium?: Maybe<Scalars['String']['output']>;
  avatarSmall?: Maybe<Scalars['String']['output']>;
  bio: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  firstName: Scalars['String']['output'];
  followersCount: Scalars['Int']['output'];
  followingCount: Scalars['Int']['output'];
  followsViewer: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isFollowing: Scalars['Boolean']['output'];
  isViewer: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  links: Array<Scalars['String']['output']>;
  profilePictureLarge?: Maybe<Scalars['String']['output']>;
  profilePictureMedium?: Maybe<Scalars['String']['output']>;
  profilePictureSmall?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export type PublicUserTypePaginatedResponseType = {
  __typename?: 'PublicUserTypePaginatedResponseType';
  items: Array<PublicUserType>;
  metadata: PaginationMetadata;
};

export type PublicVenueLeaderboardExportJobStateType = {
  __typename?: 'PublicVenueLeaderboardExportJobStateType';
  lastCompletedAt?: Maybe<Scalars['String']['output']>;
  lastError: Scalars['String']['output'];
  lastStartedAt?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PublicVenueLeaderboardExportResultType = {
  __typename?: 'PublicVenueLeaderboardExportResultType';
  appMappingsExported: Scalars['Int']['output'];
  appTracksExported: Scalars['Int']['output'];
  artifacts: Array<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['String']['output']>;
  imagesPublished: Scalars['Int']['output'];
  leaderboardEntriesExported: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  venuesExported: Scalars['Int']['output'];
};

export type RedisAuditType = {
  __typename?: 'RedisAuditType';
  completedAt: Scalars['DateTime']['output'];
  families: Array<RedisKeyFamilyType>;
  /** Audited devices whose category is not null. */
  orphans: Array<RedisOrphanType>;
  totalKeys: Scalars['Int']['output'];
};

export type RedisEventDeviceType = {
  __typename?: 'RedisEventDeviceType';
  archiveCursorAt?: Maybe<Scalars['DateTime']['output']>;
  /** The frontier minus the archive cursor (or minus the oldest sample when nothing is archived yet). */
  archiveLagSeconds?: Maybe<Scalars['Float']['output']>;
  /** From the audit; null if it is missing or does not list it. */
  bytes?: Maybe<Scalars['Float']['output']>;
  eventDevice: EventDeviceType;
  frontierAt?: Maybe<Scalars['DateTime']['output']>;
  held?: Maybe<ArchiveHeldType>;
  live: Scalars['Boolean']['output'];
  /** The audit's completedAt. */
  memoryMeasuredAt?: Maybe<Scalars['DateTime']['output']>;
  newestSampleAt?: Maybe<Scalars['DateTime']['output']>;
  /** held | backlogged | backfilling | finishing | up_to_date */
  state: Scalars['String']['output'];
  /** mqtt, legacy_tcp, or null when not live and unknown. */
  transport?: Maybe<Scalars['String']['output']>;
  trimmedThroughAt?: Maybe<Scalars['DateTime']['output']>;
  /** MQTT only. */
  verifiedCursorAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RedisKeyFamilyType = {
  __typename?: 'RedisKeyFamilyType';
  bytes: Scalars['Float']['output'];
  family: Scalars['String']['output'];
  keys: Scalars['Int']['output'];
};

export type RedisOrphanType = {
  __typename?: 'RedisOrphanType';
  bytes: Scalars['Float']['output'];
  /** deleted | archived | implausible_time | summary_only | unarchivable */
  category: Scalars['String']['output'];
  eventDeviceId: Scalars['String']['output'];
  firstSampleAt?: Maybe<Scalars['DateTime']['output']>;
  lastSampleAt?: Maybe<Scalars['DateTime']['output']>;
  rawKeys: Scalars['Int']['output'];
  summaryKeys: Scalars['Int']['output'];
};

export type RedisServerType = {
  __typename?: 'RedisServerType';
  aofEnabled?: Maybe<Scalars['Boolean']['output']>;
  aofLastWriteStatus?: Maybe<Scalars['String']['output']>;
  fragmentationRatio?: Maybe<Scalars['Float']['output']>;
  keys: Scalars['Int']['output'];
  /** 0 means no limit, as Redis reports it. */
  maxmemory?: Maybe<Scalars['Float']['output']>;
  totalSystemMemory?: Maybe<Scalars['Float']['output']>;
  usedMemory: Scalars['Float']['output'];
};

export type RedisTimelineBucketType = {
  __typename?: 'RedisTimelineBucketType';
  endAt: Scalars['DateTime']['output'];
  expected?: Maybe<Scalars['Int']['output']>;
  received?: Maybe<Scalars['Int']['output']>;
  repairAttempts?: Maybe<Scalars['Int']['output']>;
  startAt: Scalars['DateTime']['output'];
  /** repair_exhausted, missing, repairing, gap, no_status, unacknowledged, archived, empty, verified (MQTT) or covered (legacy), worst first. A bucket wider than a page takes the worst problem state (repair_exhausted, missing, repairing, gap) found in it; without one, the state covering the most of its non-empty time, ties going to the worse. It is empty only when all of it is empty. */
  state: Scalars['String']['output'];
};

export type RedisTimelineMarkersType = {
  __typename?: 'RedisTimelineMarkersType';
  archiveCursorAt?: Maybe<Scalars['DateTime']['output']>;
  frontierAt?: Maybe<Scalars['DateTime']['output']>;
  newestSampleAt?: Maybe<Scalars['DateTime']['output']>;
  trimmedThroughAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedCursorAt?: Maybe<Scalars['DateTime']['output']>;
  windowEnd?: Maybe<Scalars['DateTime']['output']>;
  windowStart?: Maybe<Scalars['DateTime']['output']>;
};

/**
 *
 * Refresh token can be used to obtain a new token instead of log in again
 * when the token expires.
 *
 * *This is only used if `JWT_LONG_RUNNING_REFRESH_TOKEN` is set to True.*
 *
 */
export type RefreshTokenType = {
  __typename?: 'RefreshTokenType';
  created: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  isExpired: Scalars['Boolean']['output'];
  revoked?: Maybe<Scalars['DateTime']['output']>;
  /** randomly generated token that is attached to a FK user. */
  token: Scalars['String']['output'];
};

export type RegisterOAuthApplicationResponseType = {
  __typename?: 'RegisterOAuthApplicationResponseType';
  application?: Maybe<OAuthApplicationType>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type ResponseType = {
  __typename?: 'ResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type RevokeRefreshTokenType = {
  __typename?: 'RevokeRefreshTokenType';
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  refreshToken?: Maybe<RefreshTokenType>;
  success: Scalars['Boolean']['output'];
};

export type SectorPointInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};

export type SectorPointType = {
  __typename?: 'SectorPointType';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lon: Scalars['Float']['output'];
  s?: Maybe<Scalars['Float']['output']>;
};

export type SectorSchemeResponseType = {
  __typename?: 'SectorSchemeResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  scheme?: Maybe<SectorSchemeType>;
};

export type SectorSchemeType = {
  __typename?: 'SectorSchemeType';
  algorithmVersion?: Maybe<Scalars['Int']['output']>;
  generated: Scalars['Boolean']['output'];
  geometryVersion?: Maybe<Scalars['Int']['output']>;
  humanModified: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  points: Array<SectorPointType>;
};

export type StripeSessionResponseType = {
  __typename?: 'StripeSessionResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  stripeSessionUrl: Scalars['String']['output'];
};

export type SubscriptionPlanType = {
  __typename?: 'SubscriptionPlanType';
  features: Array<FeatureType>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  prettyName: Scalars['String']['output'];
  priceMonth: Scalars['Float']['output'];
  priceYear: Scalars['Float']['output'];
};

export type SuperuserAccountResponseType = {
  __typename?: 'SuperuserAccountResponseType';
  account: AccountType;
  ok: Scalars['Boolean']['output'];
};

export type SuperuserAccountSubscriptionResponseType = {
  __typename?: 'SuperuserAccountSubscriptionResponseType';
  accountSubscription?: Maybe<AccountSubscriptionType>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type SuperuserEventDeviceDataSegmentDownloadLinkResponseType = {
  __typename?: 'SuperuserEventDeviceDataSegmentDownloadLinkResponseType';
  downloadLink?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SuperuserEventDeviceLegacyStatusType = {
  __typename?: 'SuperuserEventDeviceLegacyStatusType';
  isLegacy: Scalars['Boolean']['output'];
  legacyEventdeviceId?: Maybe<Scalars['Int']['output']>;
};

export type SuperuserLegacyArchiveDownloadLinkResponseType = {
  __typename?: 'SuperuserLegacyArchiveDownloadLinkResponseType';
  downloadLink?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SuperuserLegacyArchiveType = {
  __typename?: 'SuperuserLegacyArchiveType';
  end?: Maybe<Scalars['DateTime']['output']>;
  path: Scalars['String']['output'];
  start?: Maybe<Scalars['DateTime']['output']>;
};

export type SuperuserLegalEntitySettingsResponseType = {
  __typename?: 'SuperuserLegalEntitySettingsResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  settings?: Maybe<LegalEntitySettingsType>;
};

export type SuperuserPodiumEventResponseType = {
  __typename?: 'SuperuserPodiumEventResponseType';
  errors: Array<ErrorType>;
  event?: Maybe<PodiumEventType>;
  ok: Scalars['Boolean']['output'];
};

export type SuperuserPolicyDocumentResponseType = {
  __typename?: 'SuperuserPolicyDocumentResponseType';
  document?: Maybe<PolicyDocumentType>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type SuperuserPresetResponseType = {
  __typename?: 'SuperuserPresetResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  preset?: Maybe<PresetType>;
};

export type SuperuserPresetTypeResponseType = {
  __typename?: 'SuperuserPresetTypeResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  presetType?: Maybe<PresetTypeType>;
};

export type SuperuserRedisHealthType = {
  __typename?: 'SuperuserRedisHealthType';
  /** Null when the key is missing. */
  archiverLastPass?: Maybe<ArchiverPassType>;
  /** Null when the key is missing. */
  audit?: Maybe<RedisAuditType>;
  /** One per unarchived event device, problems first. */
  eventDevices: Array<RedisEventDeviceType>;
  server: RedisServerType;
};

export type SuperuserRedisTimelineType = {
  __typename?: 'SuperuserRedisTimelineType';
  bucketSeconds: Scalars['Float']['output'];
  buckets: Array<RedisTimelineBucketType>;
  endTime: Scalars['DateTime']['output'];
  markers: RedisTimelineMarkersType;
  startTime: Scalars['DateTime']['output'];
  /** mqtt, legacy_tcp, or null when not live and unknown. */
  transport?: Maybe<Scalars['String']['output']>;
};

export type SuperuserSummaryType = {
  __typename?: 'SuperuserSummaryType';
  devicesCount: Scalars['Int']['output'];
  eventsCount: Scalars['Int']['output'];
  lapsCount: Scalars['Int']['output'];
  usersCount: Scalars['Int']['output'];
};

export type SuperuserUserResponseType = {
  __typename?: 'SuperuserUserResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  user?: Maybe<BaseUserType>;
};

export type TelemetryExportType = {
  __typename?: 'TelemetryExportType';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<BaseUserType>;
  eventDevice: EventDeviceType;
  fileType: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  s3FileKey: Scalars['String']['output'];
  status: Scalars['String']['output'];
  statusDisplay: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TelemetryExportTypePaginatedResponseType = {
  __typename?: 'TelemetryExportTypePaginatedResponseType';
  items: Array<TelemetryExportType>;
  metadata: PaginationMetadata;
};

export type TelemetryImportType = {
  __typename?: 'TelemetryImportType';
  createdAt: Scalars['DateTime']['output'];
  createdBy: BaseUserType;
  eventDevice: EventDeviceType;
  fileType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  s3FileKey: Scalars['String']['output'];
  /** True once the uploaded file is past its retention and cannot be downloaded. */
  sourceFileExpired: Scalars['Boolean']['output'];
  /** When the uploaded file is removed by the retention rule; null when files are kept. */
  sourceFileExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  statusDisplay: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TelemetryImportTypePaginatedResponseType = {
  __typename?: 'TelemetryImportTypePaginatedResponseType';
  items: Array<TelemetryImportType>;
  metadata: PaginationMetadata;
};

/**
 *
 *     Encapsulates token data and returns the authenticated user with the
 *     application-specific GraphQL user type.
 *
 */
export type TokenAuthResponseType = {
  __typename?: 'TokenAuthResponseType';
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  refreshToken?: Maybe<RefreshTokenType>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<TokenType>;
  user?: Maybe<BaseUserType>;
};

/**
 *
 * the data that was used to create the token.
 *
 */
export type TokenPayloadType = {
  __typename?: 'TokenPayloadType';
  email: Scalars['String']['output'];
  /** when the token will be expired */
  exp: Scalars['DateTime']['output'];
  /** when the token was created */
  origIat: Scalars['DateTime']['output'];
};

/**
 *
 * encapsulates the token with the payload that was used to create the token.
 *
 */
export type TokenType = {
  __typename?: 'TokenType';
  payload: TokenPayloadType;
  /** The encoded payload, namely a token. */
  token: Scalars['String']['output'];
};

export type UserPreferenceCategoryType = {
  __typename?: 'UserPreferenceCategoryType';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type UserPreferenceChoiceType = {
  __typename?: 'UserPreferenceChoiceType';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UserPreferenceResponseType = {
  __typename?: 'UserPreferenceResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  preference?: Maybe<UserPreferenceType>;
};

export type UserPreferenceType = {
  __typename?: 'UserPreferenceType';
  category: Scalars['String']['output'];
  categoryLabel: Scalars['String']['output'];
  choices: Array<UserPreferenceChoiceType>;
  description: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UserResponseType = {
  __typename?: 'UserResponseType';
  user: BaseUserType;
};

export type UserStatusType = {
  __typename?: 'UserStatusType';
  archived: Scalars['Boolean']['output'];
  verified: Scalars['Boolean']['output'];
};

export type UserType = {
  __typename?: 'UserType';
  archived: Scalars['Boolean']['output'];
  dateJoined: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  logentrySet: Array<DjangoModelType>;
  status: UserStatusType;
  verified: Scalars['Boolean']['output'];
};

export type VenueGeometryRegenResponseType = {
  __typename?: 'VenueGeometryRegenResponseType';
  processed: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  results: Array<VenueGeometryRegenResultType>;
};

export type VenueGeometryRegenResultType = {
  __typename?: 'VenueGeometryRegenResultType';
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  venueId: Scalars['UUID']['output'];
};

export type VenueGeometryStatusType = {
  __typename?: 'VenueGeometryStatusType';
  stale: Scalars['Int']['output'];
  totalWithTrackMap: Scalars['Int']['output'];
};

export type VenueResponseType = {
  __typename?: 'VenueResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  venue?: Maybe<VenueType>;
};

export enum VenueSourceType {
  AutoLocked = 'AUTO_LOCKED',
  AutoProvisional = 'AUTO_PROVISIONAL',
  Manual = 'MANUAL',
  Unset = 'UNSET'
}

export type VenueType = {
  __typename?: 'VenueType';
  configuration?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  countryName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  finish?: Maybe<Scalars['GeoJSON']['output']>;
  geometryAlgorithm?: Maybe<Scalars['String']['output']>;
  geometryGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  geometryStale: Scalars['Boolean']['output'];
  geometryVersion?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  length?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Scalars['GeoJSON']['output']>;
  minLapTime?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  primarySectorScheme?: Maybe<Scalars['String']['output']>;
  sectorPoints?: Maybe<Scalars['GeoJSON']['output']>;
  sectorSchemes: Array<SectorSchemeType>;
  startFinish?: Maybe<Scalars['GeoJSON']['output']>;
  trackMap?: Maybe<Scalars['GeoJSON']['output']>;
  trackMapThumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type VenueTypePaginatedResponseType = {
  __typename?: 'VenueTypePaginatedResponseType';
  items: Array<VenueType>;
  metadata: PaginationMetadata;
};

export type VerifyTokenType = OutputInterface & {
  __typename?: 'VerifyTokenType';
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<TokenType>;
  user?: Maybe<UserType>;
};

export type VideoHlsTrackType = {
  __typename?: 'VideoHlsTrackType';
  cameraName: Scalars['String']['output'];
  playlistUrl: Scalars['String']['output'];
};

export type VideoStreamSessionType = {
  __typename?: 'VideoStreamSessionType';
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  eventDeviceId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  metadata: Scalars['JSON']['output'];
  sessionKey: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  tracks: Array<VideoTrackType>;
};

export type VideoTrackType = {
  __typename?: 'VideoTrackType';
  cameraName: Scalars['String']['output'];
  codec: Scalars['String']['output'];
  firstPdt?: Maybe<Scalars['DateTime']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  initKey: Scalars['String']['output'];
  lastPdt?: Maybe<Scalars['DateTime']['output']>;
  livePlaylistKey: Scalars['String']['output'];
  role: Scalars['String']['output'];
  segmentCount: Scalars['Int']['output'];
  segmentDurationMs: Scalars['Int']['output'];
  vodPlaylistKey: Scalars['String']['output'];
  vodPlaylistUrl?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type VideoViewerAccessType = {
  __typename?: 'VideoViewerAccessType';
  liveDelayHintSec?: Maybe<Scalars['Int']['output']>;
  mode: VideoViewerMode;
  signalingUrl?: Maybe<Scalars['String']['output']>;
  tracks?: Maybe<Array<VideoHlsTrackType>>;
  viewerToken?: Maybe<Scalars['String']['output']>;
};

export enum VideoViewerMode {
  Hls = 'HLS',
  None = 'NONE',
  Webrtc = 'WEBRTC'
}

export type WorkspaceAlternativeType = {
  __typename?: 'WorkspaceAlternativeType';
  alreadyContains: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  lastOpenedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  sameVenue: Scalars['Boolean']['output'];
  venue?: Maybe<VenueType>;
};

export type WorkspaceEventDeviceType = {
  __typename?: 'WorkspaceEventDeviceType';
  available: Scalars['Boolean']['output'];
  eventDevice?: Maybe<PodiumEventDeviceType>;
  id: Scalars['UUID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  live: Scalars['Boolean']['output'];
  liveSlot?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  venueMismatch: Scalars['Boolean']['output'];
};

export type WorkspaceLapType = {
  __typename?: 'WorkspaceLapType';
  eventDeviceId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  lap: LapType;
  position: Scalars['Int']['output'];
  workspaceEventDeviceId: Scalars['UUID']['output'];
};

export type WorkspaceQuotaType = {
  __typename?: 'WorkspaceQuotaType';
  canCreate: Scalars['Boolean']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  used: Scalars['Int']['output'];
};

export type WorkspaceResponseType = {
  __typename?: 'WorkspaceResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  workspace?: Maybe<WorkspaceType>;
};

export type WorkspaceType = {
  __typename?: 'WorkspaceType';
  createdAt: Scalars['DateTime']['output'];
  deviceCount: Scalars['Int']['output'];
  eventDevices: Array<WorkspaceEventDeviceType>;
  id: Scalars['UUID']['output'];
  laps: Array<WorkspaceLapType>;
  lastOpenedAt: Scalars['DateTime']['output'];
  locked: Scalars['Boolean']['output'];
  maxLaps: Scalars['Int']['output'];
  maxLiveSessions: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  screens: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
  venue?: Maybe<VenueType>;
};

export type WorkspacesResponseType = {
  __typename?: 'WorkspacesResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  workspaces: Array<WorkspaceType>;
};

export type MyAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAccountQuery = { __typename?: 'AllQueriesWithSuperuser', myAccount: { __typename?: 'AccountType', name: string, notes: string, subscriptionPlan: { __typename?: 'SubscriptionPlanType', prettyName: string } } };

export type UpdateAccountMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAccountMutation = { __typename?: 'AllMutationsWithSuperuser', updateAccount: { __typename?: 'AccountResponseType', ok: boolean } };

export type ResendActivationEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendActivationEmailMutation = { __typename?: 'AllMutationsWithSuperuser', resendActivationEmail: { __typename?: 'MutationNormalOutput', success: boolean, errors?: any | null } };

export type AccountQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AccountQuery = { __typename?: 'AllQueriesWithSuperuser', superuserAccountById: { __typename?: 'AccountType', id: string, name: string, notes: string, subscriptionPlan: { __typename?: 'SubscriptionPlanType', prettyName: string }, devices: Array<{ __typename?: 'DeviceType', id: string, name: string, createdAt: string }> } };

export type AdminAccountAttributesQueryVariables = Exact<{
  accountId: Scalars['UUID']['input'];
}>;


export type AdminAccountAttributesQuery = { __typename?: 'AllQueriesWithSuperuser', superuserAccountAttributes: Array<{ __typename?: 'AccountAttributeStateType', key: string, label: string, description: string, enabled: boolean, defaultEnabled: boolean }> };

export type AdminSetAccountAttributesMutationVariables = Exact<{
  accountId: Scalars['UUID']['input'];
  attributes: Array<AccountAttributeInput> | AccountAttributeInput;
}>;


export type AdminSetAccountAttributesMutation = { __typename?: 'AllMutationsWithSuperuser', superuserSetAccountAttributes: { __typename?: 'AccountAttributeResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, attributes?: Array<{ __typename?: 'AccountAttributeStateType', key: string, enabled: boolean }> | null } };

export type AdminUpdateAccountMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminUpdateAccountMutation = { __typename?: 'AllMutationsWithSuperuser', superuserUpdateAccount: { __typename?: 'SuperuserAccountResponseType', ok: boolean, account: { __typename?: 'AccountType', id: string, name: string, notes: string } } };

export type AlertMessagesQueryVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
}>;


export type AlertMessagesQuery = { __typename?: 'AllQueriesWithSuperuser', alertMessages: Array<{ __typename?: 'AlertMessageType', id: string, message: string, sendTime: string, ackTime?: string | null, sender?: { __typename?: 'BaseUserType', firstName: string, lastName: string } | null }> };

export type ApiKeyFieldsFragment = { __typename?: 'ApiKeyType', id: string, name: string, keyPrefix: string, scopes: Array<string>, isActive: boolean, createdAt: string, lastUsedAt?: string | null, revokedAt?: string | null, account: { __typename?: 'AccountType', id: string, name: string } };

export type ApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeysQuery = { __typename?: 'AllQueriesWithSuperuser', apiKeys: Array<{ __typename?: 'ApiKeyType', id: string, name: string, keyPrefix: string, scopes: Array<string>, isActive: boolean, createdAt: string, lastUsedAt?: string | null, revokedAt?: string | null, account: { __typename?: 'AccountType', id: string, name: string } }> };

export type ApiKeyScopesQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeyScopesQuery = { __typename?: 'AllQueriesWithSuperuser', apiKeyScopes: Array<{ __typename?: 'ApiKeyScopeType', key: string, label: string, description: string }> };

export type GenerateApiKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GenerateApiKeyMutation = { __typename?: 'AllMutationsWithSuperuser', generateApiKey: { __typename?: 'GenerateApiKeyResponseType', ok: boolean, key?: string | null, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, apiKey?: { __typename?: 'ApiKeyType', id: string, name: string, keyPrefix: string, scopes: Array<string>, isActive: boolean, createdAt: string, lastUsedAt?: string | null, revokedAt?: string | null, account: { __typename?: 'AccountType', id: string, name: string } } | null } };

export type UpdateApiKeyMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdateApiKeyMutation = { __typename?: 'AllMutationsWithSuperuser', updateApiKey: { __typename?: 'ApiKeyResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, apiKey?: { __typename?: 'ApiKeyType', id: string, name: string, keyPrefix: string, scopes: Array<string>, isActive: boolean, createdAt: string, lastUsedAt?: string | null, revokedAt?: string | null, account: { __typename?: 'AccountType', id: string, name: string } } | null } };

export type RevokeApiKeyMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RevokeApiKeyMutation = { __typename?: 'AllMutationsWithSuperuser', revokeApiKey: { __typename?: 'ApiKeyResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, apiKey?: { __typename?: 'ApiKeyType', id: string, name: string, keyPrefix: string, scopes: Array<string>, isActive: boolean, createdAt: string, lastUsedAt?: string | null, revokedAt?: string | null, account: { __typename?: 'AccountType', id: string, name: string } } | null } };

export type DeleteApiKeyMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteApiKeyMutation = { __typename?: 'AllMutationsWithSuperuser', deleteApiKey: { __typename?: 'OkResponseType', ok: boolean } };

export type CurrentPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentPoliciesQuery = { __typename?: 'AllQueriesWithSuperuser', currentPolicies: Array<{ __typename?: 'PolicyDocumentType', documentType: string, version: number, effectiveDate: any, body: string }> };

export type PolicyDocumentQueryVariables = Exact<{
  documentType: Scalars['String']['input'];
  version: Scalars['Int']['input'];
}>;


export type PolicyDocumentQuery = { __typename?: 'AllQueriesWithSuperuser', policyDocument?: { __typename?: 'PolicyDocumentType', documentType: string, version: number, effectiveDate: any, body: string } | null };

export type LegalEntitySettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type LegalEntitySettingsQuery = { __typename?: 'AllQueriesWithSuperuser', legalEntitySettings: { __typename?: 'LegalEntitySettingsType', entityName: string, address: string, contactEmail: string, euRepresentative: string } };

export type ConsentStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsentStatusQuery = { __typename?: 'AllQueriesWithSuperuser', consentStatus: { __typename?: 'ConsentStatusType', requiresReconsent: boolean, pendingPolicies: Array<{ __typename?: 'PolicyDocumentType', documentType: string, version: number, effectiveDate: any, body: string }> } };

export type AcceptPoliciesMutationVariables = Exact<{
  acceptances: Array<PolicyAcceptanceInput> | PolicyAcceptanceInput;
}>;


export type AcceptPoliciesMutation = { __typename?: 'AllMutationsWithSuperuser', acceptPolicies: { __typename?: 'ResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type SetMarketingConsentMutationVariables = Exact<{
  granted: Scalars['Boolean']['input'];
}>;


export type SetMarketingConsentMutation = { __typename?: 'AllMutationsWithSuperuser', setMarketingConsent: { __typename?: 'ResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type DashboardPresetsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  mine: Scalars['Boolean']['input'];
  publicOnly: Scalars['Boolean']['input'];
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  presetTypeKey?: Scalars['String']['input'];
}>;


export type DashboardPresetsQuery = { __typename?: 'AllQueriesWithSuperuser', presets: Array<{ __typename?: 'PresetType', id: string, name: string, notes: string, rating?: number | null, ratingCount: number, isSystem: boolean, isPrivate: boolean, previewImageSmall?: string | null, createdBy: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string } }> };

export type DashboardPresetDataQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DashboardPresetDataQuery = { __typename?: 'AllQueriesWithSuperuser', presetById: { __typename?: 'PresetType', id: string, name: string, presetData?: any | null } };

export type CreateDashboardPresetMutationVariables = Exact<{
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  presetData: Scalars['String']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  previewImageData?: InputMaybe<Scalars['String']['input']>;
  previewImageName?: InputMaybe<Scalars['String']['input']>;
  presetTypeKey?: Scalars['String']['input'];
}>;


export type CreateDashboardPresetMutation = { __typename?: 'AllMutationsWithSuperuser', createPreset: { __typename?: 'PresetResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, preset?: { __typename?: 'PresetType', id: string, name: string } | null } };

export type UpdateDashboardPresetMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  presetData?: InputMaybe<Scalars['String']['input']>;
  previewImageData?: InputMaybe<Scalars['String']['input']>;
  previewImageName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDashboardPresetMutation = { __typename?: 'AllMutationsWithSuperuser', updatePreset: { __typename?: 'PresetResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type MyDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyDevicesQuery = { __typename?: 'AllQueriesWithSuperuser', myDevices: Array<{ __typename?: 'DeviceType', id: string, name: string, createdAt: string, isPrivate: boolean, streamingKey: string, previewImageSmall?: string | null, previewImageMedium?: string | null, previewImageLarge?: string | null }> };

export type DeviceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeviceQuery = { __typename?: 'AllQueriesWithSuperuser', deviceById: { __typename?: 'DeviceType', id: string, name: string, notes: string, streamingKey: string, isPrivate: boolean, previewImageSmall?: string | null, previewImageMedium?: string | null, previewImageLarge?: string | null, createdAt: string } };

export type CreateDeviceMutationVariables = Exact<{
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  isPrivate: Scalars['Boolean']['input'];
}>;


export type CreateDeviceMutation = { __typename?: 'AllMutationsWithSuperuser', createDevice: { __typename?: 'DeviceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type DeleteDeviceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteDeviceMutation = { __typename?: 'AllMutationsWithSuperuser', deleteDevice: { __typename?: 'OkResponseType', ok: boolean } };

export type EditDeviceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditDeviceMutation = { __typename?: 'AllMutationsWithSuperuser', updateDevice: { __typename?: 'DeviceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type SuperuserDevicesQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuperuserDevicesQuery = { __typename?: 'AllQueriesWithSuperuser', superuserDevices: { __typename?: 'DeviceTypePaginatedResponseType', items: Array<{ __typename?: 'DeviceType', id: string, name: string, streamingKey: string, createdAt: string, createdBy: { __typename?: 'BaseUserType', id: string, email: string } }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number } } };

export type SuperuserDeviceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserDeviceQuery = { __typename?: 'AllQueriesWithSuperuser', superuserDeviceById: { __typename?: 'DeviceType', id: string, name: string, notes: string, streamingKey: string, previewImageSmall?: string | null, previewImageMedium?: string | null, previewImageLarge?: string | null, createdAt: string, isPrivate: boolean, createdBy: { __typename?: 'BaseUserType', id: string, email: string } } };

export type EventDevicesQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
}>;


export type EventDevicesQuery = { __typename?: 'AllQueriesWithSuperuser', eventDevices: Array<{ __typename?: 'EventDeviceType', id: string, startTime: string, endTime: string, competitorNumber: string, processorInstanceHost: string, device: { __typename?: 'DeviceType', id: string, name: string, isOwner: boolean, previewImageSmall?: string | null, previewImageMedium?: string | null, createdBy: { __typename?: 'BaseUserType', id: string, slug: string, firstName: string, lastName: string, avatarSmall?: string | null } } }> };

export type EventDeviceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type EventDeviceQuery = { __typename?: 'AllQueriesWithSuperuser', eventDeviceById: { __typename?: 'EventDeviceType', id: string, startTime: string, endTime: string, metadata: any, processorInstanceHost: string, device: { __typename?: 'DeviceType', id: string, name: string, streamingKey: string, isPrivate: boolean, isOwner: boolean }, event: { __typename?: 'EventType', id: string, name: string, isOwner: boolean } } };

export type SuperuserDeviceEventsQueryVariables = Exact<{
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SuperuserDeviceEventsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserEventDevices: Array<{ __typename?: 'PodiumEventDeviceType', id: string, event: { __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, venue?: { __typename?: 'VenueType', id: string, name: string } | null } }> };

export type SuperuserEventDevicesQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SuperuserEventDevicesQuery = { __typename?: 'AllQueriesWithSuperuser', superuserEventDevices: Array<{ __typename?: 'PodiumEventDeviceType', id: string, device: { __typename?: 'DeviceType', id: string, name: string, streamingKey: string, createdAt: string, createdBy: { __typename?: 'BaseUserType', id: string, email: string } } }> };

export type SuperuserEventDeviceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserEventDeviceQuery = { __typename?: 'AllQueriesWithSuperuser', superuserEventDeviceById: { __typename?: 'PodiumEventDeviceType', id: string, startTime: string, endTime: string, metadata: any, source: string, sourceVer: string, deviceSn: string, event: { __typename?: 'PodiumEventType', id: string, name: string }, device: { __typename?: 'DeviceType', id: string, name: string, isPrivate: boolean } } };

export type SuperuserLiveStreamsQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperuserLiveStreamsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserLiveStreams: Array<{ __typename?: 'EventDeviceType', id: string, liveTransport?: string | null, source: string, sourceVer: string, competitorNumber: string, event: { __typename?: 'EventType', id: string, name: string }, device: { __typename?: 'DeviceType', id: string, name: string, previewImageSmall?: string | null, previewImageMedium?: string | null, createdBy: { __typename?: 'BaseUserType', id: string, email: string } } }> };

export type SuperuserDeleteEventDeviceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserDeleteEventDeviceMutation = { __typename?: 'AllMutationsWithSuperuser', superuserDeleteEventDevice: { __typename?: 'OkResponseType', ok: boolean } };

export type CreateEventDeviceMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  competitorNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateEventDeviceMutation = { __typename?: 'AllMutationsWithSuperuser', createEventDevice: { __typename?: 'EventDeviceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type UpdateEventDeviceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  competitorNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateEventDeviceMutation = { __typename?: 'AllMutationsWithSuperuser', updateEventDevice: { __typename?: 'EventDeviceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type DeleteEventDeviceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteEventDeviceMutation = { __typename?: 'AllMutationsWithSuperuser', deleteEventDevice: { __typename?: 'OkResponseType', ok: boolean } };

export type SuperuserEventDeviceDataSegmentsQueryVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
}>;


export type SuperuserEventDeviceDataSegmentsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserEventDeviceDataSegments: Array<{ __typename?: 'EventDeviceDataSegmentType', id: string, filePath: string, start: string, end: string }> };

export type SuperuserGetEventDeviceDataSegmentDownloadLinkMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserGetEventDeviceDataSegmentDownloadLinkMutation = { __typename?: 'AllMutationsWithSuperuser', superuserGetEventDeviceDataSegmentDownloadLink: { __typename?: 'SuperuserEventDeviceDataSegmentDownloadLinkResponseType', ok: boolean, downloadLink?: string | null } };

export type EventCardFieldsFragment = { __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isPrivate: boolean, isLive: boolean, venue?: { __typename?: 'VenueType', id: string, name: string, country: string, countryName?: string | null, length?: number | null, minLapTime?: number | null, trackMapThumbnail?: string | null } | null, createdBy: { __typename?: 'BaseUserType', id: string, slug: string, firstName: string, lastName: string, avatarSmall?: string | null, profilePictureLarge?: string | null } };

export type EventsQueryVariables = Exact<{
  venueId?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  timeFilter?: InputMaybe<EventTimeFilter>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventsQuery = { __typename?: 'AllQueriesWithSuperuser', events: { __typename?: 'PodiumEventTypePaginatedResponseType', items: Array<{ __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isPrivate: boolean, isLive: boolean, venue?: { __typename?: 'VenueType', id: string, name: string, country: string, countryName?: string | null, length?: number | null, minLapTime?: number | null, trackMapThumbnail?: string | null } | null, createdBy: { __typename?: 'BaseUserType', id: string, slug: string, firstName: string, lastName: string, avatarSmall?: string | null, profilePictureLarge?: string | null } }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type MyEventsQueryVariables = Exact<{
  venueId?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  timeFilter?: InputMaybe<EventTimeFilter>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyEventsQuery = { __typename?: 'AllQueriesWithSuperuser', myEvents: { __typename?: 'PodiumEventTypePaginatedResponseType', items: Array<{ __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isPrivate: boolean, isLive: boolean, venue?: { __typename?: 'VenueType', id: string, name: string, country: string, countryName?: string | null, length?: number | null, minLapTime?: number | null, trackMapThumbnail?: string | null } | null, createdBy: { __typename?: 'BaseUserType', id: string, slug: string, firstName: string, lastName: string, avatarSmall?: string | null, profilePictureLarge?: string | null } }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type LiveEventIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type LiveEventIdsQuery = { __typename?: 'AllQueriesWithSuperuser', liveEventIds: Array<string> };

export type PublicUserEventsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PublicUserEventsQuery = { __typename?: 'AllQueriesWithSuperuser', publicUserEvents: { __typename?: 'PodiumEventTypePaginatedResponseType', items: Array<{ __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isPrivate: boolean, createdBy: { __typename?: 'BaseUserType', id: string, slug: string, firstName: string, lastName: string, avatarSmall?: string | null }, venue?: { __typename?: 'VenueType', id: string, name: string, trackMapThumbnail?: string | null } | null }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type EventQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type EventQuery = { __typename?: 'AllQueriesWithSuperuser', eventById: { __typename?: 'PodiumEventType', id: string, name: string, notes: string, startAt: string, endAt: string, isPrivate: boolean, isOwner: boolean, createdBy: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, avatarSmall?: string | null, profilePictureLarge?: string | null, account: { __typename?: 'AccountType', name: string } }, venue?: { __typename?: 'VenueType', id: string, name: string, trackMap?: any | null, startFinish?: any | null, finish?: any | null, location?: any | null, country: string, countryName?: string | null, configuration?: string | null, length?: number | null, minLapTime?: number | null } | null } };

export type EventDeviceLapSummariesQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
}>;


export type EventDeviceLapSummariesQuery = { __typename?: 'AllQueriesWithSuperuser', eventDeviceLapSummaries: Array<{ __typename?: 'EventDeviceLapSummaryType', eventDeviceId: string, lapCount: number, bestLapTime?: number | null, lastLapTime?: number | null }> };

export type CreateEventMutationVariables = Exact<{
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  startAt: Scalars['DateTime']['input'];
  endAt: Scalars['DateTime']['input'];
  isPrivate: Scalars['Boolean']['input'];
  venueId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CreateEventMutation = { __typename?: 'AllMutationsWithSuperuser', createEvent: { __typename?: 'PodiumEventResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type EditEventMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  venueId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type EditEventMutation = { __typename?: 'AllMutationsWithSuperuser', updateEvent: { __typename?: 'PodiumEventResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteEventMutation = { __typename?: 'AllMutationsWithSuperuser', deleteEvent: { __typename?: 'ResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', message: string }> } };

export type SuperuserEventsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuperuserEventsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserEvents: { __typename?: 'PodiumEventTypePaginatedResponseType', items: Array<{ __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null } | null }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number } } };

export type SuperuserEventQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserEventQuery = { __typename?: 'AllQueriesWithSuperuser', superuserEventById: { __typename?: 'PodiumEventType', id: string, name: string, notes: string, startAt: string, endAt: string, isPrivate: boolean, timeRangeAutoAdjustable: boolean, venueSource: VenueSourceType, venueClearable: boolean, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null, trackMapThumbnail?: string | null } | null } };

export type EventVenueLockQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type EventVenueLockQuery = { __typename?: 'AllQueriesWithSuperuser', eventById: { __typename?: 'PodiumEventType', id: string, venueSource: VenueSourceType, venueLocked: boolean, venueClearable: boolean, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null, trackMapThumbnail?: string | null } | null } };

export type SuperuserUpdateEventMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  venueId?: InputMaybe<Scalars['UUID']['input']>;
  timeRangeAutoAdjustable?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SuperuserUpdateEventMutation = { __typename?: 'AllMutationsWithSuperuser', superuserUpdateEvent: { __typename?: 'SuperuserPodiumEventResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, event?: { __typename?: 'PodiumEventType', id: string, name: string } | null } };

export type SuperuserDeleteEventMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SuperuserDeleteEventMutation = { __typename?: 'AllMutationsWithSuperuser', superuserDeleteEvent: { __typename?: 'ResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', message: string }> } };

export type CreateTelemetryExportMutationVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
}>;


export type CreateTelemetryExportMutation = { __typename?: 'AllMutationsWithSuperuser', createTelemetryExport: { __typename?: 'CreateTelemetryExportResponseType', ok: boolean } };

export type TelemetryExportsQueryVariables = Exact<{
  eventDeviceId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type TelemetryExportsQuery = { __typename?: 'AllQueriesWithSuperuser', telemetryExports: Array<{ __typename?: 'TelemetryExportType', id: string, status: string, statusDisplay: string, createdAt: string, eventDevice: { __typename?: 'EventDeviceType', id: string, event: { __typename?: 'EventType', name: string }, device: { __typename?: 'DeviceType', id: string, name: string, previewImageSmall?: string | null, previewImageMedium?: string | null } }, createdBy?: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string } | null }> };

export type GenerateTelemetryExportFileDownloadLinkMutationVariables = Exact<{
  telemetryExportId: Scalars['UUID']['input'];
}>;


export type GenerateTelemetryExportFileDownloadLinkMutation = { __typename?: 'AllMutationsWithSuperuser', generateTelemetryExportFileDownloadLink: { __typename?: 'GenerateTelemetryExportFileDownloadLinkResponseType', ok: boolean, downloadLink?: string | null } };

export type DeleteTelemetryExportMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteTelemetryExportMutation = { __typename?: 'AllMutationsWithSuperuser', deleteTelemetryExport: { __typename?: 'ResponseType', ok: boolean } };

export type SuperuserTelemetryExportsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuperuserTelemetryExportsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserTelemetryExports: { __typename?: 'TelemetryExportTypePaginatedResponseType', items: Array<{ __typename?: 'TelemetryExportType', id: string, status: string, statusDisplay: string, createdAt: string, eventDevice: { __typename?: 'EventDeviceType', id: string, event: { __typename?: 'EventType', name: string }, device: { __typename?: 'DeviceType', name: string, streamingKey: string } }, createdBy?: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, email: string } | null }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type SuperuserGenerateTelemetryExportDownloadLinkMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserGenerateTelemetryExportDownloadLinkMutation = { __typename?: 'AllMutationsWithSuperuser', superuserGenerateTelemetryExportDownloadLink: { __typename?: 'GenerateTelemetryExportDownloadLinkResponseType', ok: boolean, downloadLink?: string | null } };

export type SuperuserDeleteTelemetryExportMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserDeleteTelemetryExportMutation = { __typename?: 'AllMutationsWithSuperuser', superuserDeleteTelemetryExport: { __typename?: 'OkResponseType', ok: boolean } };

export type ViewerCapabilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerCapabilitiesQuery = { __typename?: 'AllQueriesWithSuperuser', viewerCapabilities: Array<string> };

export type AdminFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminFeatureFlagsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserFeatureFlags: Array<{ __typename?: 'FeatureFlagType', key: string, label: string, description: string, defaultEnabled: boolean }> };

export type AdminUserFeatureFlagsQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type AdminUserFeatureFlagsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserUserFeatureFlags: Array<{ __typename?: 'FeatureFlagAssignmentType', id: string, key: string, enabled: boolean, updatedAt: string }> };

export type AdminSetUserFeatureFlagMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  flagKey: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type AdminSetUserFeatureFlagMutation = { __typename?: 'AllMutationsWithSuperuser', superuserSetUserFeatureFlag: { __typename?: 'FeatureFlagAssignmentResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, assignment?: { __typename?: 'FeatureFlagAssignmentType', id: string, key: string, enabled: boolean } | null } };

export type AdminDeleteUserFeatureFlagMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  flagKey: Scalars['String']['input'];
}>;


export type AdminDeleteUserFeatureFlagMutation = { __typename?: 'AllMutationsWithSuperuser', superuserDeleteUserFeatureFlag: { __typename?: 'ResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type FeedQueryVariables = Exact<{
  location?: InputMaybe<LocationInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FeedQuery = { __typename?: 'AllQueriesWithSuperuser', feed: { __typename?: 'PodiumEventTypePaginatedResponseType', items: Array<{ __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isPrivate: boolean, isLive: boolean, venue?: { __typename?: 'VenueType', id: string, name: string, country: string, countryName?: string | null, length?: number | null, minLapTime?: number | null, trackMapThumbnail?: string | null } | null, createdBy: { __typename?: 'BaseUserType', id: string, slug: string, firstName: string, lastName: string, avatarSmall?: string | null, profilePictureLarge?: string | null } }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type ViewerHelpProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerHelpProgressQuery = { __typename?: 'AllQueriesWithSuperuser', viewerHelpProgress: Array<{ __typename?: 'HelpProgressType', key: string, seenAt?: string | null, playedAt?: string | null, completedAt?: string | null, dismissedAt?: string | null }>, userMe: { __typename?: 'BaseUserType', id: string, createdAt: string } };

export type RecordHelpProgressMutationVariables = Exact<{
  key: Scalars['String']['input'];
  event: HelpEvent;
}>;


export type RecordHelpProgressMutation = { __typename?: 'AllMutationsWithSuperuser', recordHelpProgress: { __typename?: 'HelpProgressResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, progress?: { __typename?: 'HelpProgressType', key: string, seenAt?: string | null, playedAt?: string | null, completedAt?: string | null, dismissedAt?: string | null } | null } };

export type ImportSessionFieldsFragment = { __typename?: 'ImportSessionType', id: string, status: string, provider: string, sourceFilename: string, sourceBytes: number, progressPct: number, errorMessage: string, operations: any, describeResult?: any | null, normalizerResult?: any | null, trackMatchResult?: any | null, lapPreview?: any | null, eventId?: string | null, deviceId?: string | null, resultEventDeviceId?: string | null, resultLogfileKey: string, suggestedEventStart?: string | null, createdAt: string, expiresAt: string };

export type CreateImportSessionMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
}>;


export type CreateImportSessionMutation = { __typename?: 'AllMutationsWithSuperuser', createImportSession: { __typename?: 'CreateImportSessionResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, uploadForm?: { __typename?: 'PresignedPostType', url: string, fields: Array<{ __typename?: 'PresignedPostFieldType', name: string, value: string }> } | null, session?: { __typename?: 'ImportSessionType', id: string, status: string, provider: string, sourceFilename: string, sourceBytes: number, progressPct: number, errorMessage: string, operations: any, describeResult?: any | null, normalizerResult?: any | null, trackMatchResult?: any | null, lapPreview?: any | null, eventId?: string | null, deviceId?: string | null, resultEventDeviceId?: string | null, resultLogfileKey: string, suggestedEventStart?: string | null, createdAt: string, expiresAt: string } | null } };

export type StartImportConversionMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type StartImportConversionMutation = { __typename?: 'AllMutationsWithSuperuser', startImportConversion: { __typename?: 'ImportSessionResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, session?: { __typename?: 'ImportSessionType', id: string, status: string, provider: string, sourceFilename: string, sourceBytes: number, progressPct: number, errorMessage: string, operations: any, describeResult?: any | null, normalizerResult?: any | null, trackMatchResult?: any | null, lapPreview?: any | null, eventId?: string | null, deviceId?: string | null, resultEventDeviceId?: string | null, resultLogfileKey: string, suggestedEventStart?: string | null, createdAt: string, expiresAt: string } | null } };

export type ApplyImportChannelSelectionsMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  adjustments: Scalars['JSON']['input'];
  excludedChannels?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ApplyImportChannelSelectionsMutation = { __typename?: 'AllMutationsWithSuperuser', applyImportChannelSelections: { __typename?: 'ImportSessionResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, session?: { __typename?: 'ImportSessionType', id: string, status: string, provider: string, sourceFilename: string, sourceBytes: number, progressPct: number, errorMessage: string, operations: any, describeResult?: any | null, normalizerResult?: any | null, trackMatchResult?: any | null, lapPreview?: any | null, eventId?: string | null, deviceId?: string | null, resultEventDeviceId?: string | null, resultLogfileKey: string, suggestedEventStart?: string | null, createdAt: string, expiresAt: string } | null } };

export type ApplyImportTrackMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  track: Scalars['JSON']['input'];
}>;


export type ApplyImportTrackMutation = { __typename?: 'AllMutationsWithSuperuser', applyImportTrack: { __typename?: 'ImportSessionResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, session?: { __typename?: 'ImportSessionType', id: string, status: string, provider: string, sourceFilename: string, sourceBytes: number, progressPct: number, errorMessage: string, operations: any, describeResult?: any | null, normalizerResult?: any | null, trackMatchResult?: any | null, lapPreview?: any | null, eventId?: string | null, deviceId?: string | null, resultEventDeviceId?: string | null, resultLogfileKey: string, suggestedEventStart?: string | null, createdAt: string, expiresAt: string } | null } };

export type FinalizeImportMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  deviceId: Scalars['UUID']['input'];
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  eventStart?: InputMaybe<Scalars['DateTime']['input']>;
  eventEnd?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type FinalizeImportMutation = { __typename?: 'AllMutationsWithSuperuser', finalizeImport: { __typename?: 'ImportSessionResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, session?: { __typename?: 'ImportSessionType', id: string, status: string, provider: string, sourceFilename: string, sourceBytes: number, progressPct: number, errorMessage: string, operations: any, describeResult?: any | null, normalizerResult?: any | null, trackMatchResult?: any | null, lapPreview?: any | null, eventId?: string | null, deviceId?: string | null, resultEventDeviceId?: string | null, resultLogfileKey: string, suggestedEventStart?: string | null, createdAt: string, expiresAt: string } | null } };

export type CancelImportSessionMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CancelImportSessionMutation = { __typename?: 'AllMutationsWithSuperuser', cancelImportSession: { __typename?: 'ImportSessionResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, session?: { __typename?: 'ImportSessionType', id: string, status: string, provider: string, sourceFilename: string, sourceBytes: number, progressPct: number, errorMessage: string, operations: any, describeResult?: any | null, normalizerResult?: any | null, trackMatchResult?: any | null, lapPreview?: any | null, eventId?: string | null, deviceId?: string | null, resultEventDeviceId?: string | null, resultLogfileKey: string, suggestedEventStart?: string | null, createdAt: string, expiresAt: string } | null } };

export type ImportSessionQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ImportSessionQuery = { __typename?: 'AllQueriesWithSuperuser', importSession: { __typename?: 'ImportSessionType', id: string, status: string, provider: string, sourceFilename: string, sourceBytes: number, progressPct: number, errorMessage: string, operations: any, describeResult?: any | null, normalizerResult?: any | null, trackMatchResult?: any | null, lapPreview?: any | null, eventId?: string | null, deviceId?: string | null, resultEventDeviceId?: string | null, resultLogfileKey: string, suggestedEventStart?: string | null, createdAt: string, expiresAt: string } };

export type ImportSessionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ImportSessionsQuery = { __typename?: 'AllQueriesWithSuperuser', importSessions: Array<{ __typename?: 'ImportSessionType', id: string, status: string, provider: string, sourceFilename: string, sourceBytes: number, progressPct: number, errorMessage: string, operations: any, describeResult?: any | null, normalizerResult?: any | null, trackMatchResult?: any | null, lapPreview?: any | null, eventId?: string | null, deviceId?: string | null, resultEventDeviceId?: string | null, resultLogfileKey: string, suggestedEventStart?: string | null, createdAt: string, expiresAt: string }> };

export type ImportFormatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportFormatsQuery = { __typename?: 'AllQueriesWithSuperuser', importFormats: Array<{ __typename?: 'ImportFormatType', key: string, description: string, extensions: Array<string> }> };

export type CreateTelemetryImportMutationVariables = Exact<{
  deviceId: Scalars['UUID']['input'];
  fileName: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CreateTelemetryImportMutation = { __typename?: 'AllMutationsWithSuperuser', createTelemetryImport: { __typename?: 'CreateTelemetryImportResponseType', ok: boolean, uploadForm?: { __typename?: 'PresignedPostType', url: string, fields: Array<{ __typename?: 'PresignedPostFieldType', name: string, value: string }> } | null, telemetryImport?: { __typename?: 'TelemetryImportType', id: string } | null, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type TelemetryImportsQueryVariables = Exact<{
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TelemetryImportsQuery = { __typename?: 'AllQueriesWithSuperuser', telemetryImports: { __typename?: 'TelemetryImportTypePaginatedResponseType', items: Array<{ __typename?: 'TelemetryImportType', id: string, filename: string, status: string, statusDisplay: string, createdAt: string, eventDevice: { __typename?: 'EventDeviceType', id: string, event: { __typename?: 'EventType', name: string }, device: { __typename?: 'DeviceType', id: string, name: string, previewImageSmall?: string | null, previewImageMedium?: string | null } } }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type TelemetryImportQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TelemetryImportQuery = { __typename?: 'AllQueriesWithSuperuser', telemetryImportById: { __typename?: 'TelemetryImportType', id: string, filename: string, sourceFileExpiresAt?: string | null, sourceFileExpired: boolean, status: string, statusDisplay: string, createdAt: string, eventDevice: { __typename?: 'EventDeviceType', id: string, event: { __typename?: 'EventType', name: string } } } };

export type GenerateSourceFileDownloadLinkMutationVariables = Exact<{
  telemetryImportId: Scalars['UUID']['input'];
}>;


export type GenerateSourceFileDownloadLinkMutation = { __typename?: 'AllMutationsWithSuperuser', generateSourceFileDownloadLink: { __typename?: 'GenerateSourceFileDownloadLinkResponseType', ok: boolean, presignedUrl?: string | null, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type DeleteTelemetryImportMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteTelemetryImportMutation = { __typename?: 'AllMutationsWithSuperuser', deleteTelemetryImport: { __typename?: 'ResponseType', ok: boolean } };

export type SuperuserTelemetryImportsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuperuserTelemetryImportsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserTelemetryImports: { __typename?: 'TelemetryImportTypePaginatedResponseType', items: Array<{ __typename?: 'TelemetryImportType', id: string, status: string, statusDisplay: string, createdAt: string, eventDevice: { __typename?: 'EventDeviceType', id: string, event: { __typename?: 'EventType', name: string }, device: { __typename?: 'DeviceType', name: string, streamingKey: string } }, createdBy: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, email: string } }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type SuperuserTelemetryImportQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserTelemetryImportQuery = { __typename?: 'AllQueriesWithSuperuser', superuserTelemetryImportById: { __typename?: 'TelemetryImportType', id: string, filename: string, sourceFileExpiresAt?: string | null, sourceFileExpired: boolean, s3FileKey: string, status: string, statusDisplay: string, createdAt: string, eventDevice: { __typename?: 'EventDeviceType', id: string, event: { __typename?: 'EventType', name: string } }, createdBy: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string } } };

export type SuperuserGenerateTelemetryImportDownloadLinkMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserGenerateTelemetryImportDownloadLinkMutation = { __typename?: 'AllMutationsWithSuperuser', superuserGenerateTelemetryImportDownloadLink: { __typename?: 'GenerateTelemetryImportDownloadLinkResponseType', ok: boolean, presignedUrl?: string | null, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type SuperuserDeleteTelemetryImportMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserDeleteTelemetryImportMutation = { __typename?: 'AllMutationsWithSuperuser', superuserDeleteTelemetryImport: { __typename?: 'OkResponseType', ok: boolean } };

export type SuperuserRetryTelemetryImportMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserRetryTelemetryImportMutation = { __typename?: 'AllMutationsWithSuperuser', superuserRetryTelemetryImport: { __typename?: 'ResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type LapsQueryVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
}>;


export type LapsQuery = { __typename?: 'AllQueriesWithSuperuser', laps: Array<{ __typename?: 'LapType', id: string, lapNumber?: number | null, lapTime?: number | null, startTime: string, endTime: string, aggregates: any }> };

export type LapDataQueryVariables = Exact<{
  lapId: Scalars['UUID']['input'];
}>;


export type LapDataQuery = { __typename?: 'AllQueriesWithSuperuser', lapById: { __typename?: 'LapType', lapData: string } };

export type SuperuserLapsQueryVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
}>;


export type SuperuserLapsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserLaps: Array<{ __typename?: 'LapType', id: string, endTime: string, lapTime?: number | null }> };

export type SuperuserLapQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserLapQuery = { __typename?: 'AllQueriesWithSuperuser', superuserLap: { __typename?: 'LapType', id: string, startTime: string, endTime: string, lapTime?: number | null, aggregates: any, venue?: { __typename?: 'VenueType', id: string, name: string } | null } };

export type SuperuserEventDeviceLegacyStatusQueryVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
}>;


export type SuperuserEventDeviceLegacyStatusQuery = { __typename?: 'AllQueriesWithSuperuser', superuserEventDeviceLegacyStatus: { __typename?: 'SuperuserEventDeviceLegacyStatusType', isLegacy: boolean, legacyEventdeviceId?: number | null } };

export type SuperuserLegacyArchivesQueryVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
}>;


export type SuperuserLegacyArchivesQuery = { __typename?: 'AllQueriesWithSuperuser', superuserLegacyArchives: Array<{ __typename?: 'SuperuserLegacyArchiveType', path: string, start?: string | null, end?: string | null }> };

export type SuperuserGetLegacyArchiveDownloadLinkMutationVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
  path: Scalars['String']['input'];
}>;


export type SuperuserGetLegacyArchiveDownloadLinkMutation = { __typename?: 'AllMutationsWithSuperuser', superuserGetLegacyArchiveDownloadLink: { __typename?: 'SuperuserLegacyArchiveDownloadLinkResponseType', ok: boolean, downloadLink?: string | null } };

export type SuperuserSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperuserSummaryQuery = { __typename?: 'AllQueriesWithSuperuser', superuserSummary: { __typename?: 'SuperuserSummaryType', usersCount: number, devicesCount: number, eventsCount: number, lapsCount: number } };

export type OauthAuthorizationRequestQueryVariables = Exact<{
  request: Scalars['String']['input'];
}>;


export type OauthAuthorizationRequestQuery = { __typename?: 'AllQueriesWithSuperuser', oauthAuthorizationRequest: { __typename?: 'OAuthAuthorizationRequestResponseType', ok: boolean, error?: string | null, errorRedirectUri?: string | null, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, authorizationRequest?: { __typename?: 'OAuthAuthorizationRequestType', redirectUri: string, state?: string | null, application: { __typename?: 'OAuthApplicationPublicType', id: string, name: string, clientId: string, skipAuthorization: boolean, isSelfRegistered: boolean }, scopes: Array<{ __typename?: 'OAuthScopeType', key: string, label: string, description: string }> } | null } };

export type AuthorizeOauthApplicationMutationVariables = Exact<{
  request: Scalars['String']['input'];
  allow: Scalars['Boolean']['input'];
  scopes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AuthorizeOauthApplicationMutation = { __typename?: 'AllMutationsWithSuperuser', authorizeOauthApplication: { __typename?: 'AuthorizeOAuthApplicationResponseType', ok: boolean, error?: string | null, redirectUri?: string | null, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type OAuthApplicationFieldsFragment = { __typename?: 'OAuthApplicationType', id: string, name: string, clientId: string, clientType: OAuthClientType, allowedScopes: Array<string>, redirectUris: Array<string>, allowedOrigins: Array<string>, isActive: boolean, skipAuthorization: boolean, createdAt: string, account?: { __typename?: 'AccountType', id: string, name: string } | null };

export type OauthApplicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OauthApplicationsQuery = { __typename?: 'AllQueriesWithSuperuser', oauthApplications: Array<{ __typename?: 'OAuthApplicationType', id: string, name: string, clientId: string, clientType: OAuthClientType, allowedScopes: Array<string>, redirectUris: Array<string>, allowedOrigins: Array<string>, isActive: boolean, skipAuthorization: boolean, createdAt: string, account?: { __typename?: 'AccountType', id: string, name: string } | null }> };

export type AuthorizedOauthApplicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthorizedOauthApplicationsQuery = { __typename?: 'AllQueriesWithSuperuser', authorizedOauthApplications: Array<{ __typename?: 'AuthorizedOAuthApplicationType', scopes: Array<string>, authorizedAt?: string | null, application: { __typename?: 'OAuthApplicationPublicType', id: string, name: string, clientId: string, skipAuthorization: boolean } }> };

export type RegisterOauthApplicationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  redirectUris: Array<Scalars['String']['input']> | Scalars['String']['input'];
  allowedScopes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  clientType: OAuthClientType;
  allowedOrigins?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type RegisterOauthApplicationMutation = { __typename?: 'AllMutationsWithSuperuser', registerOauthApplication: { __typename?: 'RegisterOAuthApplicationResponseType', ok: boolean, clientSecret?: string | null, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, application?: { __typename?: 'OAuthApplicationType', id: string, name: string, clientId: string, clientType: OAuthClientType, allowedScopes: Array<string>, redirectUris: Array<string>, allowedOrigins: Array<string>, isActive: boolean, skipAuthorization: boolean, createdAt: string, account?: { __typename?: 'AccountType', id: string, name: string } | null } | null } };

export type UpdateOauthApplicationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  redirectUris?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  allowedScopes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  allowedOrigins?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdateOauthApplicationMutation = { __typename?: 'AllMutationsWithSuperuser', updateOauthApplication: { __typename?: 'OAuthApplicationResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, application?: { __typename?: 'OAuthApplicationType', id: string, name: string, clientId: string, clientType: OAuthClientType, allowedScopes: Array<string>, redirectUris: Array<string>, allowedOrigins: Array<string>, isActive: boolean, skipAuthorization: boolean, createdAt: string, account?: { __typename?: 'AccountType', id: string, name: string } | null } | null } };

export type DeleteOauthApplicationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteOauthApplicationMutation = { __typename?: 'AllMutationsWithSuperuser', deleteOauthApplication: { __typename?: 'OkResponseType', ok: boolean } };

export type RevokeOauthApplicationAccessMutationVariables = Exact<{
  applicationId: Scalars['UUID']['input'];
}>;


export type RevokeOauthApplicationAccessMutation = { __typename?: 'AllMutationsWithSuperuser', revokeOauthApplicationAccess: { __typename?: 'OkResponseType', ok: boolean } };

export type PresetTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type PresetTypesQuery = { __typename?: 'AllQueriesWithSuperuser', presetTypes: Array<{ __typename?: 'PresetTypeType', id: string, prettyName: string, description: string, typeKey: string }> };

export type SuperuserPresetTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperuserPresetTypesQuery = { __typename?: 'AllQueriesWithSuperuser', superuserPresetTypes: Array<{ __typename?: 'PresetTypeType', id: string, prettyName: string, description: string, typeKey: string }> };

export type SuperuserPresetTypeQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserPresetTypeQuery = { __typename?: 'AllQueriesWithSuperuser', superuserPresetTypeById: { __typename?: 'PresetTypeType', id: string, prettyName: string, description: string, typeKey: string } };

export type SuperuserDeletePresetTypeMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserDeletePresetTypeMutation = { __typename?: 'AllMutationsWithSuperuser', superuserDeletePresetType: { __typename?: 'ResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type SuperuserCreatePresetTypeMutationVariables = Exact<{
  prettyName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  typeKey: Scalars['String']['input'];
}>;


export type SuperuserCreatePresetTypeMutation = { __typename?: 'AllMutationsWithSuperuser', superuserCreatePresetType: { __typename?: 'SuperuserPresetTypeResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, presetType?: { __typename?: 'PresetTypeType', id: string } | null } };

export type SuperuserUpdatePresetTypeMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  prettyName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  typeKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type SuperuserUpdatePresetTypeMutation = { __typename?: 'AllMutationsWithSuperuser', superuserUpdatePresetType: { __typename?: 'SuperuserPresetTypeResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type PresetsQueryVariables = Exact<{ [key: string]: never; }>;


export type PresetsQuery = { __typename?: 'AllQueriesWithSuperuser', presets: Array<{ __typename?: 'PresetType', id: string, name: string, presetType: { __typename?: 'PresetTypeType', id: string, prettyName: string } }> };

export type PresetQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type PresetQuery = { __typename?: 'AllQueriesWithSuperuser', presetById: { __typename?: 'PresetType', id: string, name: string, notes: string, createdAt: string, presetData?: any | null, previewImageSmall?: string | null, previewImageMedium?: string | null, previewImageLarge?: string | null, presetType: { __typename?: 'PresetTypeType', id: string, prettyName: string } } };

export type CreatePresetMutationVariables = Exact<{
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  presetData: Scalars['String']['input'];
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  presetTypeId: Scalars['UUID']['input'];
}>;


export type CreatePresetMutation = { __typename?: 'AllMutationsWithSuperuser', createPreset: { __typename?: 'PresetResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, preset?: { __typename?: 'PresetType', id: string } | null } };

export type EditPresetMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  presetData?: InputMaybe<Scalars['String']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  presetTypeId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type EditPresetMutation = { __typename?: 'AllMutationsWithSuperuser', updatePreset: { __typename?: 'PresetResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type DeletePresetMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeletePresetMutation = { __typename?: 'AllMutationsWithSuperuser', deletePreset: { __typename?: 'OkResponseType', ok: boolean } };

export type SuperuserPresetsQueryVariables = Exact<{
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SuperuserPresetsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserPresets: { __typename?: 'PresetTypePaginatedResponseType', items: Array<{ __typename?: 'PresetType', id: string, name: string, isSystem: boolean, presetType: { __typename?: 'PresetTypeType', id: string, prettyName: string } }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number } } };

export type SuperuserPresetQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserPresetQuery = { __typename?: 'AllQueriesWithSuperuser', superuserPresetById: { __typename?: 'PresetType', id: string, name: string, notes: string, createdAt: string, presetData?: any | null, previewImageSmall?: string | null, previewImageMedium?: string | null, previewImageLarge?: string | null, presetType: { __typename?: 'PresetTypeType', id: string, prettyName: string } } };

export type SuperuserCreatePresetMutationVariables = Exact<{
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  presetData: Scalars['String']['input'];
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  presetTypeId: Scalars['UUID']['input'];
}>;


export type SuperuserCreatePresetMutation = { __typename?: 'AllMutationsWithSuperuser', superuserCreatePreset: { __typename?: 'SuperuserPresetResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, preset?: { __typename?: 'PresetType', id: string } | null } };

export type SuperuserEditPresetMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  presetData?: InputMaybe<Scalars['String']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  presetTypeId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SuperuserEditPresetMutation = { __typename?: 'AllMutationsWithSuperuser', superuserUpdatePreset: { __typename?: 'SuperuserPresetResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type SuperuserDeletePresetMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserDeletePresetMutation = { __typename?: 'AllMutationsWithSuperuser', superuserDeletePreset: { __typename?: 'OkResponseType', ok: boolean } };

export type SuperuserRedisHealthQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperuserRedisHealthQuery = { __typename?: 'AllQueriesWithSuperuser', superuserRedisHealth: { __typename?: 'SuperuserRedisHealthType', server: { __typename?: 'RedisServerType', usedMemory: number, totalSystemMemory?: number | null, maxmemory?: number | null, fragmentationRatio?: number | null, aofEnabled?: boolean | null, aofLastWriteStatus?: string | null, keys: number }, archiverLastPass?: { __typename?: 'ArchiverPassType', startedAt?: string | null, completedAt: string, elapsedMs?: number | null, devices?: number | null, flushed?: number | null, backlogged?: number | null, finished?: number | null, heldBack?: number | null, failed?: number | null, noMetadata?: number | null } | null, audit?: { __typename?: 'RedisAuditType', completedAt: string, totalKeys: number, families: Array<{ __typename?: 'RedisKeyFamilyType', family: string, keys: number, bytes: number }>, orphans: Array<{ __typename?: 'RedisOrphanType', eventDeviceId: string, category: string, rawKeys: number, summaryKeys: number, bytes: number, firstSampleAt?: string | null, lastSampleAt?: string | null }> } | null, eventDevices: Array<{ __typename?: 'RedisEventDeviceType', transport?: string | null, live: boolean, newestSampleAt?: string | null, frontierAt?: string | null, archiveCursorAt?: string | null, trimmedThroughAt?: string | null, verifiedCursorAt?: string | null, archiveLagSeconds?: number | null, state: string, bytes?: number | null, memoryMeasuredAt?: string | null, eventDevice: { __typename?: 'EventDeviceType', id: string, startTime: string, endTime: string, device: { __typename?: 'DeviceType', id: string, name: string }, event: { __typename?: 'EventType', id: string, name: string } }, held?: { __typename?: 'ArchiveHeldType', reason: string, message: string, since: string, updatedAt: string } | null }> } };

export type SuperuserEventDeviceRedisTimelineQueryVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
  startTime: Scalars['DateTime']['input'];
  endTime: Scalars['DateTime']['input'];
}>;


export type SuperuserEventDeviceRedisTimelineQuery = { __typename?: 'AllQueriesWithSuperuser', superuserEventDeviceRedisTimeline: { __typename?: 'SuperuserRedisTimelineType', transport?: string | null, bucketSeconds: number, startTime: string, endTime: string, markers: { __typename?: 'RedisTimelineMarkersType', newestSampleAt?: string | null, frontierAt?: string | null, archiveCursorAt?: string | null, trimmedThroughAt?: string | null, verifiedCursorAt?: string | null, windowStart?: string | null, windowEnd?: string | null }, buckets: Array<{ __typename?: 'RedisTimelineBucketType', startAt: string, endAt: string, state: string, received?: number | null, expected?: number | null, repairAttempts?: number | null }> } };

export type SubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionPlansQuery = { __typename?: 'AllQueriesWithSuperuser', subscriptionPlans: Array<{ __typename?: 'SubscriptionPlanType', id: string, name: string, prettyName: string, notes: string, priceMonth: number, priceYear: number, features: Array<{ __typename?: 'FeatureType', code: string }> }> };

export type FeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturesQuery = { __typename?: 'AllQueriesWithSuperuser', features: Array<{ __typename?: 'FeatureType', code: string, description: string }> };

export type ViewerEntitlementsQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerEntitlementsQuery = { __typename?: 'AllQueriesWithSuperuser', viewerFeatures: Array<string>, viewerAccountAttributes: Array<string> };

export type AccountSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSubscriptionQuery = { __typename?: 'AllQueriesWithSuperuser', accountSubscription?: { __typename?: 'AccountSubscriptionType', isManuallySet: boolean, stripeRenewalFailed: boolean, stripeCurrentPeriodEnd?: any | null, stripeCancelAtPeriodEnd: boolean, subscriptionPlan: { __typename?: 'SubscriptionPlanType', id: string, name: string, features: Array<{ __typename?: 'FeatureType', code: string }> } } | null };

export type SubscriptionManagmentSessionUrlMutationVariables = Exact<{
  subscriptionPlanId: Scalars['UUID']['input'];
  isMonthly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SubscriptionManagmentSessionUrlMutation = { __typename?: 'AllMutationsWithSuperuser', subscriptionManagmentSessionUrl: { __typename?: 'StripeSessionResponseType', ok: boolean, stripeSessionUrl: string } };

export type SuperuserUpdateAccountSubscriptionMutationVariables = Exact<{
  accountId: Scalars['UUID']['input'];
  subscriptionPlanId: Scalars['UUID']['input'];
}>;


export type SuperuserUpdateAccountSubscriptionMutation = { __typename?: 'AllMutationsWithSuperuser', superuserUpdateAccountSubscription: { __typename?: 'SuperuserAccountSubscriptionResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, accountSubscription?: { __typename?: 'AccountSubscriptionType', id: string, isManuallySet: boolean, stripeCurrentPeriodEnd?: any | null, subscriptionPlan: { __typename?: 'SubscriptionPlanType', id: string, name: string, prettyName: string } } | null } };

export type AdminPolicyDocumentsQueryVariables = Exact<{
  documentType?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminPolicyDocumentsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserPolicyDocuments: Array<{ __typename?: 'PolicyDocumentType', id: string, documentType: string, version: number, effectiveDate: any, isPublished: boolean, createdAt: string, updatedAt: string }> };

export type AdminPolicyDocumentQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AdminPolicyDocumentQuery = { __typename?: 'AllQueriesWithSuperuser', superuserPolicyDocument?: { __typename?: 'PolicyDocumentType', id: string, documentType: string, version: number, effectiveDate: any, body: string, isPublished: boolean, createdAt: string, updatedAt: string } | null };

export type AdminCreatePolicyDocumentMutationVariables = Exact<{
  documentType: Scalars['String']['input'];
  effectiveDate: Scalars['Date']['input'];
  body: Scalars['String']['input'];
}>;


export type AdminCreatePolicyDocumentMutation = { __typename?: 'AllMutationsWithSuperuser', superuserCreatePolicyDocument: { __typename?: 'SuperuserPolicyDocumentResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, document?: { __typename?: 'PolicyDocumentType', id: string, documentType: string, version: number } | null } };

export type AdminUpdatePolicyDocumentMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  body?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AdminUpdatePolicyDocumentMutation = { __typename?: 'AllMutationsWithSuperuser', superuserUpdatePolicyDocument: { __typename?: 'SuperuserPolicyDocumentResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, document?: { __typename?: 'PolicyDocumentType', id: string, version: number, isPublished: boolean } | null } };

export type AdminPublishPolicyDocumentMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AdminPublishPolicyDocumentMutation = { __typename?: 'AllMutationsWithSuperuser', superuserPublishPolicyDocument: { __typename?: 'SuperuserPolicyDocumentResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, document?: { __typename?: 'PolicyDocumentType', id: string, version: number, isPublished: boolean } | null } };

export type AdminUnpublishPolicyDocumentMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AdminUnpublishPolicyDocumentMutation = { __typename?: 'AllMutationsWithSuperuser', superuserUnpublishPolicyDocument: { __typename?: 'SuperuserPolicyDocumentResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, document?: { __typename?: 'PolicyDocumentType', id: string, version: number, isPublished: boolean } | null } };

export type AdminDeletePolicyDocumentMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AdminDeletePolicyDocumentMutation = { __typename?: 'AllMutationsWithSuperuser', superuserDeletePolicyDocument: { __typename?: 'ResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type AdminUpdateLegalEntitySettingsMutationVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  euRepresentative?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminUpdateLegalEntitySettingsMutation = { __typename?: 'AllMutationsWithSuperuser', superuserUpdateLegalEntitySettings: { __typename?: 'SuperuserLegalEntitySettingsResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, settings?: { __typename?: 'LegalEntitySettingsType', entityName: string, address: string, contactEmail: string, euRepresentative: string, updatedAt: string } | null } };

export type SuperuserEventDeviceTelemetrySummaryQueryVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
  channels?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  maxPoints?: Scalars['Int']['input'];
}>;


export type SuperuserEventDeviceTelemetrySummaryQuery = { __typename?: 'AllQueriesWithSuperuser', superuserEventDeviceTelemetrySummary?: { __typename?: 'EventDeviceTelemetrySummaryType', summaryData: string, source: string, bucketSeconds: number, verifiedThrough?: string | null } | null };

export type UserPreferenceFieldsFragment = { __typename?: 'UserPreferenceType', key: string, category: string, categoryLabel: string, label: string, description: string, value: string, isDefault: boolean, choices: Array<{ __typename?: 'UserPreferenceChoiceType', value: string, label: string }> };

export type PreferenceCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type PreferenceCategoriesQuery = { __typename?: 'AllQueriesWithSuperuser', preferenceCategories: Array<{ __typename?: 'UserPreferenceCategoryType', key: string, label: string, description: string }> };

export type MyPreferencesQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyPreferencesQuery = { __typename?: 'AllQueriesWithSuperuser', myPreferences: Array<{ __typename?: 'UserPreferenceType', key: string, category: string, categoryLabel: string, label: string, description: string, value: string, isDefault: boolean, choices: Array<{ __typename?: 'UserPreferenceChoiceType', value: string, label: string }> }> };

export type UpdateUserPreferenceMutationVariables = Exact<{
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
}>;


export type UpdateUserPreferenceMutation = { __typename?: 'AllMutationsWithSuperuser', updateUserPreference: { __typename?: 'UserPreferenceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, preference?: { __typename?: 'UserPreferenceType', key: string, category: string, categoryLabel: string, label: string, description: string, value: string, isDefault: boolean, choices: Array<{ __typename?: 'UserPreferenceChoiceType', value: string, label: string }> } | null } };

export type ResetUserPreferenceMutationVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type ResetUserPreferenceMutation = { __typename?: 'AllMutationsWithSuperuser', resetUserPreference: { __typename?: 'UserPreferenceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, preference?: { __typename?: 'UserPreferenceType', key: string, category: string, categoryLabel: string, label: string, description: string, value: string, isDefault: boolean, choices: Array<{ __typename?: 'UserPreferenceChoiceType', value: string, label: string }> } | null } };

export type NavbarMeQueryVariables = Exact<{ [key: string]: never; }>;


export type NavbarMeQuery = { __typename?: 'AllQueriesWithSuperuser', userMe: { __typename?: 'BaseUserType', id: string, firstName: string } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'AllQueriesWithSuperuser', userMe: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, email: string, isActive: boolean } };

export type MyProfileMeQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileMeQuery = { __typename?: 'AllQueriesWithSuperuser', userMe: { __typename?: 'BaseUserType', id: string, email: string, slug: string, firstName: string, lastName: string, bio: string, links: Array<string>, avatarSmall?: string | null, avatarMedium?: string | null, avatarLarge?: string | null, profilePictureSmall?: string | null, profilePictureMedium?: string | null, profilePictureLarge?: string | null } };

export type SignUpMutationVariables = Exact<{
  accountName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
  acceptedPolicies?: InputMaybe<Array<PolicyAcceptanceInput> | PolicyAcceptanceInput>;
  ageConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  marketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SignUpMutation = { __typename?: 'AllMutationsWithSuperuser', registerWithAccount: { __typename?: 'MutationNormalOutput', success: boolean, errors?: any | null } };

export type UpdateUserMeMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  profilePicture?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type UpdateUserMeMutation = { __typename?: 'AllMutationsWithSuperuser', updateUserMe: { __typename?: 'UserResponseType', user: { __typename?: 'BaseUserType', id: string, email: string, slug: string, firstName: string, lastName: string, bio: string, links: Array<string>, avatarSmall?: string | null, avatarMedium?: string | null, avatarLarge?: string | null, profilePictureSmall?: string | null, profilePictureMedium?: string | null, profilePictureLarge?: string | null } } };

export type UserListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserListQuery = { __typename?: 'AllQueriesWithSuperuser', superuserUsers: { __typename?: 'BaseUserTypePaginatedResponseType', items: Array<{ __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, email: string, lastLogin?: string | null, createdAt: string, isSuperuser: boolean, isActive: boolean, account: { __typename?: 'AccountType', subscriptionPlan: { __typename?: 'SubscriptionPlanType', prettyName: string } } }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number } } };

export type UserQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type UserQuery = { __typename?: 'AllQueriesWithSuperuser', superuserUserById: { __typename?: 'BaseUserType', id: string, email: string, lastLogin?: string | null, createdAt: string, firstName: string, lastName: string, links: Array<string>, isActive: boolean, isSuperuser: boolean, account: { __typename?: 'AccountType', id: string, name: string, subscriptionPlan: { __typename?: 'SubscriptionPlanType', id: string, name: string, prettyName: string } }, devices: Array<{ __typename?: 'DeviceType', id: string, name: string, createdAt: string }> } };

export type UserProfileQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type UserProfileQuery = { __typename?: 'AllQueriesWithSuperuser', userBySlug: { __typename?: 'PublicUserType', id: string, slug: string, firstName: string, lastName: string, bio: string, links: Array<string>, followersCount: number, followingCount: number, isFollowing: boolean, followsViewer: boolean, isViewer: boolean, createdAt: string, avatarSmall?: string | null, avatarMedium?: string | null, avatarLarge?: string | null, profilePictureSmall?: string | null, profilePictureMedium?: string | null, profilePictureLarge?: string | null } };

export type PublicUserFollowersQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PublicUserFollowersQuery = { __typename?: 'AllQueriesWithSuperuser', publicUserFollowers: { __typename?: 'PublicUserTypePaginatedResponseType', items: Array<{ __typename?: 'PublicUserType', id: string, slug: string, firstName: string, lastName: string, bio: string, followersCount: number, followingCount: number, isFollowing: boolean, followsViewer: boolean, isViewer: boolean, avatarSmall?: string | null, avatarMedium?: string | null, avatarLarge?: string | null }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type PublicUserFollowingQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PublicUserFollowingQuery = { __typename?: 'AllQueriesWithSuperuser', publicUserFollowing: { __typename?: 'PublicUserTypePaginatedResponseType', items: Array<{ __typename?: 'PublicUserType', id: string, slug: string, firstName: string, lastName: string, bio: string, followersCount: number, followingCount: number, isFollowing: boolean, followsViewer: boolean, isViewer: boolean, avatarSmall?: string | null, avatarMedium?: string | null, avatarLarge?: string | null }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type FollowUserMutationVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type FollowUserMutation = { __typename?: 'AllMutationsWithSuperuser', followUser: { __typename?: 'ResponseType', ok: boolean } };

export type UnfollowUserMutationVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type UnfollowUserMutation = { __typename?: 'AllMutationsWithSuperuser', unfollowUser: { __typename?: 'ResponseType', ok: boolean } };

export type SendPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendPasswordResetEmailMutation = { __typename?: 'AllMutationsWithSuperuser', sendPasswordResetEmail: { __typename?: 'MutationNormalOutput', success: boolean, errors?: any | null } };

export type ElevateUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ElevateUserMutation = { __typename?: 'AllMutationsWithSuperuser', superuserElevateUser: { __typename?: 'OkResponseType', ok: boolean } };

export type DowngradeUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DowngradeUserMutation = { __typename?: 'AllMutationsWithSuperuser', superuserDowngradeUser: { __typename?: 'OkResponseType', ok: boolean } };

export type DeactivateUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeactivateUserMutation = { __typename?: 'AllMutationsWithSuperuser', superuserDeactivateUser: { __typename?: 'SuperuserUserResponseType', ok: boolean } };

export type ReactivateUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ReactivateUserMutation = { __typename?: 'AllMutationsWithSuperuser', superuserReactivateUser: { __typename?: 'SuperuserUserResponseType', ok: boolean } };

export type CreateUserMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
}>;


export type CreateUserMutation = { __typename?: 'AllMutationsWithSuperuser', superuserCreateUser: { __typename?: 'SuperuserUserResponseType', ok: boolean, user?: { __typename?: 'BaseUserType', id: string, email: string, lastLogin?: string | null } | null, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type SuperuserUpdateUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  links?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SuperuserUpdateUserMutation = { __typename?: 'AllMutationsWithSuperuser', superuserUpdateUser: { __typename?: 'SuperuserUserResponseType', ok: boolean, user?: { __typename?: 'BaseUserType', id: string, email: string, firstName: string, lastName: string, links: Array<string> } | null, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'AllMutationsWithSuperuser', superuserDeleteUser: { __typename?: 'OkResponseType', ok: boolean } };

export type VenuesQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Array<LocationInputType> | LocationInputType>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type VenuesQuery = { __typename?: 'AllQueriesWithSuperuser', venues: { __typename?: 'VenueTypePaginatedResponseType', items: Array<{ __typename?: 'VenueType', id: string, name: string, configuration?: string | null, location?: any | null, country: string, countryName?: string | null, length?: number | null, trackMapThumbnail?: string | null }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type VenuesByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type VenuesByNameQuery = { __typename?: 'AllQueriesWithSuperuser', venuesByName: Array<{ __typename?: 'VenueType', id: string, name: string }> };

export type MyVenuesQueryVariables = Exact<{
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyVenuesQuery = { __typename?: 'AllQueriesWithSuperuser', myVenues: { __typename?: 'VenueTypePaginatedResponseType', items: Array<{ __typename?: 'VenueType', id: string, name: string, configuration?: string | null, country: string, countryName?: string | null, length?: number | null, trackMapThumbnail?: string | null }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type VenueQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type VenueQuery = { __typename?: 'AllQueriesWithSuperuser', venueById: { __typename?: 'VenueType', id: string, name: string, location?: any | null, country: string, countryName?: string | null, startFinish?: any | null, finish?: any | null, length?: number | null, trackMapThumbnail?: string | null, trackMap?: any | null, sectorPoints?: any | null, configuration?: string | null, minLapTime?: number | null, primarySectorScheme?: string | null, geometryVersion?: number | null, geometryAlgorithm?: string | null, geometryGeneratedAt?: string | null, geometryStale: boolean, sectorSchemes: Array<{ __typename?: 'SectorSchemeType', key: string, kind: string, label: string, generated: boolean, humanModified: boolean, algorithmVersion?: number | null, geometryVersion?: number | null, points: Array<{ __typename?: 'SectorPointType', id?: string | null, lat: number, lon: number, s?: number | null, label?: string | null }> }> } };

export type CreateVenueMutationVariables = Exact<{
  name: Scalars['String']['input'];
  location: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  startFinish?: InputMaybe<Scalars['String']['input']>;
  finish?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  trackMap?: InputMaybe<Scalars['String']['input']>;
  sectorPoints?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateVenueMutation = { __typename?: 'AllMutationsWithSuperuser', createVenue: { __typename?: 'VenueResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type EditVenueMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  location: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  startFinish?: InputMaybe<Scalars['String']['input']>;
  finish?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  trackMap?: InputMaybe<Scalars['String']['input']>;
  sectorPoints?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditVenueMutation = { __typename?: 'AllMutationsWithSuperuser', updateVenue: { __typename?: 'VenueResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type DeleteVenueMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteVenueMutation = { __typename?: 'AllMutationsWithSuperuser', deleteVenue: { __typename?: 'ResponseType', ok: boolean } };

export type VenueGeometryStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type VenueGeometryStatusQuery = { __typename?: 'AllQueriesWithSuperuser', superuserVenueGeometryStatus: { __typename?: 'VenueGeometryStatusType', totalWithTrackMap: number, stale: number } };

export type SectorSchemeFieldsFragment = { __typename?: 'SectorSchemeType', key: string, kind: string, label: string, generated: boolean, humanModified: boolean, algorithmVersion?: number | null, geometryVersion?: number | null, points: Array<{ __typename?: 'SectorPointType', id?: string | null, lat: number, lon: number, s?: number | null, label?: string | null }> };

export type UpdateVenueSectorSchemeMutationVariables = Exact<{
  venueId: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
  points: Array<SectorPointInput> | SectorPointInput;
  label?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateVenueSectorSchemeMutation = { __typename?: 'AllMutationsWithSuperuser', updateVenueSectorScheme: { __typename?: 'SectorSchemeResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, scheme?: { __typename?: 'SectorSchemeType', key: string, kind: string, label: string, generated: boolean, humanModified: boolean, algorithmVersion?: number | null, geometryVersion?: number | null, points: Array<{ __typename?: 'SectorPointType', id?: string | null, lat: number, lon: number, s?: number | null, label?: string | null }> } | null } };

export type RegenerateVenueSectorSchemeMutationVariables = Exact<{
  venueId: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
}>;


export type RegenerateVenueSectorSchemeMutation = { __typename?: 'AllMutationsWithSuperuser', regenerateVenueSectorScheme: { __typename?: 'SectorSchemeResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, scheme?: { __typename?: 'SectorSchemeType', key: string, kind: string, label: string, generated: boolean, humanModified: boolean, algorithmVersion?: number | null, geometryVersion?: number | null, points: Array<{ __typename?: 'SectorPointType', id?: string | null, lat: number, lon: number, s?: number | null, label?: string | null }> } | null } };

export type SetPrimarySectorSchemeMutationVariables = Exact<{
  venueId: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
}>;


export type SetPrimarySectorSchemeMutation = { __typename?: 'AllMutationsWithSuperuser', setPrimarySectorScheme: { __typename?: 'SectorSchemeResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, scheme?: { __typename?: 'SectorSchemeType', key: string } | null } };

export type CreateVenueSectorSchemeMutationVariables = Exact<{
  venueId: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  copyFrom?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateVenueSectorSchemeMutation = { __typename?: 'AllMutationsWithSuperuser', createVenueSectorScheme: { __typename?: 'SectorSchemeResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, scheme?: { __typename?: 'SectorSchemeType', key: string, kind: string, label: string, generated: boolean, humanModified: boolean, algorithmVersion?: number | null, geometryVersion?: number | null, points: Array<{ __typename?: 'SectorPointType', id?: string | null, lat: number, lon: number, s?: number | null, label?: string | null }> } | null } };

export type DeleteVenueSectorSchemeMutationVariables = Exact<{
  venueId: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
}>;


export type DeleteVenueSectorSchemeMutation = { __typename?: 'AllMutationsWithSuperuser', deleteVenueSectorScheme: { __typename?: 'ResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type SuperuserRegenerateVenueGeometryMutationVariables = Exact<{
  limit: Scalars['Int']['input'];
  force: Scalars['Boolean']['input'];
}>;


export type SuperuserRegenerateVenueGeometryMutation = { __typename?: 'AllMutationsWithSuperuser', superuserRegenerateVenueGeometry: { __typename?: 'VenueGeometryRegenResponseType', processed: number, remaining: number, results: Array<{ __typename?: 'VenueGeometryRegenResultType', venueId: string, name: string, status: string, message?: string | null }> } };

export type VideoViewerAccessQueryVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
  preferHls: Scalars['Boolean']['input'];
}>;


export type VideoViewerAccessQuery = { __typename?: 'AllQueriesWithSuperuser', videoViewerAccess: { __typename?: 'VideoViewerAccessType', mode: VideoViewerMode, signalingUrl?: string | null, viewerToken?: string | null, liveDelayHintSec?: number | null, tracks?: Array<{ __typename?: 'VideoHlsTrackType', cameraName: string, playlistUrl: string }> | null } };

export type VideoStreamSessionsQueryVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
  overlapsStart?: InputMaybe<Scalars['DateTime']['input']>;
  overlapsEnd?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type VideoStreamSessionsQuery = { __typename?: 'AllQueriesWithSuperuser', videoStreamSessions: Array<{ __typename?: 'VideoStreamSessionType', id: string, sessionKey: string, status: string, startedAt: string, endedAt?: string | null, tracks: Array<{ __typename?: 'VideoTrackType', cameraName: string, role: string, vodPlaylistKey: string, livePlaylistKey: string, firstPdt?: string | null, lastPdt?: string | null, segmentDurationMs: number, segmentCount: number }> }> };

export type WorkspaceEventDeviceFieldsFragment = { __typename?: 'WorkspaceEventDeviceType', id: string, position: number, available: boolean, venueMismatch: boolean, live: boolean, liveSlot?: number | null, label?: string | null, eventDevice?: { __typename?: 'PodiumEventDeviceType', id: string, startTime: string, endTime: string, metadata: any, processorInstanceHost: string, device: { __typename?: 'DeviceType', id: string, name: string, isPrivate: boolean, isOwner: boolean }, event: { __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isOwner: boolean } } | null };

export type WorkspaceFieldsFragment = { __typename?: 'WorkspaceType', id: string, name: string, screens: any, createdAt: string, updatedAt: string, lastOpenedAt: string, deviceCount: number, locked: boolean, maxLaps: number, maxLiveSessions: number, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null, length?: number | null, trackMap?: any | null, startFinish?: any | null, finish?: any | null } | null, eventDevices: Array<{ __typename?: 'WorkspaceEventDeviceType', id: string, position: number, available: boolean, venueMismatch: boolean, live: boolean, liveSlot?: number | null, label?: string | null, eventDevice?: { __typename?: 'PodiumEventDeviceType', id: string, startTime: string, endTime: string, metadata: any, processorInstanceHost: string, device: { __typename?: 'DeviceType', id: string, name: string, isPrivate: boolean, isOwner: boolean }, event: { __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isOwner: boolean } } | null }>, laps: Array<{ __typename?: 'WorkspaceLapType', id: string, position: number, eventDeviceId: string, workspaceEventDeviceId: string, lap: { __typename?: 'LapType', id: string, lapNumber?: number | null, lapTime?: number | null, startTime: string, endTime: string } }> };

export type WorkspaceAlternativeFieldsFragment = { __typename?: 'WorkspaceAlternativeType', id: string, name: string, lastOpenedAt: string, alreadyContains: boolean, sameVenue: boolean, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null } | null };

export type MyWorkspacesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyWorkspacesQuery = { __typename?: 'AllQueriesWithSuperuser', myWorkspaces: Array<{ __typename?: 'WorkspaceType', id: string, name: string, lastOpenedAt: string, deviceCount: number, locked: boolean, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null, trackMapThumbnail?: string | null } | null, eventDevices: Array<{ __typename?: 'WorkspaceEventDeviceType', id: string, available: boolean, venueMismatch: boolean, label?: string | null, eventDevice?: { __typename?: 'PodiumEventDeviceType', id: string, device: { __typename?: 'DeviceType', id: string, name: string }, event: { __typename?: 'PodiumEventType', id: string, name: string, startAt: string } } | null }>, laps: Array<{ __typename?: 'WorkspaceLapType', id: string, workspaceEventDeviceId: string }> }> };

export type WorkspaceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type WorkspaceQuery = { __typename?: 'AllQueriesWithSuperuser', workspace: { __typename?: 'WorkspaceType', id: string, name: string, screens: any, createdAt: string, updatedAt: string, lastOpenedAt: string, deviceCount: number, locked: boolean, maxLaps: number, maxLiveSessions: number, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null, length?: number | null, trackMap?: any | null, startFinish?: any | null, finish?: any | null } | null, eventDevices: Array<{ __typename?: 'WorkspaceEventDeviceType', id: string, position: number, available: boolean, venueMismatch: boolean, live: boolean, liveSlot?: number | null, label?: string | null, eventDevice?: { __typename?: 'PodiumEventDeviceType', id: string, startTime: string, endTime: string, metadata: any, processorInstanceHost: string, device: { __typename?: 'DeviceType', id: string, name: string, isPrivate: boolean, isOwner: boolean }, event: { __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isOwner: boolean } } | null }>, laps: Array<{ __typename?: 'WorkspaceLapType', id: string, position: number, eventDeviceId: string, workspaceEventDeviceId: string, lap: { __typename?: 'LapType', id: string, lapNumber?: number | null, lapTime?: number | null, startTime: string, endTime: string } }> } };

export type WorkspacesForEventDeviceQueryVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
}>;


export type WorkspacesForEventDeviceQuery = { __typename?: 'AllQueriesWithSuperuser', workspacesForEventDevice: Array<{ __typename?: 'WorkspaceAlternativeType', id: string, name: string, lastOpenedAt: string, alreadyContains: boolean, sameVenue: boolean, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null } | null }> };

export type AnalyzeEventDeviceMutationVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
}>;


export type AnalyzeEventDeviceMutation = { __typename?: 'AllMutationsWithSuperuser', analyzeEventDevice: { __typename?: 'AnalyzeEventDeviceResponseType', ok: boolean, created: boolean, added: boolean, followedLive: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, workspace?: { __typename?: 'WorkspaceType', id: string, name: string, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null } | null } | null, alternatives: Array<{ __typename?: 'WorkspaceAlternativeType', id: string, name: string, lastOpenedAt: string, alreadyContains: boolean, sameVenue: boolean, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null } | null }> } };

export type CreateWorkspaceMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  venueId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CreateWorkspaceMutation = { __typename?: 'AllMutationsWithSuperuser', createWorkspace: { __typename?: 'WorkspaceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, workspace?: { __typename?: 'WorkspaceType', id: string, name: string, venue?: { __typename?: 'VenueType', id: string } | null } | null } };

export type RenameWorkspaceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameWorkspaceMutation = { __typename?: 'AllMutationsWithSuperuser', renameWorkspace: { __typename?: 'WorkspaceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, workspace?: { __typename?: 'WorkspaceType', id: string, name: string } | null } };

export type DeleteWorkspaceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteWorkspaceMutation = { __typename?: 'AllMutationsWithSuperuser', deleteWorkspace: { __typename?: 'ResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type TouchWorkspaceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TouchWorkspaceMutation = { __typename?: 'AllMutationsWithSuperuser', touchWorkspace: { __typename?: 'WorkspaceResponseType', ok: boolean } };

export type AddWorkspaceEventDeviceMutationVariables = Exact<{
  workspaceId: Scalars['UUID']['input'];
  eventDeviceId: Scalars['UUID']['input'];
}>;


export type AddWorkspaceEventDeviceMutation = { __typename?: 'AllMutationsWithSuperuser', addWorkspaceEventDevice: { __typename?: 'WorkspaceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, workspace?: { __typename?: 'WorkspaceType', id: string, name: string } | null } };

export type AddEventDeviceToWorkspacesMutationVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
  workspaceIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type AddEventDeviceToWorkspacesMutation = { __typename?: 'AllMutationsWithSuperuser', addEventDeviceToWorkspaces: { __typename?: 'WorkspacesResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, workspaces: Array<{ __typename?: 'WorkspaceType', id: string, name: string }> } };

export type RemoveWorkspaceEventDeviceMutationVariables = Exact<{
  workspaceId: Scalars['UUID']['input'];
  workspaceEventDeviceId: Scalars['UUID']['input'];
}>;


export type RemoveWorkspaceEventDeviceMutation = { __typename?: 'AllMutationsWithSuperuser', removeWorkspaceEventDevice: { __typename?: 'WorkspaceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, workspace?: { __typename?: 'WorkspaceType', id: string, name: string, screens: any, createdAt: string, updatedAt: string, lastOpenedAt: string, deviceCount: number, locked: boolean, maxLaps: number, maxLiveSessions: number, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null, length?: number | null, trackMap?: any | null, startFinish?: any | null, finish?: any | null } | null, eventDevices: Array<{ __typename?: 'WorkspaceEventDeviceType', id: string, position: number, available: boolean, venueMismatch: boolean, live: boolean, liveSlot?: number | null, label?: string | null, eventDevice?: { __typename?: 'PodiumEventDeviceType', id: string, startTime: string, endTime: string, metadata: any, processorInstanceHost: string, device: { __typename?: 'DeviceType', id: string, name: string, isPrivate: boolean, isOwner: boolean }, event: { __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isOwner: boolean } } | null }>, laps: Array<{ __typename?: 'WorkspaceLapType', id: string, position: number, eventDeviceId: string, workspaceEventDeviceId: string, lap: { __typename?: 'LapType', id: string, lapNumber?: number | null, lapTime?: number | null, startTime: string, endTime: string } }> } | null } };

export type LabelWorkspaceEventDeviceMutationVariables = Exact<{
  workspaceId: Scalars['UUID']['input'];
  workspaceEventDeviceId: Scalars['UUID']['input'];
  label: Scalars['String']['input'];
}>;


export type LabelWorkspaceEventDeviceMutation = { __typename?: 'AllMutationsWithSuperuser', labelWorkspaceEventDevice: { __typename?: 'WorkspaceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, workspace?: { __typename?: 'WorkspaceType', id: string, name: string, screens: any, createdAt: string, updatedAt: string, lastOpenedAt: string, deviceCount: number, locked: boolean, maxLaps: number, maxLiveSessions: number, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null, length?: number | null, trackMap?: any | null, startFinish?: any | null, finish?: any | null } | null, eventDevices: Array<{ __typename?: 'WorkspaceEventDeviceType', id: string, position: number, available: boolean, venueMismatch: boolean, live: boolean, liveSlot?: number | null, label?: string | null, eventDevice?: { __typename?: 'PodiumEventDeviceType', id: string, startTime: string, endTime: string, metadata: any, processorInstanceHost: string, device: { __typename?: 'DeviceType', id: string, name: string, isPrivate: boolean, isOwner: boolean }, event: { __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isOwner: boolean } } | null }>, laps: Array<{ __typename?: 'WorkspaceLapType', id: string, position: number, eventDeviceId: string, workspaceEventDeviceId: string, lap: { __typename?: 'LapType', id: string, lapNumber?: number | null, lapTime?: number | null, startTime: string, endTime: string } }> } | null } };

export type SetWorkspaceEventDeviceLiveMutationVariables = Exact<{
  workspaceId: Scalars['UUID']['input'];
  eventDeviceId: Scalars['UUID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SetWorkspaceEventDeviceLiveMutation = { __typename?: 'AllMutationsWithSuperuser', setWorkspaceEventDeviceLive: { __typename?: 'WorkspaceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, workspace?: { __typename?: 'WorkspaceType', id: string, name: string, screens: any, createdAt: string, updatedAt: string, lastOpenedAt: string, deviceCount: number, locked: boolean, maxLaps: number, maxLiveSessions: number, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null, length?: number | null, trackMap?: any | null, startFinish?: any | null, finish?: any | null } | null, eventDevices: Array<{ __typename?: 'WorkspaceEventDeviceType', id: string, position: number, available: boolean, venueMismatch: boolean, live: boolean, liveSlot?: number | null, label?: string | null, eventDevice?: { __typename?: 'PodiumEventDeviceType', id: string, startTime: string, endTime: string, metadata: any, processorInstanceHost: string, device: { __typename?: 'DeviceType', id: string, name: string, isPrivate: boolean, isOwner: boolean }, event: { __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isOwner: boolean } } | null }>, laps: Array<{ __typename?: 'WorkspaceLapType', id: string, position: number, eventDeviceId: string, workspaceEventDeviceId: string, lap: { __typename?: 'LapType', id: string, lapNumber?: number | null, lapTime?: number | null, startTime: string, endTime: string } }> } | null } };

export type SelectWorkspaceLapMutationVariables = Exact<{
  workspaceId: Scalars['UUID']['input'];
  lapId: Scalars['UUID']['input'];
}>;


export type SelectWorkspaceLapMutation = { __typename?: 'AllMutationsWithSuperuser', selectWorkspaceLap: { __typename?: 'WorkspaceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, workspace?: { __typename?: 'WorkspaceType', id: string, name: string, screens: any, createdAt: string, updatedAt: string, lastOpenedAt: string, deviceCount: number, locked: boolean, maxLaps: number, maxLiveSessions: number, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null, length?: number | null, trackMap?: any | null, startFinish?: any | null, finish?: any | null } | null, eventDevices: Array<{ __typename?: 'WorkspaceEventDeviceType', id: string, position: number, available: boolean, venueMismatch: boolean, live: boolean, liveSlot?: number | null, label?: string | null, eventDevice?: { __typename?: 'PodiumEventDeviceType', id: string, startTime: string, endTime: string, metadata: any, processorInstanceHost: string, device: { __typename?: 'DeviceType', id: string, name: string, isPrivate: boolean, isOwner: boolean }, event: { __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isOwner: boolean } } | null }>, laps: Array<{ __typename?: 'WorkspaceLapType', id: string, position: number, eventDeviceId: string, workspaceEventDeviceId: string, lap: { __typename?: 'LapType', id: string, lapNumber?: number | null, lapTime?: number | null, startTime: string, endTime: string } }> } | null } };

export type DeselectWorkspaceLapMutationVariables = Exact<{
  workspaceId: Scalars['UUID']['input'];
  lapId: Scalars['UUID']['input'];
}>;


export type DeselectWorkspaceLapMutation = { __typename?: 'AllMutationsWithSuperuser', deselectWorkspaceLap: { __typename?: 'WorkspaceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, workspace?: { __typename?: 'WorkspaceType', id: string, name: string, screens: any, createdAt: string, updatedAt: string, lastOpenedAt: string, deviceCount: number, locked: boolean, maxLaps: number, maxLiveSessions: number, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null, length?: number | null, trackMap?: any | null, startFinish?: any | null, finish?: any | null } | null, eventDevices: Array<{ __typename?: 'WorkspaceEventDeviceType', id: string, position: number, available: boolean, venueMismatch: boolean, live: boolean, liveSlot?: number | null, label?: string | null, eventDevice?: { __typename?: 'PodiumEventDeviceType', id: string, startTime: string, endTime: string, metadata: any, processorInstanceHost: string, device: { __typename?: 'DeviceType', id: string, name: string, isPrivate: boolean, isOwner: boolean }, event: { __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isOwner: boolean } } | null }>, laps: Array<{ __typename?: 'WorkspaceLapType', id: string, position: number, eventDeviceId: string, workspaceEventDeviceId: string, lap: { __typename?: 'LapType', id: string, lapNumber?: number | null, lapTime?: number | null, startTime: string, endTime: string } }> } | null } };

export type SetWorkspaceScreensMutationVariables = Exact<{
  workspaceId: Scalars['UUID']['input'];
  screens: Scalars['JSON']['input'];
}>;


export type SetWorkspaceScreensMutation = { __typename?: 'AllMutationsWithSuperuser', setWorkspaceScreens: { __typename?: 'WorkspaceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type ApplyCollectionToWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['UUID']['input'];
  presetId: Scalars['UUID']['input'];
}>;


export type ApplyCollectionToWorkspaceMutation = { __typename?: 'AllMutationsWithSuperuser', applyCollectionToWorkspace: { __typename?: 'WorkspaceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, workspace?: { __typename?: 'WorkspaceType', id: string, name: string, screens: any, createdAt: string, updatedAt: string, lastOpenedAt: string, deviceCount: number, locked: boolean, maxLaps: number, maxLiveSessions: number, venue?: { __typename?: 'VenueType', id: string, name: string, configuration?: string | null, length?: number | null, trackMap?: any | null, startFinish?: any | null, finish?: any | null } | null, eventDevices: Array<{ __typename?: 'WorkspaceEventDeviceType', id: string, position: number, available: boolean, venueMismatch: boolean, live: boolean, liveSlot?: number | null, label?: string | null, eventDevice?: { __typename?: 'PodiumEventDeviceType', id: string, startTime: string, endTime: string, metadata: any, processorInstanceHost: string, device: { __typename?: 'DeviceType', id: string, name: string, isPrivate: boolean, isOwner: boolean }, event: { __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isOwner: boolean } } | null }>, laps: Array<{ __typename?: 'WorkspaceLapType', id: string, position: number, eventDeviceId: string, workspaceEventDeviceId: string, lap: { __typename?: 'LapType', id: string, lapNumber?: number | null, lapTime?: number | null, startTime: string, endTime: string } }> } | null } };

export type WorkspaceQuotaQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspaceQuotaQuery = { __typename?: 'AllQueriesWithSuperuser', workspaceQuota: { __typename?: 'WorkspaceQuotaType', limit?: number | null, used: number, canCreate: boolean } };

export const ApiKeyFieldsFragmentDoc = gql`
    fragment ApiKeyFields on ApiKeyType {
  id
  name
  keyPrefix
  scopes
  isActive
  createdAt
  lastUsedAt
  revokedAt
  account {
    id
    name
  }
}
    `;
export const EventCardFieldsFragmentDoc = gql`
    fragment EventCardFields on PodiumEventType {
  id
  name
  startAt
  endAt
  isPrivate
  isLive
  venue {
    id
    name
    country
    countryName
    length
    minLapTime
    trackMapThumbnail
  }
  createdBy {
    id
    slug
    firstName
    lastName
    avatarSmall
    profilePictureLarge
  }
}
    `;
export const ImportSessionFieldsFragmentDoc = gql`
    fragment ImportSessionFields on ImportSessionType {
  id
  status
  provider
  sourceFilename
  sourceBytes
  progressPct
  errorMessage
  operations
  describeResult
  normalizerResult
  trackMatchResult
  lapPreview
  eventId
  deviceId
  resultEventDeviceId
  resultLogfileKey
  suggestedEventStart
  createdAt
  expiresAt
}
    `;
export const OAuthApplicationFieldsFragmentDoc = gql`
    fragment OAuthApplicationFields on OAuthApplicationType {
  id
  name
  clientId
  clientType
  allowedScopes
  redirectUris
  allowedOrigins
  isActive
  skipAuthorization
  createdAt
  account {
    id
    name
  }
}
    `;
export const UserPreferenceFieldsFragmentDoc = gql`
    fragment UserPreferenceFields on UserPreferenceType {
  key
  category
  categoryLabel
  label
  description
  choices {
    value
    label
  }
  value
  isDefault
}
    `;
export const SectorSchemeFieldsFragmentDoc = gql`
    fragment SectorSchemeFields on SectorSchemeType {
  key
  kind
  label
  generated
  humanModified
  algorithmVersion
  geometryVersion
  points {
    id
    lat
    lon
    s
    label
  }
}
    `;
export const WorkspaceEventDeviceFieldsFragmentDoc = gql`
    fragment WorkspaceEventDeviceFields on WorkspaceEventDeviceType {
  id
  position
  available
  venueMismatch
  live
  liveSlot
  label
  eventDevice {
    id
    startTime
    endTime
    metadata
    processorInstanceHost
    device {
      id
      name
      isPrivate
      isOwner
    }
    event {
      id
      name
      startAt
      endAt
      isOwner
    }
  }
}
    `;
export const WorkspaceFieldsFragmentDoc = gql`
    fragment WorkspaceFields on WorkspaceType {
  id
  name
  screens
  createdAt
  updatedAt
  lastOpenedAt
  deviceCount
  locked
  maxLaps
  maxLiveSessions
  venue {
    id
    name
    configuration
    length
    trackMap
    startFinish
    finish
  }
  eventDevices {
    ...WorkspaceEventDeviceFields
  }
  laps {
    id
    position
    eventDeviceId
    workspaceEventDeviceId
    lap {
      id
      lapNumber
      lapTime
      startTime
      endTime
    }
  }
}
    ${WorkspaceEventDeviceFieldsFragmentDoc}`;
export const WorkspaceAlternativeFieldsFragmentDoc = gql`
    fragment WorkspaceAlternativeFields on WorkspaceAlternativeType {
  id
  name
  lastOpenedAt
  alreadyContains
  sameVenue
  venue {
    id
    name
    configuration
  }
}
    `;
export const MyAccountDocument = gql`
    query MyAccount {
  myAccount {
    name
    notes
    subscriptionPlan {
      prettyName
    }
  }
}
    `;

/**
 * __useMyAccountQuery__
 *
 * To run a query within a React component, call `useMyAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAccountQuery(baseOptions?: Apollo.QueryHookOptions<MyAccountQuery, MyAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAccountQuery, MyAccountQueryVariables>(MyAccountDocument, options);
      }
export function useMyAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAccountQuery, MyAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAccountQuery, MyAccountQueryVariables>(MyAccountDocument, options);
        }
export type MyAccountQueryHookResult = ReturnType<typeof useMyAccountQuery>;
export type MyAccountLazyQueryHookResult = ReturnType<typeof useMyAccountLazyQuery>;
export type MyAccountQueryResult = Apollo.QueryResult<MyAccountQuery, MyAccountQueryVariables>;
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($name: String, $notes: String) {
  updateAccount(name: $name, notes: $notes) {
    ok
  }
}
    `;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const ResendActivationEmailDocument = gql`
    mutation ResendActivationEmail($email: String!) {
  resendActivationEmail(email: $email) {
    success
    errors
  }
}
    `;
export type ResendActivationEmailMutationFn = Apollo.MutationFunction<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>;

/**
 * __useResendActivationEmailMutation__
 *
 * To run a mutation, you first call `useResendActivationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendActivationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendActivationEmailMutation, { data, loading, error }] = useResendActivationEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendActivationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>(ResendActivationEmailDocument, options);
      }
export type ResendActivationEmailMutationHookResult = ReturnType<typeof useResendActivationEmailMutation>;
export type ResendActivationEmailMutationResult = Apollo.MutationResult<ResendActivationEmailMutation>;
export type ResendActivationEmailMutationOptions = Apollo.BaseMutationOptions<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>;
export const AccountDocument = gql`
    query Account($id: UUID!) {
  superuserAccountById(id: $id) {
    id
    name
    notes
    subscriptionPlan {
      prettyName
    }
    devices {
      id
      name
      createdAt
    }
  }
}
    `;

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountQuery(baseOptions: Apollo.QueryHookOptions<AccountQuery, AccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
      }
export function useAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountQuery, AccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
        }
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountQueryResult = Apollo.QueryResult<AccountQuery, AccountQueryVariables>;
export const AdminAccountAttributesDocument = gql`
    query AdminAccountAttributes($accountId: UUID!) {
  superuserAccountAttributes(accountId: $accountId) {
    key
    label
    description
    enabled
    defaultEnabled
  }
}
    `;

/**
 * __useAdminAccountAttributesQuery__
 *
 * To run a query within a React component, call `useAdminAccountAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAccountAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAccountAttributesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAdminAccountAttributesQuery(baseOptions: Apollo.QueryHookOptions<AdminAccountAttributesQuery, AdminAccountAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminAccountAttributesQuery, AdminAccountAttributesQueryVariables>(AdminAccountAttributesDocument, options);
      }
export function useAdminAccountAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminAccountAttributesQuery, AdminAccountAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminAccountAttributesQuery, AdminAccountAttributesQueryVariables>(AdminAccountAttributesDocument, options);
        }
export type AdminAccountAttributesQueryHookResult = ReturnType<typeof useAdminAccountAttributesQuery>;
export type AdminAccountAttributesLazyQueryHookResult = ReturnType<typeof useAdminAccountAttributesLazyQuery>;
export type AdminAccountAttributesQueryResult = Apollo.QueryResult<AdminAccountAttributesQuery, AdminAccountAttributesQueryVariables>;
export const AdminSetAccountAttributesDocument = gql`
    mutation AdminSetAccountAttributes($accountId: UUID!, $attributes: [AccountAttributeInput!]!) {
  superuserSetAccountAttributes(accountId: $accountId, attributes: $attributes) {
    ok
    errors {
      field
      message
    }
    attributes {
      key
      enabled
    }
  }
}
    `;
export type AdminSetAccountAttributesMutationFn = Apollo.MutationFunction<AdminSetAccountAttributesMutation, AdminSetAccountAttributesMutationVariables>;

/**
 * __useAdminSetAccountAttributesMutation__
 *
 * To run a mutation, you first call `useAdminSetAccountAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetAccountAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetAccountAttributesMutation, { data, loading, error }] = useAdminSetAccountAttributesMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAdminSetAccountAttributesMutation(baseOptions?: Apollo.MutationHookOptions<AdminSetAccountAttributesMutation, AdminSetAccountAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSetAccountAttributesMutation, AdminSetAccountAttributesMutationVariables>(AdminSetAccountAttributesDocument, options);
      }
export type AdminSetAccountAttributesMutationHookResult = ReturnType<typeof useAdminSetAccountAttributesMutation>;
export type AdminSetAccountAttributesMutationResult = Apollo.MutationResult<AdminSetAccountAttributesMutation>;
export type AdminSetAccountAttributesMutationOptions = Apollo.BaseMutationOptions<AdminSetAccountAttributesMutation, AdminSetAccountAttributesMutationVariables>;
export const AdminUpdateAccountDocument = gql`
    mutation AdminUpdateAccount($id: UUID!, $name: String, $notes: String) {
  superuserUpdateAccount(id: $id, name: $name, notes: $notes) {
    ok
    account {
      id
      name
      notes
    }
  }
}
    `;
export type AdminUpdateAccountMutationFn = Apollo.MutationFunction<AdminUpdateAccountMutation, AdminUpdateAccountMutationVariables>;

/**
 * __useAdminUpdateAccountMutation__
 *
 * To run a mutation, you first call `useAdminUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateAccountMutation, { data, loading, error }] = useAdminUpdateAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useAdminUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateAccountMutation, AdminUpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateAccountMutation, AdminUpdateAccountMutationVariables>(AdminUpdateAccountDocument, options);
      }
export type AdminUpdateAccountMutationHookResult = ReturnType<typeof useAdminUpdateAccountMutation>;
export type AdminUpdateAccountMutationResult = Apollo.MutationResult<AdminUpdateAccountMutation>;
export type AdminUpdateAccountMutationOptions = Apollo.BaseMutationOptions<AdminUpdateAccountMutation, AdminUpdateAccountMutationVariables>;
export const AlertMessagesDocument = gql`
    query AlertMessages($eventDeviceId: UUID!) {
  alertMessages(eventDeviceId: $eventDeviceId) {
    id
    message
    sendTime
    ackTime
    sender {
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useAlertMessagesQuery__
 *
 * To run a query within a React component, call `useAlertMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertMessagesQuery({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *   },
 * });
 */
export function useAlertMessagesQuery(baseOptions: Apollo.QueryHookOptions<AlertMessagesQuery, AlertMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertMessagesQuery, AlertMessagesQueryVariables>(AlertMessagesDocument, options);
      }
export function useAlertMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertMessagesQuery, AlertMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertMessagesQuery, AlertMessagesQueryVariables>(AlertMessagesDocument, options);
        }
export type AlertMessagesQueryHookResult = ReturnType<typeof useAlertMessagesQuery>;
export type AlertMessagesLazyQueryHookResult = ReturnType<typeof useAlertMessagesLazyQuery>;
export type AlertMessagesQueryResult = Apollo.QueryResult<AlertMessagesQuery, AlertMessagesQueryVariables>;
export const ApiKeysDocument = gql`
    query ApiKeys {
  apiKeys {
    ...ApiKeyFields
  }
}
    ${ApiKeyFieldsFragmentDoc}`;

/**
 * __useApiKeysQuery__
 *
 * To run a query within a React component, call `useApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
      }
export function useApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
export type ApiKeysQueryHookResult = ReturnType<typeof useApiKeysQuery>;
export type ApiKeysLazyQueryHookResult = ReturnType<typeof useApiKeysLazyQuery>;
export type ApiKeysQueryResult = Apollo.QueryResult<ApiKeysQuery, ApiKeysQueryVariables>;
export const ApiKeyScopesDocument = gql`
    query ApiKeyScopes {
  apiKeyScopes {
    key
    label
    description
  }
}
    `;

/**
 * __useApiKeyScopesQuery__
 *
 * To run a query within a React component, call `useApiKeyScopesQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeyScopesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeyScopesQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiKeyScopesQuery(baseOptions?: Apollo.QueryHookOptions<ApiKeyScopesQuery, ApiKeyScopesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeyScopesQuery, ApiKeyScopesQueryVariables>(ApiKeyScopesDocument, options);
      }
export function useApiKeyScopesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeyScopesQuery, ApiKeyScopesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeyScopesQuery, ApiKeyScopesQueryVariables>(ApiKeyScopesDocument, options);
        }
export type ApiKeyScopesQueryHookResult = ReturnType<typeof useApiKeyScopesQuery>;
export type ApiKeyScopesLazyQueryHookResult = ReturnType<typeof useApiKeyScopesLazyQuery>;
export type ApiKeyScopesQueryResult = Apollo.QueryResult<ApiKeyScopesQuery, ApiKeyScopesQueryVariables>;
export const GenerateApiKeyDocument = gql`
    mutation GenerateApiKey($name: String!, $scopes: [String!]!) {
  generateApiKey(name: $name, scopes: $scopes) {
    ok
    errors {
      field
      message
    }
    key
    apiKey {
      ...ApiKeyFields
    }
  }
}
    ${ApiKeyFieldsFragmentDoc}`;
export type GenerateApiKeyMutationFn = Apollo.MutationFunction<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>;

/**
 * __useGenerateApiKeyMutation__
 *
 * To run a mutation, you first call `useGenerateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateApiKeyMutation, { data, loading, error }] = useGenerateApiKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      scopes: // value for 'scopes'
 *   },
 * });
 */
export function useGenerateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>(GenerateApiKeyDocument, options);
      }
export type GenerateApiKeyMutationHookResult = ReturnType<typeof useGenerateApiKeyMutation>;
export type GenerateApiKeyMutationResult = Apollo.MutationResult<GenerateApiKeyMutation>;
export type GenerateApiKeyMutationOptions = Apollo.BaseMutationOptions<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>;
export const UpdateApiKeyDocument = gql`
    mutation UpdateApiKey($id: UUID!, $name: String, $scopes: [String!]) {
  updateApiKey(id: $id, name: $name, scopes: $scopes) {
    ok
    errors {
      field
      message
    }
    apiKey {
      ...ApiKeyFields
    }
  }
}
    ${ApiKeyFieldsFragmentDoc}`;
export type UpdateApiKeyMutationFn = Apollo.MutationFunction<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;

/**
 * __useUpdateApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApiKeyMutation, { data, loading, error }] = useUpdateApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      scopes: // value for 'scopes'
 *   },
 * });
 */
export function useUpdateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>(UpdateApiKeyDocument, options);
      }
export type UpdateApiKeyMutationHookResult = ReturnType<typeof useUpdateApiKeyMutation>;
export type UpdateApiKeyMutationResult = Apollo.MutationResult<UpdateApiKeyMutation>;
export type UpdateApiKeyMutationOptions = Apollo.BaseMutationOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;
export const RevokeApiKeyDocument = gql`
    mutation RevokeApiKey($id: UUID!) {
  revokeApiKey(id: $id) {
    ok
    errors {
      field
      message
    }
    apiKey {
      ...ApiKeyFields
    }
  }
}
    ${ApiKeyFieldsFragmentDoc}`;
export type RevokeApiKeyMutationFn = Apollo.MutationFunction<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>;

/**
 * __useRevokeApiKeyMutation__
 *
 * To run a mutation, you first call `useRevokeApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeApiKeyMutation, { data, loading, error }] = useRevokeApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>(RevokeApiKeyDocument, options);
      }
export type RevokeApiKeyMutationHookResult = ReturnType<typeof useRevokeApiKeyMutation>;
export type RevokeApiKeyMutationResult = Apollo.MutationResult<RevokeApiKeyMutation>;
export type RevokeApiKeyMutationOptions = Apollo.BaseMutationOptions<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>;
export const DeleteApiKeyDocument = gql`
    mutation DeleteApiKey($id: UUID!) {
  deleteApiKey(id: $id) {
    ok
  }
}
    `;
export type DeleteApiKeyMutationFn = Apollo.MutationFunction<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;

/**
 * __useDeleteApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiKeyMutation, { data, loading, error }] = useDeleteApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>(DeleteApiKeyDocument, options);
      }
export type DeleteApiKeyMutationHookResult = ReturnType<typeof useDeleteApiKeyMutation>;
export type DeleteApiKeyMutationResult = Apollo.MutationResult<DeleteApiKeyMutation>;
export type DeleteApiKeyMutationOptions = Apollo.BaseMutationOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export const CurrentPoliciesDocument = gql`
    query CurrentPolicies {
  currentPolicies {
    documentType
    version
    effectiveDate
    body
  }
}
    `;

/**
 * __useCurrentPoliciesQuery__
 *
 * To run a query within a React component, call `useCurrentPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentPoliciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentPoliciesQuery(baseOptions?: Apollo.QueryHookOptions<CurrentPoliciesQuery, CurrentPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentPoliciesQuery, CurrentPoliciesQueryVariables>(CurrentPoliciesDocument, options);
      }
export function useCurrentPoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentPoliciesQuery, CurrentPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentPoliciesQuery, CurrentPoliciesQueryVariables>(CurrentPoliciesDocument, options);
        }
export type CurrentPoliciesQueryHookResult = ReturnType<typeof useCurrentPoliciesQuery>;
export type CurrentPoliciesLazyQueryHookResult = ReturnType<typeof useCurrentPoliciesLazyQuery>;
export type CurrentPoliciesQueryResult = Apollo.QueryResult<CurrentPoliciesQuery, CurrentPoliciesQueryVariables>;
export const PolicyDocumentDocument = gql`
    query PolicyDocument($documentType: String!, $version: Int!) {
  policyDocument(documentType: $documentType, version: $version) {
    documentType
    version
    effectiveDate
    body
  }
}
    `;

/**
 * __usePolicyDocumentQuery__
 *
 * To run a query within a React component, call `usePolicyDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyDocumentQuery({
 *   variables: {
 *      documentType: // value for 'documentType'
 *      version: // value for 'version'
 *   },
 * });
 */
export function usePolicyDocumentQuery(baseOptions: Apollo.QueryHookOptions<PolicyDocumentQuery, PolicyDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolicyDocumentQuery, PolicyDocumentQueryVariables>(PolicyDocumentDocument, options);
      }
export function usePolicyDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolicyDocumentQuery, PolicyDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolicyDocumentQuery, PolicyDocumentQueryVariables>(PolicyDocumentDocument, options);
        }
export type PolicyDocumentQueryHookResult = ReturnType<typeof usePolicyDocumentQuery>;
export type PolicyDocumentLazyQueryHookResult = ReturnType<typeof usePolicyDocumentLazyQuery>;
export type PolicyDocumentQueryResult = Apollo.QueryResult<PolicyDocumentQuery, PolicyDocumentQueryVariables>;
export const LegalEntitySettingsDocument = gql`
    query LegalEntitySettings {
  legalEntitySettings {
    entityName
    address
    contactEmail
    euRepresentative
  }
}
    `;

/**
 * __useLegalEntitySettingsQuery__
 *
 * To run a query within a React component, call `useLegalEntitySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalEntitySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalEntitySettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLegalEntitySettingsQuery(baseOptions?: Apollo.QueryHookOptions<LegalEntitySettingsQuery, LegalEntitySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalEntitySettingsQuery, LegalEntitySettingsQueryVariables>(LegalEntitySettingsDocument, options);
      }
export function useLegalEntitySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalEntitySettingsQuery, LegalEntitySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalEntitySettingsQuery, LegalEntitySettingsQueryVariables>(LegalEntitySettingsDocument, options);
        }
export type LegalEntitySettingsQueryHookResult = ReturnType<typeof useLegalEntitySettingsQuery>;
export type LegalEntitySettingsLazyQueryHookResult = ReturnType<typeof useLegalEntitySettingsLazyQuery>;
export type LegalEntitySettingsQueryResult = Apollo.QueryResult<LegalEntitySettingsQuery, LegalEntitySettingsQueryVariables>;
export const ConsentStatusDocument = gql`
    query ConsentStatus {
  consentStatus {
    requiresReconsent
    pendingPolicies {
      documentType
      version
      effectiveDate
      body
    }
  }
}
    `;

/**
 * __useConsentStatusQuery__
 *
 * To run a query within a React component, call `useConsentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsentStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsentStatusQuery(baseOptions?: Apollo.QueryHookOptions<ConsentStatusQuery, ConsentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsentStatusQuery, ConsentStatusQueryVariables>(ConsentStatusDocument, options);
      }
export function useConsentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsentStatusQuery, ConsentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsentStatusQuery, ConsentStatusQueryVariables>(ConsentStatusDocument, options);
        }
export type ConsentStatusQueryHookResult = ReturnType<typeof useConsentStatusQuery>;
export type ConsentStatusLazyQueryHookResult = ReturnType<typeof useConsentStatusLazyQuery>;
export type ConsentStatusQueryResult = Apollo.QueryResult<ConsentStatusQuery, ConsentStatusQueryVariables>;
export const AcceptPoliciesDocument = gql`
    mutation AcceptPolicies($acceptances: [PolicyAcceptanceInput!]!) {
  acceptPolicies(acceptances: $acceptances) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type AcceptPoliciesMutationFn = Apollo.MutationFunction<AcceptPoliciesMutation, AcceptPoliciesMutationVariables>;

/**
 * __useAcceptPoliciesMutation__
 *
 * To run a mutation, you first call `useAcceptPoliciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptPoliciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptPoliciesMutation, { data, loading, error }] = useAcceptPoliciesMutation({
 *   variables: {
 *      acceptances: // value for 'acceptances'
 *   },
 * });
 */
export function useAcceptPoliciesMutation(baseOptions?: Apollo.MutationHookOptions<AcceptPoliciesMutation, AcceptPoliciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptPoliciesMutation, AcceptPoliciesMutationVariables>(AcceptPoliciesDocument, options);
      }
export type AcceptPoliciesMutationHookResult = ReturnType<typeof useAcceptPoliciesMutation>;
export type AcceptPoliciesMutationResult = Apollo.MutationResult<AcceptPoliciesMutation>;
export type AcceptPoliciesMutationOptions = Apollo.BaseMutationOptions<AcceptPoliciesMutation, AcceptPoliciesMutationVariables>;
export const SetMarketingConsentDocument = gql`
    mutation SetMarketingConsent($granted: Boolean!) {
  setMarketingConsent(granted: $granted) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type SetMarketingConsentMutationFn = Apollo.MutationFunction<SetMarketingConsentMutation, SetMarketingConsentMutationVariables>;

/**
 * __useSetMarketingConsentMutation__
 *
 * To run a mutation, you first call `useSetMarketingConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMarketingConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMarketingConsentMutation, { data, loading, error }] = useSetMarketingConsentMutation({
 *   variables: {
 *      granted: // value for 'granted'
 *   },
 * });
 */
export function useSetMarketingConsentMutation(baseOptions?: Apollo.MutationHookOptions<SetMarketingConsentMutation, SetMarketingConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMarketingConsentMutation, SetMarketingConsentMutationVariables>(SetMarketingConsentDocument, options);
      }
export type SetMarketingConsentMutationHookResult = ReturnType<typeof useSetMarketingConsentMutation>;
export type SetMarketingConsentMutationResult = Apollo.MutationResult<SetMarketingConsentMutation>;
export type SetMarketingConsentMutationOptions = Apollo.BaseMutationOptions<SetMarketingConsentMutation, SetMarketingConsentMutationVariables>;
export const DashboardPresetsDocument = gql`
    query DashboardPresets($search: String, $mine: Boolean!, $publicOnly: Boolean!, $isSystem: Boolean, $presetTypeKey: String! = "podium_dash") {
  presets(
    presetTypeKey: $presetTypeKey
    search: $search
    mine: $mine
    publicOnly: $publicOnly
    isSystem: $isSystem
  ) {
    id
    name
    notes
    rating
    ratingCount
    isSystem
    isPrivate
    previewImageSmall
    createdBy {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useDashboardPresetsQuery__
 *
 * To run a query within a React component, call `useDashboardPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardPresetsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      mine: // value for 'mine'
 *      publicOnly: // value for 'publicOnly'
 *      isSystem: // value for 'isSystem'
 *      presetTypeKey: // value for 'presetTypeKey'
 *   },
 * });
 */
export function useDashboardPresetsQuery(baseOptions: Apollo.QueryHookOptions<DashboardPresetsQuery, DashboardPresetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardPresetsQuery, DashboardPresetsQueryVariables>(DashboardPresetsDocument, options);
      }
export function useDashboardPresetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardPresetsQuery, DashboardPresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardPresetsQuery, DashboardPresetsQueryVariables>(DashboardPresetsDocument, options);
        }
export type DashboardPresetsQueryHookResult = ReturnType<typeof useDashboardPresetsQuery>;
export type DashboardPresetsLazyQueryHookResult = ReturnType<typeof useDashboardPresetsLazyQuery>;
export type DashboardPresetsQueryResult = Apollo.QueryResult<DashboardPresetsQuery, DashboardPresetsQueryVariables>;
export const DashboardPresetDataDocument = gql`
    query DashboardPresetData($id: UUID!) {
  presetById(id: $id) {
    id
    name
    presetData
  }
}
    `;

/**
 * __useDashboardPresetDataQuery__
 *
 * To run a query within a React component, call `useDashboardPresetDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardPresetDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardPresetDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardPresetDataQuery(baseOptions: Apollo.QueryHookOptions<DashboardPresetDataQuery, DashboardPresetDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardPresetDataQuery, DashboardPresetDataQueryVariables>(DashboardPresetDataDocument, options);
      }
export function useDashboardPresetDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardPresetDataQuery, DashboardPresetDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardPresetDataQuery, DashboardPresetDataQueryVariables>(DashboardPresetDataDocument, options);
        }
export type DashboardPresetDataQueryHookResult = ReturnType<typeof useDashboardPresetDataQuery>;
export type DashboardPresetDataLazyQueryHookResult = ReturnType<typeof useDashboardPresetDataLazyQuery>;
export type DashboardPresetDataQueryResult = Apollo.QueryResult<DashboardPresetDataQuery, DashboardPresetDataQueryVariables>;
export const CreateDashboardPresetDocument = gql`
    mutation CreateDashboardPreset($name: String!, $notes: String!, $presetData: String!, $isPrivate: Boolean, $previewImageData: String, $previewImageName: String, $presetTypeKey: String! = "podium_dash") {
  createPreset(
    name: $name
    notes: $notes
    presetData: $presetData
    isPrivate: $isPrivate
    previewImageData: $previewImageData
    previewImageName: $previewImageName
    presetTypeKey: $presetTypeKey
  ) {
    ok
    errors {
      field
      message
    }
    preset {
      id
      name
    }
  }
}
    `;
export type CreateDashboardPresetMutationFn = Apollo.MutationFunction<CreateDashboardPresetMutation, CreateDashboardPresetMutationVariables>;

/**
 * __useCreateDashboardPresetMutation__
 *
 * To run a mutation, you first call `useCreateDashboardPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDashboardPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDashboardPresetMutation, { data, loading, error }] = useCreateDashboardPresetMutation({
 *   variables: {
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *      presetData: // value for 'presetData'
 *      isPrivate: // value for 'isPrivate'
 *      previewImageData: // value for 'previewImageData'
 *      previewImageName: // value for 'previewImageName'
 *      presetTypeKey: // value for 'presetTypeKey'
 *   },
 * });
 */
export function useCreateDashboardPresetMutation(baseOptions?: Apollo.MutationHookOptions<CreateDashboardPresetMutation, CreateDashboardPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDashboardPresetMutation, CreateDashboardPresetMutationVariables>(CreateDashboardPresetDocument, options);
      }
export type CreateDashboardPresetMutationHookResult = ReturnType<typeof useCreateDashboardPresetMutation>;
export type CreateDashboardPresetMutationResult = Apollo.MutationResult<CreateDashboardPresetMutation>;
export type CreateDashboardPresetMutationOptions = Apollo.BaseMutationOptions<CreateDashboardPresetMutation, CreateDashboardPresetMutationVariables>;
export const UpdateDashboardPresetDocument = gql`
    mutation UpdateDashboardPreset($id: UUID!, $name: String, $notes: String, $presetData: String, $previewImageData: String, $previewImageName: String) {
  updatePreset(
    id: $id
    name: $name
    notes: $notes
    presetData: $presetData
    previewImageData: $previewImageData
    previewImageName: $previewImageName
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type UpdateDashboardPresetMutationFn = Apollo.MutationFunction<UpdateDashboardPresetMutation, UpdateDashboardPresetMutationVariables>;

/**
 * __useUpdateDashboardPresetMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardPresetMutation, { data, loading, error }] = useUpdateDashboardPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *      presetData: // value for 'presetData'
 *      previewImageData: // value for 'previewImageData'
 *      previewImageName: // value for 'previewImageName'
 *   },
 * });
 */
export function useUpdateDashboardPresetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDashboardPresetMutation, UpdateDashboardPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDashboardPresetMutation, UpdateDashboardPresetMutationVariables>(UpdateDashboardPresetDocument, options);
      }
export type UpdateDashboardPresetMutationHookResult = ReturnType<typeof useUpdateDashboardPresetMutation>;
export type UpdateDashboardPresetMutationResult = Apollo.MutationResult<UpdateDashboardPresetMutation>;
export type UpdateDashboardPresetMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardPresetMutation, UpdateDashboardPresetMutationVariables>;
export const MyDevicesDocument = gql`
    query MyDevices {
  myDevices {
    id
    name
    createdAt
    isPrivate
    streamingKey
    previewImageSmall
    previewImageMedium
    previewImageLarge
  }
}
    `;

/**
 * __useMyDevicesQuery__
 *
 * To run a query within a React component, call `useMyDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDevicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyDevicesQuery(baseOptions?: Apollo.QueryHookOptions<MyDevicesQuery, MyDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyDevicesQuery, MyDevicesQueryVariables>(MyDevicesDocument, options);
      }
export function useMyDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyDevicesQuery, MyDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyDevicesQuery, MyDevicesQueryVariables>(MyDevicesDocument, options);
        }
export type MyDevicesQueryHookResult = ReturnType<typeof useMyDevicesQuery>;
export type MyDevicesLazyQueryHookResult = ReturnType<typeof useMyDevicesLazyQuery>;
export type MyDevicesQueryResult = Apollo.QueryResult<MyDevicesQuery, MyDevicesQueryVariables>;
export const DeviceDocument = gql`
    query Device($id: UUID!) {
  deviceById(id: $id) {
    id
    name
    notes
    streamingKey
    isPrivate
    previewImageSmall
    previewImageMedium
    previewImageLarge
    createdAt
  }
}
    `;

/**
 * __useDeviceQuery__
 *
 * To run a query within a React component, call `useDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceQuery(baseOptions: Apollo.QueryHookOptions<DeviceQuery, DeviceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceQuery, DeviceQueryVariables>(DeviceDocument, options);
      }
export function useDeviceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceQuery, DeviceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceQuery, DeviceQueryVariables>(DeviceDocument, options);
        }
export type DeviceQueryHookResult = ReturnType<typeof useDeviceQuery>;
export type DeviceLazyQueryHookResult = ReturnType<typeof useDeviceLazyQuery>;
export type DeviceQueryResult = Apollo.QueryResult<DeviceQuery, DeviceQueryVariables>;
export const CreateDeviceDocument = gql`
    mutation CreateDevice($name: String!, $notes: String!, $previewImage: Upload, $isPrivate: Boolean!) {
  createDevice(
    name: $name
    notes: $notes
    previewImage: $previewImage
    isPrivate: $isPrivate
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type CreateDeviceMutationFn = Apollo.MutationFunction<CreateDeviceMutation, CreateDeviceMutationVariables>;

/**
 * __useCreateDeviceMutation__
 *
 * To run a mutation, you first call `useCreateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviceMutation, { data, loading, error }] = useCreateDeviceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *      previewImage: // value for 'previewImage'
 *      isPrivate: // value for 'isPrivate'
 *   },
 * });
 */
export function useCreateDeviceMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeviceMutation, CreateDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeviceMutation, CreateDeviceMutationVariables>(CreateDeviceDocument, options);
      }
export type CreateDeviceMutationHookResult = ReturnType<typeof useCreateDeviceMutation>;
export type CreateDeviceMutationResult = Apollo.MutationResult<CreateDeviceMutation>;
export type CreateDeviceMutationOptions = Apollo.BaseMutationOptions<CreateDeviceMutation, CreateDeviceMutationVariables>;
export const DeleteDeviceDocument = gql`
    mutation DeleteDevice($id: UUID!) {
  deleteDevice(id: $id) {
    ok
  }
}
    `;
export type DeleteDeviceMutationFn = Apollo.MutationFunction<DeleteDeviceMutation, DeleteDeviceMutationVariables>;

/**
 * __useDeleteDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceMutation, { data, loading, error }] = useDeleteDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeviceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeviceMutation, DeleteDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeviceMutation, DeleteDeviceMutationVariables>(DeleteDeviceDocument, options);
      }
export type DeleteDeviceMutationHookResult = ReturnType<typeof useDeleteDeviceMutation>;
export type DeleteDeviceMutationResult = Apollo.MutationResult<DeleteDeviceMutation>;
export type DeleteDeviceMutationOptions = Apollo.BaseMutationOptions<DeleteDeviceMutation, DeleteDeviceMutationVariables>;
export const EditDeviceDocument = gql`
    mutation EditDevice($id: UUID!, $name: String, $notes: String, $previewImage: Upload, $isPrivate: Boolean) {
  updateDevice(
    id: $id
    name: $name
    notes: $notes
    previewImage: $previewImage
    isPrivate: $isPrivate
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type EditDeviceMutationFn = Apollo.MutationFunction<EditDeviceMutation, EditDeviceMutationVariables>;

/**
 * __useEditDeviceMutation__
 *
 * To run a mutation, you first call `useEditDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDeviceMutation, { data, loading, error }] = useEditDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *      previewImage: // value for 'previewImage'
 *      isPrivate: // value for 'isPrivate'
 *   },
 * });
 */
export function useEditDeviceMutation(baseOptions?: Apollo.MutationHookOptions<EditDeviceMutation, EditDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDeviceMutation, EditDeviceMutationVariables>(EditDeviceDocument, options);
      }
export type EditDeviceMutationHookResult = ReturnType<typeof useEditDeviceMutation>;
export type EditDeviceMutationResult = Apollo.MutationResult<EditDeviceMutation>;
export type EditDeviceMutationOptions = Apollo.BaseMutationOptions<EditDeviceMutation, EditDeviceMutationVariables>;
export const SuperuserDevicesDocument = gql`
    query SuperuserDevices($name: String, $rowsPerPage: Int, $page: Int) {
  superuserDevices(name: $name, rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      name
      streamingKey
      createdAt
      createdBy {
        id
        email
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useSuperuserDevicesQuery__
 *
 * To run a query within a React component, call `useSuperuserDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserDevicesQuery({
 *   variables: {
 *      name: // value for 'name'
 *      rowsPerPage: // value for 'rowsPerPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSuperuserDevicesQuery(baseOptions?: Apollo.QueryHookOptions<SuperuserDevicesQuery, SuperuserDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserDevicesQuery, SuperuserDevicesQueryVariables>(SuperuserDevicesDocument, options);
      }
export function useSuperuserDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserDevicesQuery, SuperuserDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserDevicesQuery, SuperuserDevicesQueryVariables>(SuperuserDevicesDocument, options);
        }
export type SuperuserDevicesQueryHookResult = ReturnType<typeof useSuperuserDevicesQuery>;
export type SuperuserDevicesLazyQueryHookResult = ReturnType<typeof useSuperuserDevicesLazyQuery>;
export type SuperuserDevicesQueryResult = Apollo.QueryResult<SuperuserDevicesQuery, SuperuserDevicesQueryVariables>;
export const SuperuserDeviceDocument = gql`
    query SuperuserDevice($id: UUID!) {
  superuserDeviceById(id: $id) {
    id
    name
    notes
    streamingKey
    previewImageSmall
    previewImageMedium
    previewImageLarge
    createdAt
    isPrivate
    createdBy {
      id
      email
    }
  }
}
    `;

/**
 * __useSuperuserDeviceQuery__
 *
 * To run a query within a React component, call `useSuperuserDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserDeviceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserDeviceQuery(baseOptions: Apollo.QueryHookOptions<SuperuserDeviceQuery, SuperuserDeviceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserDeviceQuery, SuperuserDeviceQueryVariables>(SuperuserDeviceDocument, options);
      }
export function useSuperuserDeviceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserDeviceQuery, SuperuserDeviceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserDeviceQuery, SuperuserDeviceQueryVariables>(SuperuserDeviceDocument, options);
        }
export type SuperuserDeviceQueryHookResult = ReturnType<typeof useSuperuserDeviceQuery>;
export type SuperuserDeviceLazyQueryHookResult = ReturnType<typeof useSuperuserDeviceLazyQuery>;
export type SuperuserDeviceQueryResult = Apollo.QueryResult<SuperuserDeviceQuery, SuperuserDeviceQueryVariables>;
export const EventDevicesDocument = gql`
    query EventDevices($eventId: UUID!) {
  eventDevices(eventId: $eventId) {
    id
    startTime
    endTime
    competitorNumber
    processorInstanceHost
    device {
      id
      name
      isOwner
      previewImageSmall
      previewImageMedium
      createdBy {
        id
        slug
        firstName
        lastName
        avatarSmall
      }
    }
  }
}
    `;

/**
 * __useEventDevicesQuery__
 *
 * To run a query within a React component, call `useEventDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDevicesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventDevicesQuery(baseOptions: Apollo.QueryHookOptions<EventDevicesQuery, EventDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventDevicesQuery, EventDevicesQueryVariables>(EventDevicesDocument, options);
      }
export function useEventDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventDevicesQuery, EventDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventDevicesQuery, EventDevicesQueryVariables>(EventDevicesDocument, options);
        }
export type EventDevicesQueryHookResult = ReturnType<typeof useEventDevicesQuery>;
export type EventDevicesLazyQueryHookResult = ReturnType<typeof useEventDevicesLazyQuery>;
export type EventDevicesQueryResult = Apollo.QueryResult<EventDevicesQuery, EventDevicesQueryVariables>;
export const EventDeviceDocument = gql`
    query EventDevice($id: UUID!) {
  eventDeviceById(id: $id) {
    id
    startTime
    endTime
    device {
      id
      name
      streamingKey
      isPrivate
      isOwner
    }
    event {
      id
      name
      isOwner
    }
    metadata
    processorInstanceHost
  }
}
    `;

/**
 * __useEventDeviceQuery__
 *
 * To run a query within a React component, call `useEventDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDeviceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventDeviceQuery(baseOptions: Apollo.QueryHookOptions<EventDeviceQuery, EventDeviceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventDeviceQuery, EventDeviceQueryVariables>(EventDeviceDocument, options);
      }
export function useEventDeviceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventDeviceQuery, EventDeviceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventDeviceQuery, EventDeviceQueryVariables>(EventDeviceDocument, options);
        }
export type EventDeviceQueryHookResult = ReturnType<typeof useEventDeviceQuery>;
export type EventDeviceLazyQueryHookResult = ReturnType<typeof useEventDeviceLazyQuery>;
export type EventDeviceQueryResult = Apollo.QueryResult<EventDeviceQuery, EventDeviceQueryVariables>;
export const SuperuserDeviceEventsDocument = gql`
    query SuperuserDeviceEvents($deviceId: UUID) {
  superuserEventDevices(deviceId: $deviceId) {
    id
    event {
      id
      name
      startAt
      endAt
      venue {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSuperuserDeviceEventsQuery__
 *
 * To run a query within a React component, call `useSuperuserDeviceEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserDeviceEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserDeviceEventsQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useSuperuserDeviceEventsQuery(baseOptions?: Apollo.QueryHookOptions<SuperuserDeviceEventsQuery, SuperuserDeviceEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserDeviceEventsQuery, SuperuserDeviceEventsQueryVariables>(SuperuserDeviceEventsDocument, options);
      }
export function useSuperuserDeviceEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserDeviceEventsQuery, SuperuserDeviceEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserDeviceEventsQuery, SuperuserDeviceEventsQueryVariables>(SuperuserDeviceEventsDocument, options);
        }
export type SuperuserDeviceEventsQueryHookResult = ReturnType<typeof useSuperuserDeviceEventsQuery>;
export type SuperuserDeviceEventsLazyQueryHookResult = ReturnType<typeof useSuperuserDeviceEventsLazyQuery>;
export type SuperuserDeviceEventsQueryResult = Apollo.QueryResult<SuperuserDeviceEventsQuery, SuperuserDeviceEventsQueryVariables>;
export const SuperuserEventDevicesDocument = gql`
    query SuperuserEventDevices($eventId: UUID) {
  superuserEventDevices(eventId: $eventId) {
    id
    device {
      id
      name
      streamingKey
      createdAt
      createdBy {
        id
        email
      }
    }
  }
}
    `;

/**
 * __useSuperuserEventDevicesQuery__
 *
 * To run a query within a React component, call `useSuperuserEventDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserEventDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserEventDevicesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useSuperuserEventDevicesQuery(baseOptions?: Apollo.QueryHookOptions<SuperuserEventDevicesQuery, SuperuserEventDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserEventDevicesQuery, SuperuserEventDevicesQueryVariables>(SuperuserEventDevicesDocument, options);
      }
export function useSuperuserEventDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserEventDevicesQuery, SuperuserEventDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserEventDevicesQuery, SuperuserEventDevicesQueryVariables>(SuperuserEventDevicesDocument, options);
        }
export type SuperuserEventDevicesQueryHookResult = ReturnType<typeof useSuperuserEventDevicesQuery>;
export type SuperuserEventDevicesLazyQueryHookResult = ReturnType<typeof useSuperuserEventDevicesLazyQuery>;
export type SuperuserEventDevicesQueryResult = Apollo.QueryResult<SuperuserEventDevicesQuery, SuperuserEventDevicesQueryVariables>;
export const SuperuserEventDeviceDocument = gql`
    query SuperuserEventDevice($id: UUID!) {
  superuserEventDeviceById(id: $id) {
    id
    startTime
    endTime
    metadata
    source
    sourceVer
    deviceSn
    event {
      id
      name
    }
    device {
      id
      name
      isPrivate
    }
  }
}
    `;

/**
 * __useSuperuserEventDeviceQuery__
 *
 * To run a query within a React component, call `useSuperuserEventDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserEventDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserEventDeviceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserEventDeviceQuery(baseOptions: Apollo.QueryHookOptions<SuperuserEventDeviceQuery, SuperuserEventDeviceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserEventDeviceQuery, SuperuserEventDeviceQueryVariables>(SuperuserEventDeviceDocument, options);
      }
export function useSuperuserEventDeviceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserEventDeviceQuery, SuperuserEventDeviceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserEventDeviceQuery, SuperuserEventDeviceQueryVariables>(SuperuserEventDeviceDocument, options);
        }
export type SuperuserEventDeviceQueryHookResult = ReturnType<typeof useSuperuserEventDeviceQuery>;
export type SuperuserEventDeviceLazyQueryHookResult = ReturnType<typeof useSuperuserEventDeviceLazyQuery>;
export type SuperuserEventDeviceQueryResult = Apollo.QueryResult<SuperuserEventDeviceQuery, SuperuserEventDeviceQueryVariables>;
export const SuperuserLiveStreamsDocument = gql`
    query SuperuserLiveStreams {
  superuserLiveStreams: superuserActiveEventDevices {
    id
    liveTransport
    source
    sourceVer
    competitorNumber
    event {
      id
      name
    }
    device {
      id
      name
      previewImageSmall
      previewImageMedium
      createdBy {
        id
        email
      }
    }
  }
}
    `;

/**
 * __useSuperuserLiveStreamsQuery__
 *
 * To run a query within a React component, call `useSuperuserLiveStreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserLiveStreamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserLiveStreamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuperuserLiveStreamsQuery(baseOptions?: Apollo.QueryHookOptions<SuperuserLiveStreamsQuery, SuperuserLiveStreamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserLiveStreamsQuery, SuperuserLiveStreamsQueryVariables>(SuperuserLiveStreamsDocument, options);
      }
export function useSuperuserLiveStreamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserLiveStreamsQuery, SuperuserLiveStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserLiveStreamsQuery, SuperuserLiveStreamsQueryVariables>(SuperuserLiveStreamsDocument, options);
        }
export type SuperuserLiveStreamsQueryHookResult = ReturnType<typeof useSuperuserLiveStreamsQuery>;
export type SuperuserLiveStreamsLazyQueryHookResult = ReturnType<typeof useSuperuserLiveStreamsLazyQuery>;
export type SuperuserLiveStreamsQueryResult = Apollo.QueryResult<SuperuserLiveStreamsQuery, SuperuserLiveStreamsQueryVariables>;
export const SuperuserDeleteEventDeviceDocument = gql`
    mutation SuperuserDeleteEventDevice($id: UUID!) {
  superuserDeleteEventDevice(id: $id) {
    ok
  }
}
    `;
export type SuperuserDeleteEventDeviceMutationFn = Apollo.MutationFunction<SuperuserDeleteEventDeviceMutation, SuperuserDeleteEventDeviceMutationVariables>;

/**
 * __useSuperuserDeleteEventDeviceMutation__
 *
 * To run a mutation, you first call `useSuperuserDeleteEventDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserDeleteEventDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserDeleteEventDeviceMutation, { data, loading, error }] = useSuperuserDeleteEventDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserDeleteEventDeviceMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserDeleteEventDeviceMutation, SuperuserDeleteEventDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserDeleteEventDeviceMutation, SuperuserDeleteEventDeviceMutationVariables>(SuperuserDeleteEventDeviceDocument, options);
      }
export type SuperuserDeleteEventDeviceMutationHookResult = ReturnType<typeof useSuperuserDeleteEventDeviceMutation>;
export type SuperuserDeleteEventDeviceMutationResult = Apollo.MutationResult<SuperuserDeleteEventDeviceMutation>;
export type SuperuserDeleteEventDeviceMutationOptions = Apollo.BaseMutationOptions<SuperuserDeleteEventDeviceMutation, SuperuserDeleteEventDeviceMutationVariables>;
export const CreateEventDeviceDocument = gql`
    mutation CreateEventDevice($eventId: UUID!, $deviceId: UUID, $competitorNumber: String) {
  createEventDevice(
    eventId: $eventId
    deviceId: $deviceId
    competitorNumber: $competitorNumber
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type CreateEventDeviceMutationFn = Apollo.MutationFunction<CreateEventDeviceMutation, CreateEventDeviceMutationVariables>;

/**
 * __useCreateEventDeviceMutation__
 *
 * To run a mutation, you first call `useCreateEventDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventDeviceMutation, { data, loading, error }] = useCreateEventDeviceMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      deviceId: // value for 'deviceId'
 *      competitorNumber: // value for 'competitorNumber'
 *   },
 * });
 */
export function useCreateEventDeviceMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventDeviceMutation, CreateEventDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventDeviceMutation, CreateEventDeviceMutationVariables>(CreateEventDeviceDocument, options);
      }
export type CreateEventDeviceMutationHookResult = ReturnType<typeof useCreateEventDeviceMutation>;
export type CreateEventDeviceMutationResult = Apollo.MutationResult<CreateEventDeviceMutation>;
export type CreateEventDeviceMutationOptions = Apollo.BaseMutationOptions<CreateEventDeviceMutation, CreateEventDeviceMutationVariables>;
export const UpdateEventDeviceDocument = gql`
    mutation UpdateEventDevice($id: UUID!, $competitorNumber: String) {
  updateEventDevice(id: $id, competitorNumber: $competitorNumber) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type UpdateEventDeviceMutationFn = Apollo.MutationFunction<UpdateEventDeviceMutation, UpdateEventDeviceMutationVariables>;

/**
 * __useUpdateEventDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateEventDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventDeviceMutation, { data, loading, error }] = useUpdateEventDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      competitorNumber: // value for 'competitorNumber'
 *   },
 * });
 */
export function useUpdateEventDeviceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventDeviceMutation, UpdateEventDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventDeviceMutation, UpdateEventDeviceMutationVariables>(UpdateEventDeviceDocument, options);
      }
export type UpdateEventDeviceMutationHookResult = ReturnType<typeof useUpdateEventDeviceMutation>;
export type UpdateEventDeviceMutationResult = Apollo.MutationResult<UpdateEventDeviceMutation>;
export type UpdateEventDeviceMutationOptions = Apollo.BaseMutationOptions<UpdateEventDeviceMutation, UpdateEventDeviceMutationVariables>;
export const DeleteEventDeviceDocument = gql`
    mutation DeleteEventDevice($id: UUID!) {
  deleteEventDevice(id: $id) {
    ok
  }
}
    `;
export type DeleteEventDeviceMutationFn = Apollo.MutationFunction<DeleteEventDeviceMutation, DeleteEventDeviceMutationVariables>;

/**
 * __useDeleteEventDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteEventDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventDeviceMutation, { data, loading, error }] = useDeleteEventDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventDeviceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventDeviceMutation, DeleteEventDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventDeviceMutation, DeleteEventDeviceMutationVariables>(DeleteEventDeviceDocument, options);
      }
export type DeleteEventDeviceMutationHookResult = ReturnType<typeof useDeleteEventDeviceMutation>;
export type DeleteEventDeviceMutationResult = Apollo.MutationResult<DeleteEventDeviceMutation>;
export type DeleteEventDeviceMutationOptions = Apollo.BaseMutationOptions<DeleteEventDeviceMutation, DeleteEventDeviceMutationVariables>;
export const SuperuserEventDeviceDataSegmentsDocument = gql`
    query SuperuserEventDeviceDataSegments($eventDeviceId: UUID!) {
  superuserEventDeviceDataSegments(eventDeviceId: $eventDeviceId) {
    id
    filePath
    start
    end
  }
}
    `;

/**
 * __useSuperuserEventDeviceDataSegmentsQuery__
 *
 * To run a query within a React component, call `useSuperuserEventDeviceDataSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserEventDeviceDataSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserEventDeviceDataSegmentsQuery({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *   },
 * });
 */
export function useSuperuserEventDeviceDataSegmentsQuery(baseOptions: Apollo.QueryHookOptions<SuperuserEventDeviceDataSegmentsQuery, SuperuserEventDeviceDataSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserEventDeviceDataSegmentsQuery, SuperuserEventDeviceDataSegmentsQueryVariables>(SuperuserEventDeviceDataSegmentsDocument, options);
      }
export function useSuperuserEventDeviceDataSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserEventDeviceDataSegmentsQuery, SuperuserEventDeviceDataSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserEventDeviceDataSegmentsQuery, SuperuserEventDeviceDataSegmentsQueryVariables>(SuperuserEventDeviceDataSegmentsDocument, options);
        }
export type SuperuserEventDeviceDataSegmentsQueryHookResult = ReturnType<typeof useSuperuserEventDeviceDataSegmentsQuery>;
export type SuperuserEventDeviceDataSegmentsLazyQueryHookResult = ReturnType<typeof useSuperuserEventDeviceDataSegmentsLazyQuery>;
export type SuperuserEventDeviceDataSegmentsQueryResult = Apollo.QueryResult<SuperuserEventDeviceDataSegmentsQuery, SuperuserEventDeviceDataSegmentsQueryVariables>;
export const SuperuserGetEventDeviceDataSegmentDownloadLinkDocument = gql`
    mutation SuperuserGetEventDeviceDataSegmentDownloadLink($id: UUID!) {
  superuserGetEventDeviceDataSegmentDownloadLink(id: $id) {
    ok
    downloadLink
  }
}
    `;
export type SuperuserGetEventDeviceDataSegmentDownloadLinkMutationFn = Apollo.MutationFunction<SuperuserGetEventDeviceDataSegmentDownloadLinkMutation, SuperuserGetEventDeviceDataSegmentDownloadLinkMutationVariables>;

/**
 * __useSuperuserGetEventDeviceDataSegmentDownloadLinkMutation__
 *
 * To run a mutation, you first call `useSuperuserGetEventDeviceDataSegmentDownloadLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserGetEventDeviceDataSegmentDownloadLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserGetEventDeviceDataSegmentDownloadLinkMutation, { data, loading, error }] = useSuperuserGetEventDeviceDataSegmentDownloadLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserGetEventDeviceDataSegmentDownloadLinkMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserGetEventDeviceDataSegmentDownloadLinkMutation, SuperuserGetEventDeviceDataSegmentDownloadLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserGetEventDeviceDataSegmentDownloadLinkMutation, SuperuserGetEventDeviceDataSegmentDownloadLinkMutationVariables>(SuperuserGetEventDeviceDataSegmentDownloadLinkDocument, options);
      }
export type SuperuserGetEventDeviceDataSegmentDownloadLinkMutationHookResult = ReturnType<typeof useSuperuserGetEventDeviceDataSegmentDownloadLinkMutation>;
export type SuperuserGetEventDeviceDataSegmentDownloadLinkMutationResult = Apollo.MutationResult<SuperuserGetEventDeviceDataSegmentDownloadLinkMutation>;
export type SuperuserGetEventDeviceDataSegmentDownloadLinkMutationOptions = Apollo.BaseMutationOptions<SuperuserGetEventDeviceDataSegmentDownloadLinkMutation, SuperuserGetEventDeviceDataSegmentDownloadLinkMutationVariables>;
export const EventsDocument = gql`
    query Events($venueId: UUID, $search: String, $timeFilter: EventTimeFilter, $rowsPerPage: Int, $page: Int) {
  events(
    venueId: $venueId
    search: $search
    timeFilter: $timeFilter
    rowsPerPage: $rowsPerPage
    page: $page
  ) {
    items {
      ...EventCardFields
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${EventCardFieldsFragmentDoc}`;

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      search: // value for 'search'
 *      timeFilter: // value for 'timeFilter'
 *      rowsPerPage: // value for 'rowsPerPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useEventsQuery(baseOptions?: Apollo.QueryHookOptions<EventsQuery, EventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
      }
export function useEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsQuery, EventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
        }
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>;
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>;
export type EventsQueryResult = Apollo.QueryResult<EventsQuery, EventsQueryVariables>;
export const MyEventsDocument = gql`
    query MyEvents($venueId: UUID, $search: String, $timeFilter: EventTimeFilter, $rowsPerPage: Int, $page: Int) {
  myEvents(
    venueId: $venueId
    search: $search
    timeFilter: $timeFilter
    rowsPerPage: $rowsPerPage
    page: $page
  ) {
    items {
      ...EventCardFields
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${EventCardFieldsFragmentDoc}`;

/**
 * __useMyEventsQuery__
 *
 * To run a query within a React component, call `useMyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEventsQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      search: // value for 'search'
 *      timeFilter: // value for 'timeFilter'
 *      rowsPerPage: // value for 'rowsPerPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useMyEventsQuery(baseOptions?: Apollo.QueryHookOptions<MyEventsQuery, MyEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEventsQuery, MyEventsQueryVariables>(MyEventsDocument, options);
      }
export function useMyEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEventsQuery, MyEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEventsQuery, MyEventsQueryVariables>(MyEventsDocument, options);
        }
export type MyEventsQueryHookResult = ReturnType<typeof useMyEventsQuery>;
export type MyEventsLazyQueryHookResult = ReturnType<typeof useMyEventsLazyQuery>;
export type MyEventsQueryResult = Apollo.QueryResult<MyEventsQuery, MyEventsQueryVariables>;
export const LiveEventIdsDocument = gql`
    query LiveEventIds {
  liveEventIds
}
    `;

/**
 * __useLiveEventIdsQuery__
 *
 * To run a query within a React component, call `useLiveEventIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveEventIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveEventIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLiveEventIdsQuery(baseOptions?: Apollo.QueryHookOptions<LiveEventIdsQuery, LiveEventIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiveEventIdsQuery, LiveEventIdsQueryVariables>(LiveEventIdsDocument, options);
      }
export function useLiveEventIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiveEventIdsQuery, LiveEventIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiveEventIdsQuery, LiveEventIdsQueryVariables>(LiveEventIdsDocument, options);
        }
export type LiveEventIdsQueryHookResult = ReturnType<typeof useLiveEventIdsQuery>;
export type LiveEventIdsLazyQueryHookResult = ReturnType<typeof useLiveEventIdsLazyQuery>;
export type LiveEventIdsQueryResult = Apollo.QueryResult<LiveEventIdsQuery, LiveEventIdsQueryVariables>;
export const PublicUserEventsDocument = gql`
    query PublicUserEvents($slug: String!, $rowsPerPage: Int, $page: Int) {
  publicUserEvents(slug: $slug, rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      name
      startAt
      endAt
      isPrivate
      createdBy {
        id
        slug
        firstName
        lastName
        avatarSmall
      }
      venue {
        id
        name
        trackMapThumbnail
      }
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

/**
 * __usePublicUserEventsQuery__
 *
 * To run a query within a React component, call `usePublicUserEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicUserEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicUserEventsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      rowsPerPage: // value for 'rowsPerPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePublicUserEventsQuery(baseOptions: Apollo.QueryHookOptions<PublicUserEventsQuery, PublicUserEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicUserEventsQuery, PublicUserEventsQueryVariables>(PublicUserEventsDocument, options);
      }
export function usePublicUserEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicUserEventsQuery, PublicUserEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicUserEventsQuery, PublicUserEventsQueryVariables>(PublicUserEventsDocument, options);
        }
export type PublicUserEventsQueryHookResult = ReturnType<typeof usePublicUserEventsQuery>;
export type PublicUserEventsLazyQueryHookResult = ReturnType<typeof usePublicUserEventsLazyQuery>;
export type PublicUserEventsQueryResult = Apollo.QueryResult<PublicUserEventsQuery, PublicUserEventsQueryVariables>;
export const EventDocument = gql`
    query Event($id: UUID!) {
  eventById(id: $id) {
    id
    name
    notes
    startAt
    endAt
    isPrivate
    isOwner
    createdBy {
      id
      firstName
      lastName
      avatarSmall
      profilePictureLarge
      account {
        name
      }
    }
    venue {
      id
      name
      trackMap
      startFinish
      finish
      location
      country
      countryName
      configuration
      length
      minLapTime
    }
  }
}
    `;

/**
 * __useEventQuery__
 *
 * To run a query within a React component, call `useEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventQuery(baseOptions: Apollo.QueryHookOptions<EventQuery, EventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventQuery, EventQueryVariables>(EventDocument, options);
      }
export function useEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventQuery, EventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventQuery, EventQueryVariables>(EventDocument, options);
        }
export type EventQueryHookResult = ReturnType<typeof useEventQuery>;
export type EventLazyQueryHookResult = ReturnType<typeof useEventLazyQuery>;
export type EventQueryResult = Apollo.QueryResult<EventQuery, EventQueryVariables>;
export const EventDeviceLapSummariesDocument = gql`
    query EventDeviceLapSummaries($eventId: UUID!) {
  eventDeviceLapSummaries(eventId: $eventId) {
    eventDeviceId
    lapCount
    bestLapTime
    lastLapTime
  }
}
    `;

/**
 * __useEventDeviceLapSummariesQuery__
 *
 * To run a query within a React component, call `useEventDeviceLapSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventDeviceLapSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDeviceLapSummariesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventDeviceLapSummariesQuery(baseOptions: Apollo.QueryHookOptions<EventDeviceLapSummariesQuery, EventDeviceLapSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventDeviceLapSummariesQuery, EventDeviceLapSummariesQueryVariables>(EventDeviceLapSummariesDocument, options);
      }
export function useEventDeviceLapSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventDeviceLapSummariesQuery, EventDeviceLapSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventDeviceLapSummariesQuery, EventDeviceLapSummariesQueryVariables>(EventDeviceLapSummariesDocument, options);
        }
export type EventDeviceLapSummariesQueryHookResult = ReturnType<typeof useEventDeviceLapSummariesQuery>;
export type EventDeviceLapSummariesLazyQueryHookResult = ReturnType<typeof useEventDeviceLapSummariesLazyQuery>;
export type EventDeviceLapSummariesQueryResult = Apollo.QueryResult<EventDeviceLapSummariesQuery, EventDeviceLapSummariesQueryVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($name: String!, $notes: String!, $startAt: DateTime!, $endAt: DateTime!, $isPrivate: Boolean!, $venueId: UUID) {
  createEvent(
    name: $name
    notes: $notes
    startAt: $startAt
    endAt: $endAt
    isPrivate: $isPrivate
    venueId: $venueId
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *      isPrivate: // value for 'isPrivate'
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const EditEventDocument = gql`
    mutation EditEvent($id: UUID!, $name: String, $notes: String, $startAt: DateTime, $endAt: DateTime, $isPrivate: Boolean, $venueId: UUID) {
  updateEvent(
    id: $id
    name: $name
    notes: $notes
    startAt: $startAt
    endAt: $endAt
    isPrivate: $isPrivate
    venueId: $venueId
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type EditEventMutationFn = Apollo.MutationFunction<EditEventMutation, EditEventMutationVariables>;

/**
 * __useEditEventMutation__
 *
 * To run a mutation, you first call `useEditEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEventMutation, { data, loading, error }] = useEditEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *      isPrivate: // value for 'isPrivate'
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useEditEventMutation(baseOptions?: Apollo.MutationHookOptions<EditEventMutation, EditEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEventMutation, EditEventMutationVariables>(EditEventDocument, options);
      }
export type EditEventMutationHookResult = ReturnType<typeof useEditEventMutation>;
export type EditEventMutationResult = Apollo.MutationResult<EditEventMutation>;
export type EditEventMutationOptions = Apollo.BaseMutationOptions<EditEventMutation, EditEventMutationVariables>;
export const DeleteEventDocument = gql`
    mutation DeleteEvent($id: UUID!) {
  deleteEvent(id: $id) {
    ok
    errors {
      message
    }
  }
}
    `;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, options);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const SuperuserEventsDocument = gql`
    query SuperuserEvents($name: String, $rowsPerPage: Int, $page: Int) {
  superuserEvents(name: $name, rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      name
      startAt
      endAt
      venue {
        id
        name
        configuration
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useSuperuserEventsQuery__
 *
 * To run a query within a React component, call `useSuperuserEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserEventsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      rowsPerPage: // value for 'rowsPerPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSuperuserEventsQuery(baseOptions?: Apollo.QueryHookOptions<SuperuserEventsQuery, SuperuserEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserEventsQuery, SuperuserEventsQueryVariables>(SuperuserEventsDocument, options);
      }
export function useSuperuserEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserEventsQuery, SuperuserEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserEventsQuery, SuperuserEventsQueryVariables>(SuperuserEventsDocument, options);
        }
export type SuperuserEventsQueryHookResult = ReturnType<typeof useSuperuserEventsQuery>;
export type SuperuserEventsLazyQueryHookResult = ReturnType<typeof useSuperuserEventsLazyQuery>;
export type SuperuserEventsQueryResult = Apollo.QueryResult<SuperuserEventsQuery, SuperuserEventsQueryVariables>;
export const SuperuserEventDocument = gql`
    query SuperuserEvent($id: UUID!) {
  superuserEventById(id: $id) {
    id
    name
    notes
    startAt
    endAt
    isPrivate
    timeRangeAutoAdjustable
    venueSource
    venueClearable
    venue {
      id
      name
      configuration
      trackMapThumbnail
    }
  }
}
    `;

/**
 * __useSuperuserEventQuery__
 *
 * To run a query within a React component, call `useSuperuserEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserEventQuery(baseOptions: Apollo.QueryHookOptions<SuperuserEventQuery, SuperuserEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserEventQuery, SuperuserEventQueryVariables>(SuperuserEventDocument, options);
      }
export function useSuperuserEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserEventQuery, SuperuserEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserEventQuery, SuperuserEventQueryVariables>(SuperuserEventDocument, options);
        }
export type SuperuserEventQueryHookResult = ReturnType<typeof useSuperuserEventQuery>;
export type SuperuserEventLazyQueryHookResult = ReturnType<typeof useSuperuserEventLazyQuery>;
export type SuperuserEventQueryResult = Apollo.QueryResult<SuperuserEventQuery, SuperuserEventQueryVariables>;
export const EventVenueLockDocument = gql`
    query EventVenueLock($id: UUID!) {
  eventById(id: $id) {
    id
    venueSource
    venueLocked
    venueClearable
    venue {
      id
      name
      configuration
      trackMapThumbnail
    }
  }
}
    `;

/**
 * __useEventVenueLockQuery__
 *
 * To run a query within a React component, call `useEventVenueLockQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventVenueLockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventVenueLockQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventVenueLockQuery(baseOptions: Apollo.QueryHookOptions<EventVenueLockQuery, EventVenueLockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventVenueLockQuery, EventVenueLockQueryVariables>(EventVenueLockDocument, options);
      }
export function useEventVenueLockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventVenueLockQuery, EventVenueLockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventVenueLockQuery, EventVenueLockQueryVariables>(EventVenueLockDocument, options);
        }
export type EventVenueLockQueryHookResult = ReturnType<typeof useEventVenueLockQuery>;
export type EventVenueLockLazyQueryHookResult = ReturnType<typeof useEventVenueLockLazyQuery>;
export type EventVenueLockQueryResult = Apollo.QueryResult<EventVenueLockQuery, EventVenueLockQueryVariables>;
export const SuperuserUpdateEventDocument = gql`
    mutation SuperuserUpdateEvent($id: UUID!, $name: String, $notes: String, $startAt: DateTime, $endAt: DateTime, $isPrivate: Boolean, $venueId: UUID, $timeRangeAutoAdjustable: Boolean) {
  superuserUpdateEvent(
    id: $id
    name: $name
    notes: $notes
    startAt: $startAt
    endAt: $endAt
    isPrivate: $isPrivate
    venueId: $venueId
    timeRangeAutoAdjustable: $timeRangeAutoAdjustable
  ) {
    ok
    errors {
      field
      message
    }
    event {
      id
      name
    }
  }
}
    `;
export type SuperuserUpdateEventMutationFn = Apollo.MutationFunction<SuperuserUpdateEventMutation, SuperuserUpdateEventMutationVariables>;

/**
 * __useSuperuserUpdateEventMutation__
 *
 * To run a mutation, you first call `useSuperuserUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserUpdateEventMutation, { data, loading, error }] = useSuperuserUpdateEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *      isPrivate: // value for 'isPrivate'
 *      venueId: // value for 'venueId'
 *      timeRangeAutoAdjustable: // value for 'timeRangeAutoAdjustable'
 *   },
 * });
 */
export function useSuperuserUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserUpdateEventMutation, SuperuserUpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserUpdateEventMutation, SuperuserUpdateEventMutationVariables>(SuperuserUpdateEventDocument, options);
      }
export type SuperuserUpdateEventMutationHookResult = ReturnType<typeof useSuperuserUpdateEventMutation>;
export type SuperuserUpdateEventMutationResult = Apollo.MutationResult<SuperuserUpdateEventMutation>;
export type SuperuserUpdateEventMutationOptions = Apollo.BaseMutationOptions<SuperuserUpdateEventMutation, SuperuserUpdateEventMutationVariables>;
export const SuperuserDeleteEventDocument = gql`
    mutation SuperuserDeleteEvent($id: UUID!, $force: Boolean) {
  superuserDeleteEvent(id: $id, force: $force) {
    ok
    errors {
      message
    }
  }
}
    `;
export type SuperuserDeleteEventMutationFn = Apollo.MutationFunction<SuperuserDeleteEventMutation, SuperuserDeleteEventMutationVariables>;

/**
 * __useSuperuserDeleteEventMutation__
 *
 * To run a mutation, you first call `useSuperuserDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserDeleteEventMutation, { data, loading, error }] = useSuperuserDeleteEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useSuperuserDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserDeleteEventMutation, SuperuserDeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserDeleteEventMutation, SuperuserDeleteEventMutationVariables>(SuperuserDeleteEventDocument, options);
      }
export type SuperuserDeleteEventMutationHookResult = ReturnType<typeof useSuperuserDeleteEventMutation>;
export type SuperuserDeleteEventMutationResult = Apollo.MutationResult<SuperuserDeleteEventMutation>;
export type SuperuserDeleteEventMutationOptions = Apollo.BaseMutationOptions<SuperuserDeleteEventMutation, SuperuserDeleteEventMutationVariables>;
export const CreateTelemetryExportDocument = gql`
    mutation CreateTelemetryExport($eventDeviceId: UUID!) {
  createTelemetryExport(eventDeviceId: $eventDeviceId) {
    ok
  }
}
    `;
export type CreateTelemetryExportMutationFn = Apollo.MutationFunction<CreateTelemetryExportMutation, CreateTelemetryExportMutationVariables>;

/**
 * __useCreateTelemetryExportMutation__
 *
 * To run a mutation, you first call `useCreateTelemetryExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTelemetryExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTelemetryExportMutation, { data, loading, error }] = useCreateTelemetryExportMutation({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *   },
 * });
 */
export function useCreateTelemetryExportMutation(baseOptions?: Apollo.MutationHookOptions<CreateTelemetryExportMutation, CreateTelemetryExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTelemetryExportMutation, CreateTelemetryExportMutationVariables>(CreateTelemetryExportDocument, options);
      }
export type CreateTelemetryExportMutationHookResult = ReturnType<typeof useCreateTelemetryExportMutation>;
export type CreateTelemetryExportMutationResult = Apollo.MutationResult<CreateTelemetryExportMutation>;
export type CreateTelemetryExportMutationOptions = Apollo.BaseMutationOptions<CreateTelemetryExportMutation, CreateTelemetryExportMutationVariables>;
export const TelemetryExportsDocument = gql`
    query TelemetryExports($eventDeviceId: UUID) {
  telemetryExports(eventDeviceId: $eventDeviceId) {
    id
    status
    statusDisplay
    createdAt
    eventDevice {
      id
      event {
        name
      }
      device {
        id
        name
        previewImageSmall
        previewImageMedium
      }
    }
    createdBy {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useTelemetryExportsQuery__
 *
 * To run a query within a React component, call `useTelemetryExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTelemetryExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTelemetryExportsQuery({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *   },
 * });
 */
export function useTelemetryExportsQuery(baseOptions?: Apollo.QueryHookOptions<TelemetryExportsQuery, TelemetryExportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TelemetryExportsQuery, TelemetryExportsQueryVariables>(TelemetryExportsDocument, options);
      }
export function useTelemetryExportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TelemetryExportsQuery, TelemetryExportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TelemetryExportsQuery, TelemetryExportsQueryVariables>(TelemetryExportsDocument, options);
        }
export type TelemetryExportsQueryHookResult = ReturnType<typeof useTelemetryExportsQuery>;
export type TelemetryExportsLazyQueryHookResult = ReturnType<typeof useTelemetryExportsLazyQuery>;
export type TelemetryExportsQueryResult = Apollo.QueryResult<TelemetryExportsQuery, TelemetryExportsQueryVariables>;
export const GenerateTelemetryExportFileDownloadLinkDocument = gql`
    mutation GenerateTelemetryExportFileDownloadLink($telemetryExportId: UUID!) {
  generateTelemetryExportFileDownloadLink(telemetryExportId: $telemetryExportId) {
    ok
    downloadLink
  }
}
    `;
export type GenerateTelemetryExportFileDownloadLinkMutationFn = Apollo.MutationFunction<GenerateTelemetryExportFileDownloadLinkMutation, GenerateTelemetryExportFileDownloadLinkMutationVariables>;

/**
 * __useGenerateTelemetryExportFileDownloadLinkMutation__
 *
 * To run a mutation, you first call `useGenerateTelemetryExportFileDownloadLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTelemetryExportFileDownloadLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTelemetryExportFileDownloadLinkMutation, { data, loading, error }] = useGenerateTelemetryExportFileDownloadLinkMutation({
 *   variables: {
 *      telemetryExportId: // value for 'telemetryExportId'
 *   },
 * });
 */
export function useGenerateTelemetryExportFileDownloadLinkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTelemetryExportFileDownloadLinkMutation, GenerateTelemetryExportFileDownloadLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTelemetryExportFileDownloadLinkMutation, GenerateTelemetryExportFileDownloadLinkMutationVariables>(GenerateTelemetryExportFileDownloadLinkDocument, options);
      }
export type GenerateTelemetryExportFileDownloadLinkMutationHookResult = ReturnType<typeof useGenerateTelemetryExportFileDownloadLinkMutation>;
export type GenerateTelemetryExportFileDownloadLinkMutationResult = Apollo.MutationResult<GenerateTelemetryExportFileDownloadLinkMutation>;
export type GenerateTelemetryExportFileDownloadLinkMutationOptions = Apollo.BaseMutationOptions<GenerateTelemetryExportFileDownloadLinkMutation, GenerateTelemetryExportFileDownloadLinkMutationVariables>;
export const DeleteTelemetryExportDocument = gql`
    mutation DeleteTelemetryExport($id: UUID!) {
  deleteTelemetryExport(id: $id) {
    ok
  }
}
    `;
export type DeleteTelemetryExportMutationFn = Apollo.MutationFunction<DeleteTelemetryExportMutation, DeleteTelemetryExportMutationVariables>;

/**
 * __useDeleteTelemetryExportMutation__
 *
 * To run a mutation, you first call `useDeleteTelemetryExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTelemetryExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTelemetryExportMutation, { data, loading, error }] = useDeleteTelemetryExportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTelemetryExportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTelemetryExportMutation, DeleteTelemetryExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTelemetryExportMutation, DeleteTelemetryExportMutationVariables>(DeleteTelemetryExportDocument, options);
      }
export type DeleteTelemetryExportMutationHookResult = ReturnType<typeof useDeleteTelemetryExportMutation>;
export type DeleteTelemetryExportMutationResult = Apollo.MutationResult<DeleteTelemetryExportMutation>;
export type DeleteTelemetryExportMutationOptions = Apollo.BaseMutationOptions<DeleteTelemetryExportMutation, DeleteTelemetryExportMutationVariables>;
export const SuperuserTelemetryExportsDocument = gql`
    query SuperuserTelemetryExports($search: String, $rowsPerPage: Int, $page: Int) {
  superuserTelemetryExports(
    search: $search
    rowsPerPage: $rowsPerPage
    page: $page
  ) {
    items {
      id
      status
      statusDisplay
      createdAt
      eventDevice {
        id
        event {
          name
        }
        device {
          name
          streamingKey
        }
      }
      createdBy {
        id
        firstName
        lastName
        email
      }
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

/**
 * __useSuperuserTelemetryExportsQuery__
 *
 * To run a query within a React component, call `useSuperuserTelemetryExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserTelemetryExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserTelemetryExportsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      rowsPerPage: // value for 'rowsPerPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSuperuserTelemetryExportsQuery(baseOptions?: Apollo.QueryHookOptions<SuperuserTelemetryExportsQuery, SuperuserTelemetryExportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserTelemetryExportsQuery, SuperuserTelemetryExportsQueryVariables>(SuperuserTelemetryExportsDocument, options);
      }
export function useSuperuserTelemetryExportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserTelemetryExportsQuery, SuperuserTelemetryExportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserTelemetryExportsQuery, SuperuserTelemetryExportsQueryVariables>(SuperuserTelemetryExportsDocument, options);
        }
export type SuperuserTelemetryExportsQueryHookResult = ReturnType<typeof useSuperuserTelemetryExportsQuery>;
export type SuperuserTelemetryExportsLazyQueryHookResult = ReturnType<typeof useSuperuserTelemetryExportsLazyQuery>;
export type SuperuserTelemetryExportsQueryResult = Apollo.QueryResult<SuperuserTelemetryExportsQuery, SuperuserTelemetryExportsQueryVariables>;
export const SuperuserGenerateTelemetryExportDownloadLinkDocument = gql`
    mutation SuperuserGenerateTelemetryExportDownloadLink($id: UUID!) {
  superuserGenerateTelemetryExportDownloadLink(id: $id) {
    ok
    downloadLink
  }
}
    `;
export type SuperuserGenerateTelemetryExportDownloadLinkMutationFn = Apollo.MutationFunction<SuperuserGenerateTelemetryExportDownloadLinkMutation, SuperuserGenerateTelemetryExportDownloadLinkMutationVariables>;

/**
 * __useSuperuserGenerateTelemetryExportDownloadLinkMutation__
 *
 * To run a mutation, you first call `useSuperuserGenerateTelemetryExportDownloadLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserGenerateTelemetryExportDownloadLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserGenerateTelemetryExportDownloadLinkMutation, { data, loading, error }] = useSuperuserGenerateTelemetryExportDownloadLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserGenerateTelemetryExportDownloadLinkMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserGenerateTelemetryExportDownloadLinkMutation, SuperuserGenerateTelemetryExportDownloadLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserGenerateTelemetryExportDownloadLinkMutation, SuperuserGenerateTelemetryExportDownloadLinkMutationVariables>(SuperuserGenerateTelemetryExportDownloadLinkDocument, options);
      }
export type SuperuserGenerateTelemetryExportDownloadLinkMutationHookResult = ReturnType<typeof useSuperuserGenerateTelemetryExportDownloadLinkMutation>;
export type SuperuserGenerateTelemetryExportDownloadLinkMutationResult = Apollo.MutationResult<SuperuserGenerateTelemetryExportDownloadLinkMutation>;
export type SuperuserGenerateTelemetryExportDownloadLinkMutationOptions = Apollo.BaseMutationOptions<SuperuserGenerateTelemetryExportDownloadLinkMutation, SuperuserGenerateTelemetryExportDownloadLinkMutationVariables>;
export const SuperuserDeleteTelemetryExportDocument = gql`
    mutation SuperuserDeleteTelemetryExport($id: UUID!) {
  superuserDeleteTelemetryExport(id: $id) {
    ok
  }
}
    `;
export type SuperuserDeleteTelemetryExportMutationFn = Apollo.MutationFunction<SuperuserDeleteTelemetryExportMutation, SuperuserDeleteTelemetryExportMutationVariables>;

/**
 * __useSuperuserDeleteTelemetryExportMutation__
 *
 * To run a mutation, you first call `useSuperuserDeleteTelemetryExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserDeleteTelemetryExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserDeleteTelemetryExportMutation, { data, loading, error }] = useSuperuserDeleteTelemetryExportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserDeleteTelemetryExportMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserDeleteTelemetryExportMutation, SuperuserDeleteTelemetryExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserDeleteTelemetryExportMutation, SuperuserDeleteTelemetryExportMutationVariables>(SuperuserDeleteTelemetryExportDocument, options);
      }
export type SuperuserDeleteTelemetryExportMutationHookResult = ReturnType<typeof useSuperuserDeleteTelemetryExportMutation>;
export type SuperuserDeleteTelemetryExportMutationResult = Apollo.MutationResult<SuperuserDeleteTelemetryExportMutation>;
export type SuperuserDeleteTelemetryExportMutationOptions = Apollo.BaseMutationOptions<SuperuserDeleteTelemetryExportMutation, SuperuserDeleteTelemetryExportMutationVariables>;
export const ViewerCapabilitiesDocument = gql`
    query ViewerCapabilities {
  viewerCapabilities
}
    `;

/**
 * __useViewerCapabilitiesQuery__
 *
 * To run a query within a React component, call `useViewerCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerCapabilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerCapabilitiesQuery(baseOptions?: Apollo.QueryHookOptions<ViewerCapabilitiesQuery, ViewerCapabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerCapabilitiesQuery, ViewerCapabilitiesQueryVariables>(ViewerCapabilitiesDocument, options);
      }
export function useViewerCapabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerCapabilitiesQuery, ViewerCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerCapabilitiesQuery, ViewerCapabilitiesQueryVariables>(ViewerCapabilitiesDocument, options);
        }
export type ViewerCapabilitiesQueryHookResult = ReturnType<typeof useViewerCapabilitiesQuery>;
export type ViewerCapabilitiesLazyQueryHookResult = ReturnType<typeof useViewerCapabilitiesLazyQuery>;
export type ViewerCapabilitiesQueryResult = Apollo.QueryResult<ViewerCapabilitiesQuery, ViewerCapabilitiesQueryVariables>;
export const AdminFeatureFlagsDocument = gql`
    query AdminFeatureFlags {
  superuserFeatureFlags {
    key
    label
    description
    defaultEnabled
  }
}
    `;

/**
 * __useAdminFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useAdminFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<AdminFeatureFlagsQuery, AdminFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFeatureFlagsQuery, AdminFeatureFlagsQueryVariables>(AdminFeatureFlagsDocument, options);
      }
export function useAdminFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFeatureFlagsQuery, AdminFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFeatureFlagsQuery, AdminFeatureFlagsQueryVariables>(AdminFeatureFlagsDocument, options);
        }
export type AdminFeatureFlagsQueryHookResult = ReturnType<typeof useAdminFeatureFlagsQuery>;
export type AdminFeatureFlagsLazyQueryHookResult = ReturnType<typeof useAdminFeatureFlagsLazyQuery>;
export type AdminFeatureFlagsQueryResult = Apollo.QueryResult<AdminFeatureFlagsQuery, AdminFeatureFlagsQueryVariables>;
export const AdminUserFeatureFlagsDocument = gql`
    query AdminUserFeatureFlags($userId: UUID!) {
  superuserUserFeatureFlags(userId: $userId) {
    id
    key
    enabled
    updatedAt
  }
}
    `;

/**
 * __useAdminUserFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useAdminUserFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserFeatureFlagsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminUserFeatureFlagsQuery(baseOptions: Apollo.QueryHookOptions<AdminUserFeatureFlagsQuery, AdminUserFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserFeatureFlagsQuery, AdminUserFeatureFlagsQueryVariables>(AdminUserFeatureFlagsDocument, options);
      }
export function useAdminUserFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserFeatureFlagsQuery, AdminUserFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserFeatureFlagsQuery, AdminUserFeatureFlagsQueryVariables>(AdminUserFeatureFlagsDocument, options);
        }
export type AdminUserFeatureFlagsQueryHookResult = ReturnType<typeof useAdminUserFeatureFlagsQuery>;
export type AdminUserFeatureFlagsLazyQueryHookResult = ReturnType<typeof useAdminUserFeatureFlagsLazyQuery>;
export type AdminUserFeatureFlagsQueryResult = Apollo.QueryResult<AdminUserFeatureFlagsQuery, AdminUserFeatureFlagsQueryVariables>;
export const AdminSetUserFeatureFlagDocument = gql`
    mutation AdminSetUserFeatureFlag($userId: UUID!, $flagKey: String!, $enabled: Boolean!) {
  superuserSetUserFeatureFlag(
    userId: $userId
    flagKey: $flagKey
    enabled: $enabled
  ) {
    ok
    errors {
      field
      message
    }
    assignment {
      id
      key
      enabled
    }
  }
}
    `;
export type AdminSetUserFeatureFlagMutationFn = Apollo.MutationFunction<AdminSetUserFeatureFlagMutation, AdminSetUserFeatureFlagMutationVariables>;

/**
 * __useAdminSetUserFeatureFlagMutation__
 *
 * To run a mutation, you first call `useAdminSetUserFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetUserFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetUserFeatureFlagMutation, { data, loading, error }] = useAdminSetUserFeatureFlagMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      flagKey: // value for 'flagKey'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useAdminSetUserFeatureFlagMutation(baseOptions?: Apollo.MutationHookOptions<AdminSetUserFeatureFlagMutation, AdminSetUserFeatureFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSetUserFeatureFlagMutation, AdminSetUserFeatureFlagMutationVariables>(AdminSetUserFeatureFlagDocument, options);
      }
export type AdminSetUserFeatureFlagMutationHookResult = ReturnType<typeof useAdminSetUserFeatureFlagMutation>;
export type AdminSetUserFeatureFlagMutationResult = Apollo.MutationResult<AdminSetUserFeatureFlagMutation>;
export type AdminSetUserFeatureFlagMutationOptions = Apollo.BaseMutationOptions<AdminSetUserFeatureFlagMutation, AdminSetUserFeatureFlagMutationVariables>;
export const AdminDeleteUserFeatureFlagDocument = gql`
    mutation AdminDeleteUserFeatureFlag($userId: UUID!, $flagKey: String!) {
  superuserDeleteUserFeatureFlag(userId: $userId, flagKey: $flagKey) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type AdminDeleteUserFeatureFlagMutationFn = Apollo.MutationFunction<AdminDeleteUserFeatureFlagMutation, AdminDeleteUserFeatureFlagMutationVariables>;

/**
 * __useAdminDeleteUserFeatureFlagMutation__
 *
 * To run a mutation, you first call `useAdminDeleteUserFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteUserFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteUserFeatureFlagMutation, { data, loading, error }] = useAdminDeleteUserFeatureFlagMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      flagKey: // value for 'flagKey'
 *   },
 * });
 */
export function useAdminDeleteUserFeatureFlagMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteUserFeatureFlagMutation, AdminDeleteUserFeatureFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteUserFeatureFlagMutation, AdminDeleteUserFeatureFlagMutationVariables>(AdminDeleteUserFeatureFlagDocument, options);
      }
export type AdminDeleteUserFeatureFlagMutationHookResult = ReturnType<typeof useAdminDeleteUserFeatureFlagMutation>;
export type AdminDeleteUserFeatureFlagMutationResult = Apollo.MutationResult<AdminDeleteUserFeatureFlagMutation>;
export type AdminDeleteUserFeatureFlagMutationOptions = Apollo.BaseMutationOptions<AdminDeleteUserFeatureFlagMutation, AdminDeleteUserFeatureFlagMutationVariables>;
export const FeedDocument = gql`
    query Feed($location: LocationInputType, $page: Int, $rowsPerPage: Int) {
  feed(location: $location, page: $page, rowsPerPage: $rowsPerPage) {
    items {
      ...EventCardFields
    }
    metadata {
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${EventCardFieldsFragmentDoc}`;

/**
 * __useFeedQuery__
 *
 * To run a query within a React component, call `useFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedQuery({
 *   variables: {
 *      location: // value for 'location'
 *      page: // value for 'page'
 *      rowsPerPage: // value for 'rowsPerPage'
 *   },
 * });
 */
export function useFeedQuery(baseOptions?: Apollo.QueryHookOptions<FeedQuery, FeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedQuery, FeedQueryVariables>(FeedDocument, options);
      }
export function useFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedQuery, FeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedQuery, FeedQueryVariables>(FeedDocument, options);
        }
export type FeedQueryHookResult = ReturnType<typeof useFeedQuery>;
export type FeedLazyQueryHookResult = ReturnType<typeof useFeedLazyQuery>;
export type FeedQueryResult = Apollo.QueryResult<FeedQuery, FeedQueryVariables>;
export const ViewerHelpProgressDocument = gql`
    query ViewerHelpProgress {
  viewerHelpProgress {
    key
    seenAt
    playedAt
    completedAt
    dismissedAt
  }
  userMe {
    id
    createdAt
  }
}
    `;

/**
 * __useViewerHelpProgressQuery__
 *
 * To run a query within a React component, call `useViewerHelpProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerHelpProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerHelpProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerHelpProgressQuery(baseOptions?: Apollo.QueryHookOptions<ViewerHelpProgressQuery, ViewerHelpProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerHelpProgressQuery, ViewerHelpProgressQueryVariables>(ViewerHelpProgressDocument, options);
      }
export function useViewerHelpProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerHelpProgressQuery, ViewerHelpProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerHelpProgressQuery, ViewerHelpProgressQueryVariables>(ViewerHelpProgressDocument, options);
        }
export type ViewerHelpProgressQueryHookResult = ReturnType<typeof useViewerHelpProgressQuery>;
export type ViewerHelpProgressLazyQueryHookResult = ReturnType<typeof useViewerHelpProgressLazyQuery>;
export type ViewerHelpProgressQueryResult = Apollo.QueryResult<ViewerHelpProgressQuery, ViewerHelpProgressQueryVariables>;
export const RecordHelpProgressDocument = gql`
    mutation RecordHelpProgress($key: String!, $event: HelpEvent!) {
  recordHelpProgress(key: $key, event: $event) {
    ok
    errors {
      field
      message
    }
    progress {
      key
      seenAt
      playedAt
      completedAt
      dismissedAt
    }
  }
}
    `;
export type RecordHelpProgressMutationFn = Apollo.MutationFunction<RecordHelpProgressMutation, RecordHelpProgressMutationVariables>;

/**
 * __useRecordHelpProgressMutation__
 *
 * To run a mutation, you first call `useRecordHelpProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordHelpProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordHelpProgressMutation, { data, loading, error }] = useRecordHelpProgressMutation({
 *   variables: {
 *      key: // value for 'key'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useRecordHelpProgressMutation(baseOptions?: Apollo.MutationHookOptions<RecordHelpProgressMutation, RecordHelpProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordHelpProgressMutation, RecordHelpProgressMutationVariables>(RecordHelpProgressDocument, options);
      }
export type RecordHelpProgressMutationHookResult = ReturnType<typeof useRecordHelpProgressMutation>;
export type RecordHelpProgressMutationResult = Apollo.MutationResult<RecordHelpProgressMutation>;
export type RecordHelpProgressMutationOptions = Apollo.BaseMutationOptions<RecordHelpProgressMutation, RecordHelpProgressMutationVariables>;
export const CreateImportSessionDocument = gql`
    mutation CreateImportSession($provider: String!, $filename: String!, $sizeBytes: Int!) {
  createImportSession(
    provider: $provider
    filename: $filename
    sizeBytes: $sizeBytes
  ) {
    ok
    errors {
      field
      message
    }
    uploadForm {
      url
      fields {
        name
        value
      }
    }
    session {
      ...ImportSessionFields
    }
  }
}
    ${ImportSessionFieldsFragmentDoc}`;
export type CreateImportSessionMutationFn = Apollo.MutationFunction<CreateImportSessionMutation, CreateImportSessionMutationVariables>;

/**
 * __useCreateImportSessionMutation__
 *
 * To run a mutation, you first call `useCreateImportSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImportSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImportSessionMutation, { data, loading, error }] = useCreateImportSessionMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      filename: // value for 'filename'
 *      sizeBytes: // value for 'sizeBytes'
 *   },
 * });
 */
export function useCreateImportSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateImportSessionMutation, CreateImportSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImportSessionMutation, CreateImportSessionMutationVariables>(CreateImportSessionDocument, options);
      }
export type CreateImportSessionMutationHookResult = ReturnType<typeof useCreateImportSessionMutation>;
export type CreateImportSessionMutationResult = Apollo.MutationResult<CreateImportSessionMutation>;
export type CreateImportSessionMutationOptions = Apollo.BaseMutationOptions<CreateImportSessionMutation, CreateImportSessionMutationVariables>;
export const StartImportConversionDocument = gql`
    mutation StartImportConversion($id: UUID!) {
  startImportConversion(id: $id) {
    ok
    errors {
      field
      message
    }
    session {
      ...ImportSessionFields
    }
  }
}
    ${ImportSessionFieldsFragmentDoc}`;
export type StartImportConversionMutationFn = Apollo.MutationFunction<StartImportConversionMutation, StartImportConversionMutationVariables>;

/**
 * __useStartImportConversionMutation__
 *
 * To run a mutation, you first call `useStartImportConversionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartImportConversionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startImportConversionMutation, { data, loading, error }] = useStartImportConversionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartImportConversionMutation(baseOptions?: Apollo.MutationHookOptions<StartImportConversionMutation, StartImportConversionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartImportConversionMutation, StartImportConversionMutationVariables>(StartImportConversionDocument, options);
      }
export type StartImportConversionMutationHookResult = ReturnType<typeof useStartImportConversionMutation>;
export type StartImportConversionMutationResult = Apollo.MutationResult<StartImportConversionMutation>;
export type StartImportConversionMutationOptions = Apollo.BaseMutationOptions<StartImportConversionMutation, StartImportConversionMutationVariables>;
export const ApplyImportChannelSelectionsDocument = gql`
    mutation ApplyImportChannelSelections($id: UUID!, $adjustments: JSON!, $excludedChannels: [String!]) {
  applyImportChannelSelections(
    id: $id
    adjustments: $adjustments
    excludedChannels: $excludedChannels
  ) {
    ok
    errors {
      field
      message
    }
    session {
      ...ImportSessionFields
    }
  }
}
    ${ImportSessionFieldsFragmentDoc}`;
export type ApplyImportChannelSelectionsMutationFn = Apollo.MutationFunction<ApplyImportChannelSelectionsMutation, ApplyImportChannelSelectionsMutationVariables>;

/**
 * __useApplyImportChannelSelectionsMutation__
 *
 * To run a mutation, you first call `useApplyImportChannelSelectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyImportChannelSelectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyImportChannelSelectionsMutation, { data, loading, error }] = useApplyImportChannelSelectionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      adjustments: // value for 'adjustments'
 *      excludedChannels: // value for 'excludedChannels'
 *   },
 * });
 */
export function useApplyImportChannelSelectionsMutation(baseOptions?: Apollo.MutationHookOptions<ApplyImportChannelSelectionsMutation, ApplyImportChannelSelectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyImportChannelSelectionsMutation, ApplyImportChannelSelectionsMutationVariables>(ApplyImportChannelSelectionsDocument, options);
      }
export type ApplyImportChannelSelectionsMutationHookResult = ReturnType<typeof useApplyImportChannelSelectionsMutation>;
export type ApplyImportChannelSelectionsMutationResult = Apollo.MutationResult<ApplyImportChannelSelectionsMutation>;
export type ApplyImportChannelSelectionsMutationOptions = Apollo.BaseMutationOptions<ApplyImportChannelSelectionsMutation, ApplyImportChannelSelectionsMutationVariables>;
export const ApplyImportTrackDocument = gql`
    mutation ApplyImportTrack($id: UUID!, $track: JSON!) {
  applyImportTrack(id: $id, track: $track) {
    ok
    errors {
      field
      message
    }
    session {
      ...ImportSessionFields
    }
  }
}
    ${ImportSessionFieldsFragmentDoc}`;
export type ApplyImportTrackMutationFn = Apollo.MutationFunction<ApplyImportTrackMutation, ApplyImportTrackMutationVariables>;

/**
 * __useApplyImportTrackMutation__
 *
 * To run a mutation, you first call `useApplyImportTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyImportTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyImportTrackMutation, { data, loading, error }] = useApplyImportTrackMutation({
 *   variables: {
 *      id: // value for 'id'
 *      track: // value for 'track'
 *   },
 * });
 */
export function useApplyImportTrackMutation(baseOptions?: Apollo.MutationHookOptions<ApplyImportTrackMutation, ApplyImportTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyImportTrackMutation, ApplyImportTrackMutationVariables>(ApplyImportTrackDocument, options);
      }
export type ApplyImportTrackMutationHookResult = ReturnType<typeof useApplyImportTrackMutation>;
export type ApplyImportTrackMutationResult = Apollo.MutationResult<ApplyImportTrackMutation>;
export type ApplyImportTrackMutationOptions = Apollo.BaseMutationOptions<ApplyImportTrackMutation, ApplyImportTrackMutationVariables>;
export const FinalizeImportDocument = gql`
    mutation FinalizeImport($id: UUID!, $deviceId: UUID!, $eventId: UUID, $eventName: String, $eventStart: DateTime, $eventEnd: DateTime) {
  finalizeImport(
    id: $id
    deviceId: $deviceId
    eventId: $eventId
    eventName: $eventName
    eventStart: $eventStart
    eventEnd: $eventEnd
  ) {
    ok
    errors {
      field
      message
    }
    session {
      ...ImportSessionFields
    }
  }
}
    ${ImportSessionFieldsFragmentDoc}`;
export type FinalizeImportMutationFn = Apollo.MutationFunction<FinalizeImportMutation, FinalizeImportMutationVariables>;

/**
 * __useFinalizeImportMutation__
 *
 * To run a mutation, you first call `useFinalizeImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeImportMutation, { data, loading, error }] = useFinalizeImportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deviceId: // value for 'deviceId'
 *      eventId: // value for 'eventId'
 *      eventName: // value for 'eventName'
 *      eventStart: // value for 'eventStart'
 *      eventEnd: // value for 'eventEnd'
 *   },
 * });
 */
export function useFinalizeImportMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeImportMutation, FinalizeImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeImportMutation, FinalizeImportMutationVariables>(FinalizeImportDocument, options);
      }
export type FinalizeImportMutationHookResult = ReturnType<typeof useFinalizeImportMutation>;
export type FinalizeImportMutationResult = Apollo.MutationResult<FinalizeImportMutation>;
export type FinalizeImportMutationOptions = Apollo.BaseMutationOptions<FinalizeImportMutation, FinalizeImportMutationVariables>;
export const CancelImportSessionDocument = gql`
    mutation CancelImportSession($id: UUID!) {
  cancelImportSession(id: $id) {
    ok
    errors {
      field
      message
    }
    session {
      ...ImportSessionFields
    }
  }
}
    ${ImportSessionFieldsFragmentDoc}`;
export type CancelImportSessionMutationFn = Apollo.MutationFunction<CancelImportSessionMutation, CancelImportSessionMutationVariables>;

/**
 * __useCancelImportSessionMutation__
 *
 * To run a mutation, you first call `useCancelImportSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelImportSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelImportSessionMutation, { data, loading, error }] = useCancelImportSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelImportSessionMutation(baseOptions?: Apollo.MutationHookOptions<CancelImportSessionMutation, CancelImportSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelImportSessionMutation, CancelImportSessionMutationVariables>(CancelImportSessionDocument, options);
      }
export type CancelImportSessionMutationHookResult = ReturnType<typeof useCancelImportSessionMutation>;
export type CancelImportSessionMutationResult = Apollo.MutationResult<CancelImportSessionMutation>;
export type CancelImportSessionMutationOptions = Apollo.BaseMutationOptions<CancelImportSessionMutation, CancelImportSessionMutationVariables>;
export const ImportSessionDocument = gql`
    query ImportSession($id: UUID!) {
  importSession(id: $id) {
    ...ImportSessionFields
  }
}
    ${ImportSessionFieldsFragmentDoc}`;

/**
 * __useImportSessionQuery__
 *
 * To run a query within a React component, call `useImportSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImportSessionQuery(baseOptions: Apollo.QueryHookOptions<ImportSessionQuery, ImportSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportSessionQuery, ImportSessionQueryVariables>(ImportSessionDocument, options);
      }
export function useImportSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportSessionQuery, ImportSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportSessionQuery, ImportSessionQueryVariables>(ImportSessionDocument, options);
        }
export type ImportSessionQueryHookResult = ReturnType<typeof useImportSessionQuery>;
export type ImportSessionLazyQueryHookResult = ReturnType<typeof useImportSessionLazyQuery>;
export type ImportSessionQueryResult = Apollo.QueryResult<ImportSessionQuery, ImportSessionQueryVariables>;
export const ImportSessionsDocument = gql`
    query ImportSessions($limit: Int) {
  importSessions(limit: $limit) {
    ...ImportSessionFields
  }
}
    ${ImportSessionFieldsFragmentDoc}`;

/**
 * __useImportSessionsQuery__
 *
 * To run a query within a React component, call `useImportSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportSessionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useImportSessionsQuery(baseOptions?: Apollo.QueryHookOptions<ImportSessionsQuery, ImportSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportSessionsQuery, ImportSessionsQueryVariables>(ImportSessionsDocument, options);
      }
export function useImportSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportSessionsQuery, ImportSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportSessionsQuery, ImportSessionsQueryVariables>(ImportSessionsDocument, options);
        }
export type ImportSessionsQueryHookResult = ReturnType<typeof useImportSessionsQuery>;
export type ImportSessionsLazyQueryHookResult = ReturnType<typeof useImportSessionsLazyQuery>;
export type ImportSessionsQueryResult = Apollo.QueryResult<ImportSessionsQuery, ImportSessionsQueryVariables>;
export const ImportFormatsDocument = gql`
    query ImportFormats {
  importFormats {
    key
    description
    extensions
  }
}
    `;

/**
 * __useImportFormatsQuery__
 *
 * To run a query within a React component, call `useImportFormatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportFormatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportFormatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useImportFormatsQuery(baseOptions?: Apollo.QueryHookOptions<ImportFormatsQuery, ImportFormatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportFormatsQuery, ImportFormatsQueryVariables>(ImportFormatsDocument, options);
      }
export function useImportFormatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportFormatsQuery, ImportFormatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportFormatsQuery, ImportFormatsQueryVariables>(ImportFormatsDocument, options);
        }
export type ImportFormatsQueryHookResult = ReturnType<typeof useImportFormatsQuery>;
export type ImportFormatsLazyQueryHookResult = ReturnType<typeof useImportFormatsLazyQuery>;
export type ImportFormatsQueryResult = Apollo.QueryResult<ImportFormatsQuery, ImportFormatsQueryVariables>;
export const CreateTelemetryImportDocument = gql`
    mutation CreateTelemetryImport($deviceId: UUID!, $fileName: String!, $eventId: UUID) {
  createTelemetryImport(
    deviceId: $deviceId
    fileName: $fileName
    eventId: $eventId
  ) {
    ok
    uploadForm {
      url
      fields {
        name
        value
      }
    }
    telemetryImport {
      id
    }
    errors {
      field
      message
    }
  }
}
    `;
export type CreateTelemetryImportMutationFn = Apollo.MutationFunction<CreateTelemetryImportMutation, CreateTelemetryImportMutationVariables>;

/**
 * __useCreateTelemetryImportMutation__
 *
 * To run a mutation, you first call `useCreateTelemetryImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTelemetryImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTelemetryImportMutation, { data, loading, error }] = useCreateTelemetryImportMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      fileName: // value for 'fileName'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useCreateTelemetryImportMutation(baseOptions?: Apollo.MutationHookOptions<CreateTelemetryImportMutation, CreateTelemetryImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTelemetryImportMutation, CreateTelemetryImportMutationVariables>(CreateTelemetryImportDocument, options);
      }
export type CreateTelemetryImportMutationHookResult = ReturnType<typeof useCreateTelemetryImportMutation>;
export type CreateTelemetryImportMutationResult = Apollo.MutationResult<CreateTelemetryImportMutation>;
export type CreateTelemetryImportMutationOptions = Apollo.BaseMutationOptions<CreateTelemetryImportMutation, CreateTelemetryImportMutationVariables>;
export const TelemetryImportsDocument = gql`
    query TelemetryImports($rowsPerPage: Int, $page: Int) {
  telemetryImports(rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      filename
      status
      statusDisplay
      eventDevice {
        id
        event {
          name
        }
        device {
          id
          name
          previewImageSmall
          previewImageMedium
        }
      }
      createdAt
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

/**
 * __useTelemetryImportsQuery__
 *
 * To run a query within a React component, call `useTelemetryImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTelemetryImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTelemetryImportsQuery({
 *   variables: {
 *      rowsPerPage: // value for 'rowsPerPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTelemetryImportsQuery(baseOptions?: Apollo.QueryHookOptions<TelemetryImportsQuery, TelemetryImportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TelemetryImportsQuery, TelemetryImportsQueryVariables>(TelemetryImportsDocument, options);
      }
export function useTelemetryImportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TelemetryImportsQuery, TelemetryImportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TelemetryImportsQuery, TelemetryImportsQueryVariables>(TelemetryImportsDocument, options);
        }
export type TelemetryImportsQueryHookResult = ReturnType<typeof useTelemetryImportsQuery>;
export type TelemetryImportsLazyQueryHookResult = ReturnType<typeof useTelemetryImportsLazyQuery>;
export type TelemetryImportsQueryResult = Apollo.QueryResult<TelemetryImportsQuery, TelemetryImportsQueryVariables>;
export const TelemetryImportDocument = gql`
    query TelemetryImport($id: UUID!) {
  telemetryImportById(id: $id) {
    id
    filename
    sourceFileExpiresAt
    sourceFileExpired
    status
    statusDisplay
    eventDevice {
      id
      event {
        name
      }
    }
    createdAt
  }
}
    `;

/**
 * __useTelemetryImportQuery__
 *
 * To run a query within a React component, call `useTelemetryImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTelemetryImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTelemetryImportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTelemetryImportQuery(baseOptions: Apollo.QueryHookOptions<TelemetryImportQuery, TelemetryImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TelemetryImportQuery, TelemetryImportQueryVariables>(TelemetryImportDocument, options);
      }
export function useTelemetryImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TelemetryImportQuery, TelemetryImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TelemetryImportQuery, TelemetryImportQueryVariables>(TelemetryImportDocument, options);
        }
export type TelemetryImportQueryHookResult = ReturnType<typeof useTelemetryImportQuery>;
export type TelemetryImportLazyQueryHookResult = ReturnType<typeof useTelemetryImportLazyQuery>;
export type TelemetryImportQueryResult = Apollo.QueryResult<TelemetryImportQuery, TelemetryImportQueryVariables>;
export const GenerateSourceFileDownloadLinkDocument = gql`
    mutation GenerateSourceFileDownloadLink($telemetryImportId: UUID!) {
  generateSourceFileDownloadLink(telemetryImportId: $telemetryImportId) {
    ok
    presignedUrl
    errors {
      field
      message
    }
  }
}
    `;
export type GenerateSourceFileDownloadLinkMutationFn = Apollo.MutationFunction<GenerateSourceFileDownloadLinkMutation, GenerateSourceFileDownloadLinkMutationVariables>;

/**
 * __useGenerateSourceFileDownloadLinkMutation__
 *
 * To run a mutation, you first call `useGenerateSourceFileDownloadLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSourceFileDownloadLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSourceFileDownloadLinkMutation, { data, loading, error }] = useGenerateSourceFileDownloadLinkMutation({
 *   variables: {
 *      telemetryImportId: // value for 'telemetryImportId'
 *   },
 * });
 */
export function useGenerateSourceFileDownloadLinkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSourceFileDownloadLinkMutation, GenerateSourceFileDownloadLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSourceFileDownloadLinkMutation, GenerateSourceFileDownloadLinkMutationVariables>(GenerateSourceFileDownloadLinkDocument, options);
      }
export type GenerateSourceFileDownloadLinkMutationHookResult = ReturnType<typeof useGenerateSourceFileDownloadLinkMutation>;
export type GenerateSourceFileDownloadLinkMutationResult = Apollo.MutationResult<GenerateSourceFileDownloadLinkMutation>;
export type GenerateSourceFileDownloadLinkMutationOptions = Apollo.BaseMutationOptions<GenerateSourceFileDownloadLinkMutation, GenerateSourceFileDownloadLinkMutationVariables>;
export const DeleteTelemetryImportDocument = gql`
    mutation DeleteTelemetryImport($id: UUID!) {
  deleteTelemetryImport(id: $id) {
    ok
  }
}
    `;
export type DeleteTelemetryImportMutationFn = Apollo.MutationFunction<DeleteTelemetryImportMutation, DeleteTelemetryImportMutationVariables>;

/**
 * __useDeleteTelemetryImportMutation__
 *
 * To run a mutation, you first call `useDeleteTelemetryImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTelemetryImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTelemetryImportMutation, { data, loading, error }] = useDeleteTelemetryImportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTelemetryImportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTelemetryImportMutation, DeleteTelemetryImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTelemetryImportMutation, DeleteTelemetryImportMutationVariables>(DeleteTelemetryImportDocument, options);
      }
export type DeleteTelemetryImportMutationHookResult = ReturnType<typeof useDeleteTelemetryImportMutation>;
export type DeleteTelemetryImportMutationResult = Apollo.MutationResult<DeleteTelemetryImportMutation>;
export type DeleteTelemetryImportMutationOptions = Apollo.BaseMutationOptions<DeleteTelemetryImportMutation, DeleteTelemetryImportMutationVariables>;
export const SuperuserTelemetryImportsDocument = gql`
    query SuperuserTelemetryImports($search: String, $rowsPerPage: Int, $page: Int) {
  superuserTelemetryImports(
    search: $search
    rowsPerPage: $rowsPerPage
    page: $page
  ) {
    items {
      id
      status
      statusDisplay
      eventDevice {
        id
        event {
          name
        }
        device {
          name
          streamingKey
        }
      }
      createdAt
      createdBy {
        id
        firstName
        lastName
        email
      }
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

/**
 * __useSuperuserTelemetryImportsQuery__
 *
 * To run a query within a React component, call `useSuperuserTelemetryImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserTelemetryImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserTelemetryImportsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      rowsPerPage: // value for 'rowsPerPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSuperuserTelemetryImportsQuery(baseOptions?: Apollo.QueryHookOptions<SuperuserTelemetryImportsQuery, SuperuserTelemetryImportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserTelemetryImportsQuery, SuperuserTelemetryImportsQueryVariables>(SuperuserTelemetryImportsDocument, options);
      }
export function useSuperuserTelemetryImportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserTelemetryImportsQuery, SuperuserTelemetryImportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserTelemetryImportsQuery, SuperuserTelemetryImportsQueryVariables>(SuperuserTelemetryImportsDocument, options);
        }
export type SuperuserTelemetryImportsQueryHookResult = ReturnType<typeof useSuperuserTelemetryImportsQuery>;
export type SuperuserTelemetryImportsLazyQueryHookResult = ReturnType<typeof useSuperuserTelemetryImportsLazyQuery>;
export type SuperuserTelemetryImportsQueryResult = Apollo.QueryResult<SuperuserTelemetryImportsQuery, SuperuserTelemetryImportsQueryVariables>;
export const SuperuserTelemetryImportDocument = gql`
    query SuperuserTelemetryImport($id: UUID!) {
  superuserTelemetryImportById(id: $id) {
    id
    filename
    sourceFileExpiresAt
    sourceFileExpired
    s3FileKey
    status
    statusDisplay
    eventDevice {
      id
      event {
        name
      }
    }
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useSuperuserTelemetryImportQuery__
 *
 * To run a query within a React component, call `useSuperuserTelemetryImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserTelemetryImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserTelemetryImportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserTelemetryImportQuery(baseOptions: Apollo.QueryHookOptions<SuperuserTelemetryImportQuery, SuperuserTelemetryImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserTelemetryImportQuery, SuperuserTelemetryImportQueryVariables>(SuperuserTelemetryImportDocument, options);
      }
export function useSuperuserTelemetryImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserTelemetryImportQuery, SuperuserTelemetryImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserTelemetryImportQuery, SuperuserTelemetryImportQueryVariables>(SuperuserTelemetryImportDocument, options);
        }
export type SuperuserTelemetryImportQueryHookResult = ReturnType<typeof useSuperuserTelemetryImportQuery>;
export type SuperuserTelemetryImportLazyQueryHookResult = ReturnType<typeof useSuperuserTelemetryImportLazyQuery>;
export type SuperuserTelemetryImportQueryResult = Apollo.QueryResult<SuperuserTelemetryImportQuery, SuperuserTelemetryImportQueryVariables>;
export const SuperuserGenerateTelemetryImportDownloadLinkDocument = gql`
    mutation SuperuserGenerateTelemetryImportDownloadLink($id: UUID!) {
  superuserGenerateTelemetryImportDownloadLink(id: $id) {
    ok
    presignedUrl
    errors {
      field
      message
    }
  }
}
    `;
export type SuperuserGenerateTelemetryImportDownloadLinkMutationFn = Apollo.MutationFunction<SuperuserGenerateTelemetryImportDownloadLinkMutation, SuperuserGenerateTelemetryImportDownloadLinkMutationVariables>;

/**
 * __useSuperuserGenerateTelemetryImportDownloadLinkMutation__
 *
 * To run a mutation, you first call `useSuperuserGenerateTelemetryImportDownloadLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserGenerateTelemetryImportDownloadLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserGenerateTelemetryImportDownloadLinkMutation, { data, loading, error }] = useSuperuserGenerateTelemetryImportDownloadLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserGenerateTelemetryImportDownloadLinkMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserGenerateTelemetryImportDownloadLinkMutation, SuperuserGenerateTelemetryImportDownloadLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserGenerateTelemetryImportDownloadLinkMutation, SuperuserGenerateTelemetryImportDownloadLinkMutationVariables>(SuperuserGenerateTelemetryImportDownloadLinkDocument, options);
      }
export type SuperuserGenerateTelemetryImportDownloadLinkMutationHookResult = ReturnType<typeof useSuperuserGenerateTelemetryImportDownloadLinkMutation>;
export type SuperuserGenerateTelemetryImportDownloadLinkMutationResult = Apollo.MutationResult<SuperuserGenerateTelemetryImportDownloadLinkMutation>;
export type SuperuserGenerateTelemetryImportDownloadLinkMutationOptions = Apollo.BaseMutationOptions<SuperuserGenerateTelemetryImportDownloadLinkMutation, SuperuserGenerateTelemetryImportDownloadLinkMutationVariables>;
export const SuperuserDeleteTelemetryImportDocument = gql`
    mutation SuperuserDeleteTelemetryImport($id: UUID!) {
  superuserDeleteTelemetryImport(id: $id) {
    ok
  }
}
    `;
export type SuperuserDeleteTelemetryImportMutationFn = Apollo.MutationFunction<SuperuserDeleteTelemetryImportMutation, SuperuserDeleteTelemetryImportMutationVariables>;

/**
 * __useSuperuserDeleteTelemetryImportMutation__
 *
 * To run a mutation, you first call `useSuperuserDeleteTelemetryImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserDeleteTelemetryImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserDeleteTelemetryImportMutation, { data, loading, error }] = useSuperuserDeleteTelemetryImportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserDeleteTelemetryImportMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserDeleteTelemetryImportMutation, SuperuserDeleteTelemetryImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserDeleteTelemetryImportMutation, SuperuserDeleteTelemetryImportMutationVariables>(SuperuserDeleteTelemetryImportDocument, options);
      }
export type SuperuserDeleteTelemetryImportMutationHookResult = ReturnType<typeof useSuperuserDeleteTelemetryImportMutation>;
export type SuperuserDeleteTelemetryImportMutationResult = Apollo.MutationResult<SuperuserDeleteTelemetryImportMutation>;
export type SuperuserDeleteTelemetryImportMutationOptions = Apollo.BaseMutationOptions<SuperuserDeleteTelemetryImportMutation, SuperuserDeleteTelemetryImportMutationVariables>;
export const SuperuserRetryTelemetryImportDocument = gql`
    mutation SuperuserRetryTelemetryImport($id: UUID!) {
  superuserRetryTelemetryImport(id: $id) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type SuperuserRetryTelemetryImportMutationFn = Apollo.MutationFunction<SuperuserRetryTelemetryImportMutation, SuperuserRetryTelemetryImportMutationVariables>;

/**
 * __useSuperuserRetryTelemetryImportMutation__
 *
 * To run a mutation, you first call `useSuperuserRetryTelemetryImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserRetryTelemetryImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserRetryTelemetryImportMutation, { data, loading, error }] = useSuperuserRetryTelemetryImportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserRetryTelemetryImportMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserRetryTelemetryImportMutation, SuperuserRetryTelemetryImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserRetryTelemetryImportMutation, SuperuserRetryTelemetryImportMutationVariables>(SuperuserRetryTelemetryImportDocument, options);
      }
export type SuperuserRetryTelemetryImportMutationHookResult = ReturnType<typeof useSuperuserRetryTelemetryImportMutation>;
export type SuperuserRetryTelemetryImportMutationResult = Apollo.MutationResult<SuperuserRetryTelemetryImportMutation>;
export type SuperuserRetryTelemetryImportMutationOptions = Apollo.BaseMutationOptions<SuperuserRetryTelemetryImportMutation, SuperuserRetryTelemetryImportMutationVariables>;
export const LapsDocument = gql`
    query Laps($eventDeviceId: UUID!) {
  laps(eventDeviceId: $eventDeviceId) {
    id
    lapNumber
    lapTime
    startTime
    endTime
    aggregates
  }
}
    `;

/**
 * __useLapsQuery__
 *
 * To run a query within a React component, call `useLapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLapsQuery({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *   },
 * });
 */
export function useLapsQuery(baseOptions: Apollo.QueryHookOptions<LapsQuery, LapsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LapsQuery, LapsQueryVariables>(LapsDocument, options);
      }
export function useLapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LapsQuery, LapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LapsQuery, LapsQueryVariables>(LapsDocument, options);
        }
export type LapsQueryHookResult = ReturnType<typeof useLapsQuery>;
export type LapsLazyQueryHookResult = ReturnType<typeof useLapsLazyQuery>;
export type LapsQueryResult = Apollo.QueryResult<LapsQuery, LapsQueryVariables>;
export const LapDataDocument = gql`
    query LapData($lapId: UUID!) {
  lapById(id: $lapId) {
    lapData
  }
}
    `;

/**
 * __useLapDataQuery__
 *
 * To run a query within a React component, call `useLapDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLapDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLapDataQuery({
 *   variables: {
 *      lapId: // value for 'lapId'
 *   },
 * });
 */
export function useLapDataQuery(baseOptions: Apollo.QueryHookOptions<LapDataQuery, LapDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LapDataQuery, LapDataQueryVariables>(LapDataDocument, options);
      }
export function useLapDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LapDataQuery, LapDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LapDataQuery, LapDataQueryVariables>(LapDataDocument, options);
        }
export type LapDataQueryHookResult = ReturnType<typeof useLapDataQuery>;
export type LapDataLazyQueryHookResult = ReturnType<typeof useLapDataLazyQuery>;
export type LapDataQueryResult = Apollo.QueryResult<LapDataQuery, LapDataQueryVariables>;
export const SuperuserLapsDocument = gql`
    query SuperuserLaps($eventDeviceId: UUID!) {
  superuserLaps(eventDeviceId: $eventDeviceId) {
    id
    endTime
    lapTime
  }
}
    `;

/**
 * __useSuperuserLapsQuery__
 *
 * To run a query within a React component, call `useSuperuserLapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserLapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserLapsQuery({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *   },
 * });
 */
export function useSuperuserLapsQuery(baseOptions: Apollo.QueryHookOptions<SuperuserLapsQuery, SuperuserLapsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserLapsQuery, SuperuserLapsQueryVariables>(SuperuserLapsDocument, options);
      }
export function useSuperuserLapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserLapsQuery, SuperuserLapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserLapsQuery, SuperuserLapsQueryVariables>(SuperuserLapsDocument, options);
        }
export type SuperuserLapsQueryHookResult = ReturnType<typeof useSuperuserLapsQuery>;
export type SuperuserLapsLazyQueryHookResult = ReturnType<typeof useSuperuserLapsLazyQuery>;
export type SuperuserLapsQueryResult = Apollo.QueryResult<SuperuserLapsQuery, SuperuserLapsQueryVariables>;
export const SuperuserLapDocument = gql`
    query SuperuserLap($id: UUID!) {
  superuserLap(id: $id) {
    id
    startTime
    endTime
    lapTime
    aggregates
    venue {
      id
      name
    }
  }
}
    `;

/**
 * __useSuperuserLapQuery__
 *
 * To run a query within a React component, call `useSuperuserLapQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserLapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserLapQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserLapQuery(baseOptions: Apollo.QueryHookOptions<SuperuserLapQuery, SuperuserLapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserLapQuery, SuperuserLapQueryVariables>(SuperuserLapDocument, options);
      }
export function useSuperuserLapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserLapQuery, SuperuserLapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserLapQuery, SuperuserLapQueryVariables>(SuperuserLapDocument, options);
        }
export type SuperuserLapQueryHookResult = ReturnType<typeof useSuperuserLapQuery>;
export type SuperuserLapLazyQueryHookResult = ReturnType<typeof useSuperuserLapLazyQuery>;
export type SuperuserLapQueryResult = Apollo.QueryResult<SuperuserLapQuery, SuperuserLapQueryVariables>;
export const SuperuserEventDeviceLegacyStatusDocument = gql`
    query SuperuserEventDeviceLegacyStatus($eventDeviceId: UUID!) {
  superuserEventDeviceLegacyStatus(eventDeviceId: $eventDeviceId) {
    isLegacy
    legacyEventdeviceId
  }
}
    `;

/**
 * __useSuperuserEventDeviceLegacyStatusQuery__
 *
 * To run a query within a React component, call `useSuperuserEventDeviceLegacyStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserEventDeviceLegacyStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserEventDeviceLegacyStatusQuery({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *   },
 * });
 */
export function useSuperuserEventDeviceLegacyStatusQuery(baseOptions: Apollo.QueryHookOptions<SuperuserEventDeviceLegacyStatusQuery, SuperuserEventDeviceLegacyStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserEventDeviceLegacyStatusQuery, SuperuserEventDeviceLegacyStatusQueryVariables>(SuperuserEventDeviceLegacyStatusDocument, options);
      }
export function useSuperuserEventDeviceLegacyStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserEventDeviceLegacyStatusQuery, SuperuserEventDeviceLegacyStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserEventDeviceLegacyStatusQuery, SuperuserEventDeviceLegacyStatusQueryVariables>(SuperuserEventDeviceLegacyStatusDocument, options);
        }
export type SuperuserEventDeviceLegacyStatusQueryHookResult = ReturnType<typeof useSuperuserEventDeviceLegacyStatusQuery>;
export type SuperuserEventDeviceLegacyStatusLazyQueryHookResult = ReturnType<typeof useSuperuserEventDeviceLegacyStatusLazyQuery>;
export type SuperuserEventDeviceLegacyStatusQueryResult = Apollo.QueryResult<SuperuserEventDeviceLegacyStatusQuery, SuperuserEventDeviceLegacyStatusQueryVariables>;
export const SuperuserLegacyArchivesDocument = gql`
    query SuperuserLegacyArchives($eventDeviceId: UUID!) {
  superuserLegacyArchives(eventDeviceId: $eventDeviceId) {
    path
    start
    end
  }
}
    `;

/**
 * __useSuperuserLegacyArchivesQuery__
 *
 * To run a query within a React component, call `useSuperuserLegacyArchivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserLegacyArchivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserLegacyArchivesQuery({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *   },
 * });
 */
export function useSuperuserLegacyArchivesQuery(baseOptions: Apollo.QueryHookOptions<SuperuserLegacyArchivesQuery, SuperuserLegacyArchivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserLegacyArchivesQuery, SuperuserLegacyArchivesQueryVariables>(SuperuserLegacyArchivesDocument, options);
      }
export function useSuperuserLegacyArchivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserLegacyArchivesQuery, SuperuserLegacyArchivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserLegacyArchivesQuery, SuperuserLegacyArchivesQueryVariables>(SuperuserLegacyArchivesDocument, options);
        }
export type SuperuserLegacyArchivesQueryHookResult = ReturnType<typeof useSuperuserLegacyArchivesQuery>;
export type SuperuserLegacyArchivesLazyQueryHookResult = ReturnType<typeof useSuperuserLegacyArchivesLazyQuery>;
export type SuperuserLegacyArchivesQueryResult = Apollo.QueryResult<SuperuserLegacyArchivesQuery, SuperuserLegacyArchivesQueryVariables>;
export const SuperuserGetLegacyArchiveDownloadLinkDocument = gql`
    mutation SuperuserGetLegacyArchiveDownloadLink($eventDeviceId: UUID!, $path: String!) {
  superuserGetLegacyArchiveDownloadLink(
    eventDeviceId: $eventDeviceId
    path: $path
  ) {
    ok
    downloadLink
  }
}
    `;
export type SuperuserGetLegacyArchiveDownloadLinkMutationFn = Apollo.MutationFunction<SuperuserGetLegacyArchiveDownloadLinkMutation, SuperuserGetLegacyArchiveDownloadLinkMutationVariables>;

/**
 * __useSuperuserGetLegacyArchiveDownloadLinkMutation__
 *
 * To run a mutation, you first call `useSuperuserGetLegacyArchiveDownloadLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserGetLegacyArchiveDownloadLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserGetLegacyArchiveDownloadLinkMutation, { data, loading, error }] = useSuperuserGetLegacyArchiveDownloadLinkMutation({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useSuperuserGetLegacyArchiveDownloadLinkMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserGetLegacyArchiveDownloadLinkMutation, SuperuserGetLegacyArchiveDownloadLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserGetLegacyArchiveDownloadLinkMutation, SuperuserGetLegacyArchiveDownloadLinkMutationVariables>(SuperuserGetLegacyArchiveDownloadLinkDocument, options);
      }
export type SuperuserGetLegacyArchiveDownloadLinkMutationHookResult = ReturnType<typeof useSuperuserGetLegacyArchiveDownloadLinkMutation>;
export type SuperuserGetLegacyArchiveDownloadLinkMutationResult = Apollo.MutationResult<SuperuserGetLegacyArchiveDownloadLinkMutation>;
export type SuperuserGetLegacyArchiveDownloadLinkMutationOptions = Apollo.BaseMutationOptions<SuperuserGetLegacyArchiveDownloadLinkMutation, SuperuserGetLegacyArchiveDownloadLinkMutationVariables>;
export const SuperuserSummaryDocument = gql`
    query SuperuserSummary {
  superuserSummary {
    usersCount
    devicesCount
    eventsCount
    lapsCount
  }
}
    `;

/**
 * __useSuperuserSummaryQuery__
 *
 * To run a query within a React component, call `useSuperuserSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuperuserSummaryQuery(baseOptions?: Apollo.QueryHookOptions<SuperuserSummaryQuery, SuperuserSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserSummaryQuery, SuperuserSummaryQueryVariables>(SuperuserSummaryDocument, options);
      }
export function useSuperuserSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserSummaryQuery, SuperuserSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserSummaryQuery, SuperuserSummaryQueryVariables>(SuperuserSummaryDocument, options);
        }
export type SuperuserSummaryQueryHookResult = ReturnType<typeof useSuperuserSummaryQuery>;
export type SuperuserSummaryLazyQueryHookResult = ReturnType<typeof useSuperuserSummaryLazyQuery>;
export type SuperuserSummaryQueryResult = Apollo.QueryResult<SuperuserSummaryQuery, SuperuserSummaryQueryVariables>;
export const OauthAuthorizationRequestDocument = gql`
    query OauthAuthorizationRequest($request: String!) {
  oauthAuthorizationRequest(request: $request) {
    ok
    error
    errorRedirectUri
    errors {
      field
      message
    }
    authorizationRequest {
      application {
        id
        name
        clientId
        skipAuthorization
        isSelfRegistered
      }
      scopes {
        key
        label
        description
      }
      redirectUri
      state
    }
  }
}
    `;

/**
 * __useOauthAuthorizationRequestQuery__
 *
 * To run a query within a React component, call `useOauthAuthorizationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useOauthAuthorizationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOauthAuthorizationRequestQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useOauthAuthorizationRequestQuery(baseOptions: Apollo.QueryHookOptions<OauthAuthorizationRequestQuery, OauthAuthorizationRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OauthAuthorizationRequestQuery, OauthAuthorizationRequestQueryVariables>(OauthAuthorizationRequestDocument, options);
      }
export function useOauthAuthorizationRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OauthAuthorizationRequestQuery, OauthAuthorizationRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OauthAuthorizationRequestQuery, OauthAuthorizationRequestQueryVariables>(OauthAuthorizationRequestDocument, options);
        }
export type OauthAuthorizationRequestQueryHookResult = ReturnType<typeof useOauthAuthorizationRequestQuery>;
export type OauthAuthorizationRequestLazyQueryHookResult = ReturnType<typeof useOauthAuthorizationRequestLazyQuery>;
export type OauthAuthorizationRequestQueryResult = Apollo.QueryResult<OauthAuthorizationRequestQuery, OauthAuthorizationRequestQueryVariables>;
export const AuthorizeOauthApplicationDocument = gql`
    mutation AuthorizeOauthApplication($request: String!, $allow: Boolean!, $scopes: [String!]) {
  authorizeOauthApplication(request: $request, allow: $allow, scopes: $scopes) {
    ok
    error
    redirectUri
    errors {
      field
      message
    }
  }
}
    `;
export type AuthorizeOauthApplicationMutationFn = Apollo.MutationFunction<AuthorizeOauthApplicationMutation, AuthorizeOauthApplicationMutationVariables>;

/**
 * __useAuthorizeOauthApplicationMutation__
 *
 * To run a mutation, you first call `useAuthorizeOauthApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthorizeOauthApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authorizeOauthApplicationMutation, { data, loading, error }] = useAuthorizeOauthApplicationMutation({
 *   variables: {
 *      request: // value for 'request'
 *      allow: // value for 'allow'
 *      scopes: // value for 'scopes'
 *   },
 * });
 */
export function useAuthorizeOauthApplicationMutation(baseOptions?: Apollo.MutationHookOptions<AuthorizeOauthApplicationMutation, AuthorizeOauthApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthorizeOauthApplicationMutation, AuthorizeOauthApplicationMutationVariables>(AuthorizeOauthApplicationDocument, options);
      }
export type AuthorizeOauthApplicationMutationHookResult = ReturnType<typeof useAuthorizeOauthApplicationMutation>;
export type AuthorizeOauthApplicationMutationResult = Apollo.MutationResult<AuthorizeOauthApplicationMutation>;
export type AuthorizeOauthApplicationMutationOptions = Apollo.BaseMutationOptions<AuthorizeOauthApplicationMutation, AuthorizeOauthApplicationMutationVariables>;
export const OauthApplicationsDocument = gql`
    query OauthApplications {
  oauthApplications {
    ...OAuthApplicationFields
  }
}
    ${OAuthApplicationFieldsFragmentDoc}`;

/**
 * __useOauthApplicationsQuery__
 *
 * To run a query within a React component, call `useOauthApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOauthApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOauthApplicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOauthApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<OauthApplicationsQuery, OauthApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OauthApplicationsQuery, OauthApplicationsQueryVariables>(OauthApplicationsDocument, options);
      }
export function useOauthApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OauthApplicationsQuery, OauthApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OauthApplicationsQuery, OauthApplicationsQueryVariables>(OauthApplicationsDocument, options);
        }
export type OauthApplicationsQueryHookResult = ReturnType<typeof useOauthApplicationsQuery>;
export type OauthApplicationsLazyQueryHookResult = ReturnType<typeof useOauthApplicationsLazyQuery>;
export type OauthApplicationsQueryResult = Apollo.QueryResult<OauthApplicationsQuery, OauthApplicationsQueryVariables>;
export const AuthorizedOauthApplicationsDocument = gql`
    query AuthorizedOauthApplications {
  authorizedOauthApplications {
    application {
      id
      name
      clientId
      skipAuthorization
    }
    scopes
    authorizedAt
  }
}
    `;

/**
 * __useAuthorizedOauthApplicationsQuery__
 *
 * To run a query within a React component, call `useAuthorizedOauthApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorizedOauthApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorizedOauthApplicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthorizedOauthApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<AuthorizedOauthApplicationsQuery, AuthorizedOauthApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorizedOauthApplicationsQuery, AuthorizedOauthApplicationsQueryVariables>(AuthorizedOauthApplicationsDocument, options);
      }
export function useAuthorizedOauthApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorizedOauthApplicationsQuery, AuthorizedOauthApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorizedOauthApplicationsQuery, AuthorizedOauthApplicationsQueryVariables>(AuthorizedOauthApplicationsDocument, options);
        }
export type AuthorizedOauthApplicationsQueryHookResult = ReturnType<typeof useAuthorizedOauthApplicationsQuery>;
export type AuthorizedOauthApplicationsLazyQueryHookResult = ReturnType<typeof useAuthorizedOauthApplicationsLazyQuery>;
export type AuthorizedOauthApplicationsQueryResult = Apollo.QueryResult<AuthorizedOauthApplicationsQuery, AuthorizedOauthApplicationsQueryVariables>;
export const RegisterOauthApplicationDocument = gql`
    mutation RegisterOauthApplication($name: String!, $redirectUris: [String!]!, $allowedScopes: [String!]!, $clientType: OAuthClientType!, $allowedOrigins: [String!]) {
  registerOauthApplication(
    name: $name
    redirectUris: $redirectUris
    allowedScopes: $allowedScopes
    clientType: $clientType
    allowedOrigins: $allowedOrigins
  ) {
    ok
    errors {
      field
      message
    }
    clientSecret
    application {
      ...OAuthApplicationFields
    }
  }
}
    ${OAuthApplicationFieldsFragmentDoc}`;
export type RegisterOauthApplicationMutationFn = Apollo.MutationFunction<RegisterOauthApplicationMutation, RegisterOauthApplicationMutationVariables>;

/**
 * __useRegisterOauthApplicationMutation__
 *
 * To run a mutation, you first call `useRegisterOauthApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterOauthApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerOauthApplicationMutation, { data, loading, error }] = useRegisterOauthApplicationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      redirectUris: // value for 'redirectUris'
 *      allowedScopes: // value for 'allowedScopes'
 *      clientType: // value for 'clientType'
 *      allowedOrigins: // value for 'allowedOrigins'
 *   },
 * });
 */
export function useRegisterOauthApplicationMutation(baseOptions?: Apollo.MutationHookOptions<RegisterOauthApplicationMutation, RegisterOauthApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterOauthApplicationMutation, RegisterOauthApplicationMutationVariables>(RegisterOauthApplicationDocument, options);
      }
export type RegisterOauthApplicationMutationHookResult = ReturnType<typeof useRegisterOauthApplicationMutation>;
export type RegisterOauthApplicationMutationResult = Apollo.MutationResult<RegisterOauthApplicationMutation>;
export type RegisterOauthApplicationMutationOptions = Apollo.BaseMutationOptions<RegisterOauthApplicationMutation, RegisterOauthApplicationMutationVariables>;
export const UpdateOauthApplicationDocument = gql`
    mutation UpdateOauthApplication($id: UUID!, $name: String, $redirectUris: [String!], $allowedScopes: [String!], $isActive: Boolean, $allowedOrigins: [String!]) {
  updateOauthApplication(
    id: $id
    name: $name
    redirectUris: $redirectUris
    allowedScopes: $allowedScopes
    isActive: $isActive
    allowedOrigins: $allowedOrigins
  ) {
    ok
    errors {
      field
      message
    }
    application {
      ...OAuthApplicationFields
    }
  }
}
    ${OAuthApplicationFieldsFragmentDoc}`;
export type UpdateOauthApplicationMutationFn = Apollo.MutationFunction<UpdateOauthApplicationMutation, UpdateOauthApplicationMutationVariables>;

/**
 * __useUpdateOauthApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateOauthApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOauthApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOauthApplicationMutation, { data, loading, error }] = useUpdateOauthApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      redirectUris: // value for 'redirectUris'
 *      allowedScopes: // value for 'allowedScopes'
 *      isActive: // value for 'isActive'
 *      allowedOrigins: // value for 'allowedOrigins'
 *   },
 * });
 */
export function useUpdateOauthApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOauthApplicationMutation, UpdateOauthApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOauthApplicationMutation, UpdateOauthApplicationMutationVariables>(UpdateOauthApplicationDocument, options);
      }
export type UpdateOauthApplicationMutationHookResult = ReturnType<typeof useUpdateOauthApplicationMutation>;
export type UpdateOauthApplicationMutationResult = Apollo.MutationResult<UpdateOauthApplicationMutation>;
export type UpdateOauthApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateOauthApplicationMutation, UpdateOauthApplicationMutationVariables>;
export const DeleteOauthApplicationDocument = gql`
    mutation DeleteOauthApplication($id: UUID!) {
  deleteOauthApplication(id: $id) {
    ok
  }
}
    `;
export type DeleteOauthApplicationMutationFn = Apollo.MutationFunction<DeleteOauthApplicationMutation, DeleteOauthApplicationMutationVariables>;

/**
 * __useDeleteOauthApplicationMutation__
 *
 * To run a mutation, you first call `useDeleteOauthApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOauthApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOauthApplicationMutation, { data, loading, error }] = useDeleteOauthApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOauthApplicationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOauthApplicationMutation, DeleteOauthApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOauthApplicationMutation, DeleteOauthApplicationMutationVariables>(DeleteOauthApplicationDocument, options);
      }
export type DeleteOauthApplicationMutationHookResult = ReturnType<typeof useDeleteOauthApplicationMutation>;
export type DeleteOauthApplicationMutationResult = Apollo.MutationResult<DeleteOauthApplicationMutation>;
export type DeleteOauthApplicationMutationOptions = Apollo.BaseMutationOptions<DeleteOauthApplicationMutation, DeleteOauthApplicationMutationVariables>;
export const RevokeOauthApplicationAccessDocument = gql`
    mutation RevokeOauthApplicationAccess($applicationId: UUID!) {
  revokeOauthApplicationAccess(applicationId: $applicationId) {
    ok
  }
}
    `;
export type RevokeOauthApplicationAccessMutationFn = Apollo.MutationFunction<RevokeOauthApplicationAccessMutation, RevokeOauthApplicationAccessMutationVariables>;

/**
 * __useRevokeOauthApplicationAccessMutation__
 *
 * To run a mutation, you first call `useRevokeOauthApplicationAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeOauthApplicationAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeOauthApplicationAccessMutation, { data, loading, error }] = useRevokeOauthApplicationAccessMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useRevokeOauthApplicationAccessMutation(baseOptions?: Apollo.MutationHookOptions<RevokeOauthApplicationAccessMutation, RevokeOauthApplicationAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeOauthApplicationAccessMutation, RevokeOauthApplicationAccessMutationVariables>(RevokeOauthApplicationAccessDocument, options);
      }
export type RevokeOauthApplicationAccessMutationHookResult = ReturnType<typeof useRevokeOauthApplicationAccessMutation>;
export type RevokeOauthApplicationAccessMutationResult = Apollo.MutationResult<RevokeOauthApplicationAccessMutation>;
export type RevokeOauthApplicationAccessMutationOptions = Apollo.BaseMutationOptions<RevokeOauthApplicationAccessMutation, RevokeOauthApplicationAccessMutationVariables>;
export const PresetTypesDocument = gql`
    query PresetTypes {
  presetTypes {
    id
    prettyName
    description
    typeKey
  }
}
    `;

/**
 * __usePresetTypesQuery__
 *
 * To run a query within a React component, call `usePresetTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresetTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresetTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePresetTypesQuery(baseOptions?: Apollo.QueryHookOptions<PresetTypesQuery, PresetTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PresetTypesQuery, PresetTypesQueryVariables>(PresetTypesDocument, options);
      }
export function usePresetTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PresetTypesQuery, PresetTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PresetTypesQuery, PresetTypesQueryVariables>(PresetTypesDocument, options);
        }
export type PresetTypesQueryHookResult = ReturnType<typeof usePresetTypesQuery>;
export type PresetTypesLazyQueryHookResult = ReturnType<typeof usePresetTypesLazyQuery>;
export type PresetTypesQueryResult = Apollo.QueryResult<PresetTypesQuery, PresetTypesQueryVariables>;
export const SuperuserPresetTypesDocument = gql`
    query SuperuserPresetTypes {
  superuserPresetTypes {
    id
    prettyName
    description
    typeKey
  }
}
    `;

/**
 * __useSuperuserPresetTypesQuery__
 *
 * To run a query within a React component, call `useSuperuserPresetTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserPresetTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserPresetTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuperuserPresetTypesQuery(baseOptions?: Apollo.QueryHookOptions<SuperuserPresetTypesQuery, SuperuserPresetTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserPresetTypesQuery, SuperuserPresetTypesQueryVariables>(SuperuserPresetTypesDocument, options);
      }
export function useSuperuserPresetTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserPresetTypesQuery, SuperuserPresetTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserPresetTypesQuery, SuperuserPresetTypesQueryVariables>(SuperuserPresetTypesDocument, options);
        }
export type SuperuserPresetTypesQueryHookResult = ReturnType<typeof useSuperuserPresetTypesQuery>;
export type SuperuserPresetTypesLazyQueryHookResult = ReturnType<typeof useSuperuserPresetTypesLazyQuery>;
export type SuperuserPresetTypesQueryResult = Apollo.QueryResult<SuperuserPresetTypesQuery, SuperuserPresetTypesQueryVariables>;
export const SuperuserPresetTypeDocument = gql`
    query SuperuserPresetType($id: UUID!) {
  superuserPresetTypeById(id: $id) {
    id
    prettyName
    description
    typeKey
  }
}
    `;

/**
 * __useSuperuserPresetTypeQuery__
 *
 * To run a query within a React component, call `useSuperuserPresetTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserPresetTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserPresetTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserPresetTypeQuery(baseOptions: Apollo.QueryHookOptions<SuperuserPresetTypeQuery, SuperuserPresetTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserPresetTypeQuery, SuperuserPresetTypeQueryVariables>(SuperuserPresetTypeDocument, options);
      }
export function useSuperuserPresetTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserPresetTypeQuery, SuperuserPresetTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserPresetTypeQuery, SuperuserPresetTypeQueryVariables>(SuperuserPresetTypeDocument, options);
        }
export type SuperuserPresetTypeQueryHookResult = ReturnType<typeof useSuperuserPresetTypeQuery>;
export type SuperuserPresetTypeLazyQueryHookResult = ReturnType<typeof useSuperuserPresetTypeLazyQuery>;
export type SuperuserPresetTypeQueryResult = Apollo.QueryResult<SuperuserPresetTypeQuery, SuperuserPresetTypeQueryVariables>;
export const SuperuserDeletePresetTypeDocument = gql`
    mutation SuperuserDeletePresetType($id: UUID!) {
  superuserDeletePresetType(id: $id) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type SuperuserDeletePresetTypeMutationFn = Apollo.MutationFunction<SuperuserDeletePresetTypeMutation, SuperuserDeletePresetTypeMutationVariables>;

/**
 * __useSuperuserDeletePresetTypeMutation__
 *
 * To run a mutation, you first call `useSuperuserDeletePresetTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserDeletePresetTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserDeletePresetTypeMutation, { data, loading, error }] = useSuperuserDeletePresetTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserDeletePresetTypeMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserDeletePresetTypeMutation, SuperuserDeletePresetTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserDeletePresetTypeMutation, SuperuserDeletePresetTypeMutationVariables>(SuperuserDeletePresetTypeDocument, options);
      }
export type SuperuserDeletePresetTypeMutationHookResult = ReturnType<typeof useSuperuserDeletePresetTypeMutation>;
export type SuperuserDeletePresetTypeMutationResult = Apollo.MutationResult<SuperuserDeletePresetTypeMutation>;
export type SuperuserDeletePresetTypeMutationOptions = Apollo.BaseMutationOptions<SuperuserDeletePresetTypeMutation, SuperuserDeletePresetTypeMutationVariables>;
export const SuperuserCreatePresetTypeDocument = gql`
    mutation SuperuserCreatePresetType($prettyName: String!, $description: String!, $typeKey: String!) {
  superuserCreatePresetType(
    prettyName: $prettyName
    description: $description
    typeKey: $typeKey
  ) {
    ok
    errors {
      field
      message
    }
    presetType {
      id
    }
  }
}
    `;
export type SuperuserCreatePresetTypeMutationFn = Apollo.MutationFunction<SuperuserCreatePresetTypeMutation, SuperuserCreatePresetTypeMutationVariables>;

/**
 * __useSuperuserCreatePresetTypeMutation__
 *
 * To run a mutation, you first call `useSuperuserCreatePresetTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserCreatePresetTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserCreatePresetTypeMutation, { data, loading, error }] = useSuperuserCreatePresetTypeMutation({
 *   variables: {
 *      prettyName: // value for 'prettyName'
 *      description: // value for 'description'
 *      typeKey: // value for 'typeKey'
 *   },
 * });
 */
export function useSuperuserCreatePresetTypeMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserCreatePresetTypeMutation, SuperuserCreatePresetTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserCreatePresetTypeMutation, SuperuserCreatePresetTypeMutationVariables>(SuperuserCreatePresetTypeDocument, options);
      }
export type SuperuserCreatePresetTypeMutationHookResult = ReturnType<typeof useSuperuserCreatePresetTypeMutation>;
export type SuperuserCreatePresetTypeMutationResult = Apollo.MutationResult<SuperuserCreatePresetTypeMutation>;
export type SuperuserCreatePresetTypeMutationOptions = Apollo.BaseMutationOptions<SuperuserCreatePresetTypeMutation, SuperuserCreatePresetTypeMutationVariables>;
export const SuperuserUpdatePresetTypeDocument = gql`
    mutation SuperuserUpdatePresetType($id: UUID!, $prettyName: String, $description: String, $typeKey: String) {
  superuserUpdatePresetType(
    id: $id
    prettyName: $prettyName
    description: $description
    typeKey: $typeKey
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type SuperuserUpdatePresetTypeMutationFn = Apollo.MutationFunction<SuperuserUpdatePresetTypeMutation, SuperuserUpdatePresetTypeMutationVariables>;

/**
 * __useSuperuserUpdatePresetTypeMutation__
 *
 * To run a mutation, you first call `useSuperuserUpdatePresetTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserUpdatePresetTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserUpdatePresetTypeMutation, { data, loading, error }] = useSuperuserUpdatePresetTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      prettyName: // value for 'prettyName'
 *      description: // value for 'description'
 *      typeKey: // value for 'typeKey'
 *   },
 * });
 */
export function useSuperuserUpdatePresetTypeMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserUpdatePresetTypeMutation, SuperuserUpdatePresetTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserUpdatePresetTypeMutation, SuperuserUpdatePresetTypeMutationVariables>(SuperuserUpdatePresetTypeDocument, options);
      }
export type SuperuserUpdatePresetTypeMutationHookResult = ReturnType<typeof useSuperuserUpdatePresetTypeMutation>;
export type SuperuserUpdatePresetTypeMutationResult = Apollo.MutationResult<SuperuserUpdatePresetTypeMutation>;
export type SuperuserUpdatePresetTypeMutationOptions = Apollo.BaseMutationOptions<SuperuserUpdatePresetTypeMutation, SuperuserUpdatePresetTypeMutationVariables>;
export const PresetsDocument = gql`
    query Presets {
  presets {
    id
    name
    presetType {
      id
      prettyName
    }
  }
}
    `;

/**
 * __usePresetsQuery__
 *
 * To run a query within a React component, call `usePresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresetsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePresetsQuery(baseOptions?: Apollo.QueryHookOptions<PresetsQuery, PresetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PresetsQuery, PresetsQueryVariables>(PresetsDocument, options);
      }
export function usePresetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PresetsQuery, PresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PresetsQuery, PresetsQueryVariables>(PresetsDocument, options);
        }
export type PresetsQueryHookResult = ReturnType<typeof usePresetsQuery>;
export type PresetsLazyQueryHookResult = ReturnType<typeof usePresetsLazyQuery>;
export type PresetsQueryResult = Apollo.QueryResult<PresetsQuery, PresetsQueryVariables>;
export const PresetDocument = gql`
    query Preset($id: UUID!) {
  presetById(id: $id) {
    id
    name
    notes
    createdAt
    presetData
    previewImageSmall
    previewImageMedium
    previewImageLarge
    presetType {
      id
      prettyName
    }
  }
}
    `;

/**
 * __usePresetQuery__
 *
 * To run a query within a React component, call `usePresetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePresetQuery(baseOptions: Apollo.QueryHookOptions<PresetQuery, PresetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PresetQuery, PresetQueryVariables>(PresetDocument, options);
      }
export function usePresetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PresetQuery, PresetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PresetQuery, PresetQueryVariables>(PresetDocument, options);
        }
export type PresetQueryHookResult = ReturnType<typeof usePresetQuery>;
export type PresetLazyQueryHookResult = ReturnType<typeof usePresetLazyQuery>;
export type PresetQueryResult = Apollo.QueryResult<PresetQuery, PresetQueryVariables>;
export const CreatePresetDocument = gql`
    mutation CreatePreset($name: String!, $notes: String!, $presetData: String!, $previewImage: Upload, $presetTypeId: UUID!) {
  createPreset(
    name: $name
    notes: $notes
    presetData: $presetData
    previewImage: $previewImage
    presetTypeId: $presetTypeId
  ) {
    ok
    errors {
      field
      message
    }
    preset {
      id
    }
  }
}
    `;
export type CreatePresetMutationFn = Apollo.MutationFunction<CreatePresetMutation, CreatePresetMutationVariables>;

/**
 * __useCreatePresetMutation__
 *
 * To run a mutation, you first call `useCreatePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPresetMutation, { data, loading, error }] = useCreatePresetMutation({
 *   variables: {
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *      presetData: // value for 'presetData'
 *      previewImage: // value for 'previewImage'
 *      presetTypeId: // value for 'presetTypeId'
 *   },
 * });
 */
export function useCreatePresetMutation(baseOptions?: Apollo.MutationHookOptions<CreatePresetMutation, CreatePresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePresetMutation, CreatePresetMutationVariables>(CreatePresetDocument, options);
      }
export type CreatePresetMutationHookResult = ReturnType<typeof useCreatePresetMutation>;
export type CreatePresetMutationResult = Apollo.MutationResult<CreatePresetMutation>;
export type CreatePresetMutationOptions = Apollo.BaseMutationOptions<CreatePresetMutation, CreatePresetMutationVariables>;
export const EditPresetDocument = gql`
    mutation EditPreset($id: UUID!, $name: String, $notes: String, $presetData: String, $previewImage: Upload, $presetTypeId: UUID) {
  updatePreset(
    id: $id
    name: $name
    notes: $notes
    presetData: $presetData
    previewImage: $previewImage
    presetTypeId: $presetTypeId
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type EditPresetMutationFn = Apollo.MutationFunction<EditPresetMutation, EditPresetMutationVariables>;

/**
 * __useEditPresetMutation__
 *
 * To run a mutation, you first call `useEditPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPresetMutation, { data, loading, error }] = useEditPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *      presetData: // value for 'presetData'
 *      previewImage: // value for 'previewImage'
 *      presetTypeId: // value for 'presetTypeId'
 *   },
 * });
 */
export function useEditPresetMutation(baseOptions?: Apollo.MutationHookOptions<EditPresetMutation, EditPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPresetMutation, EditPresetMutationVariables>(EditPresetDocument, options);
      }
export type EditPresetMutationHookResult = ReturnType<typeof useEditPresetMutation>;
export type EditPresetMutationResult = Apollo.MutationResult<EditPresetMutation>;
export type EditPresetMutationOptions = Apollo.BaseMutationOptions<EditPresetMutation, EditPresetMutationVariables>;
export const DeletePresetDocument = gql`
    mutation DeletePreset($id: UUID!) {
  deletePreset(id: $id) {
    ok
  }
}
    `;
export type DeletePresetMutationFn = Apollo.MutationFunction<DeletePresetMutation, DeletePresetMutationVariables>;

/**
 * __useDeletePresetMutation__
 *
 * To run a mutation, you first call `useDeletePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePresetMutation, { data, loading, error }] = useDeletePresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePresetMutation(baseOptions?: Apollo.MutationHookOptions<DeletePresetMutation, DeletePresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePresetMutation, DeletePresetMutationVariables>(DeletePresetDocument, options);
      }
export type DeletePresetMutationHookResult = ReturnType<typeof useDeletePresetMutation>;
export type DeletePresetMutationResult = Apollo.MutationResult<DeletePresetMutation>;
export type DeletePresetMutationOptions = Apollo.BaseMutationOptions<DeletePresetMutation, DeletePresetMutationVariables>;
export const SuperuserPresetsDocument = gql`
    query SuperuserPresets($rowsPerPage: Int, $page: Int, $isSystem: Boolean) {
  superuserPresets(rowsPerPage: $rowsPerPage, page: $page, isSystem: $isSystem) {
    items {
      id
      name
      isSystem
      presetType {
        id
        prettyName
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useSuperuserPresetsQuery__
 *
 * To run a query within a React component, call `useSuperuserPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserPresetsQuery({
 *   variables: {
 *      rowsPerPage: // value for 'rowsPerPage'
 *      page: // value for 'page'
 *      isSystem: // value for 'isSystem'
 *   },
 * });
 */
export function useSuperuserPresetsQuery(baseOptions?: Apollo.QueryHookOptions<SuperuserPresetsQuery, SuperuserPresetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserPresetsQuery, SuperuserPresetsQueryVariables>(SuperuserPresetsDocument, options);
      }
export function useSuperuserPresetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserPresetsQuery, SuperuserPresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserPresetsQuery, SuperuserPresetsQueryVariables>(SuperuserPresetsDocument, options);
        }
export type SuperuserPresetsQueryHookResult = ReturnType<typeof useSuperuserPresetsQuery>;
export type SuperuserPresetsLazyQueryHookResult = ReturnType<typeof useSuperuserPresetsLazyQuery>;
export type SuperuserPresetsQueryResult = Apollo.QueryResult<SuperuserPresetsQuery, SuperuserPresetsQueryVariables>;
export const SuperuserPresetDocument = gql`
    query SuperuserPreset($id: UUID!) {
  superuserPresetById(id: $id) {
    id
    name
    notes
    createdAt
    presetData
    previewImageSmall
    previewImageMedium
    previewImageLarge
    presetType {
      id
      prettyName
    }
  }
}
    `;

/**
 * __useSuperuserPresetQuery__
 *
 * To run a query within a React component, call `useSuperuserPresetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserPresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserPresetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserPresetQuery(baseOptions: Apollo.QueryHookOptions<SuperuserPresetQuery, SuperuserPresetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserPresetQuery, SuperuserPresetQueryVariables>(SuperuserPresetDocument, options);
      }
export function useSuperuserPresetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserPresetQuery, SuperuserPresetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserPresetQuery, SuperuserPresetQueryVariables>(SuperuserPresetDocument, options);
        }
export type SuperuserPresetQueryHookResult = ReturnType<typeof useSuperuserPresetQuery>;
export type SuperuserPresetLazyQueryHookResult = ReturnType<typeof useSuperuserPresetLazyQuery>;
export type SuperuserPresetQueryResult = Apollo.QueryResult<SuperuserPresetQuery, SuperuserPresetQueryVariables>;
export const SuperuserCreatePresetDocument = gql`
    mutation SuperuserCreatePreset($name: String!, $notes: String!, $presetData: String!, $previewImage: Upload, $presetTypeId: UUID!) {
  superuserCreatePreset(
    name: $name
    notes: $notes
    presetData: $presetData
    previewImage: $previewImage
    presetTypeId: $presetTypeId
  ) {
    ok
    errors {
      field
      message
    }
    preset {
      id
    }
  }
}
    `;
export type SuperuserCreatePresetMutationFn = Apollo.MutationFunction<SuperuserCreatePresetMutation, SuperuserCreatePresetMutationVariables>;

/**
 * __useSuperuserCreatePresetMutation__
 *
 * To run a mutation, you first call `useSuperuserCreatePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserCreatePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserCreatePresetMutation, { data, loading, error }] = useSuperuserCreatePresetMutation({
 *   variables: {
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *      presetData: // value for 'presetData'
 *      previewImage: // value for 'previewImage'
 *      presetTypeId: // value for 'presetTypeId'
 *   },
 * });
 */
export function useSuperuserCreatePresetMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserCreatePresetMutation, SuperuserCreatePresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserCreatePresetMutation, SuperuserCreatePresetMutationVariables>(SuperuserCreatePresetDocument, options);
      }
export type SuperuserCreatePresetMutationHookResult = ReturnType<typeof useSuperuserCreatePresetMutation>;
export type SuperuserCreatePresetMutationResult = Apollo.MutationResult<SuperuserCreatePresetMutation>;
export type SuperuserCreatePresetMutationOptions = Apollo.BaseMutationOptions<SuperuserCreatePresetMutation, SuperuserCreatePresetMutationVariables>;
export const SuperuserEditPresetDocument = gql`
    mutation SuperuserEditPreset($id: UUID!, $name: String, $notes: String, $presetData: String, $previewImage: Upload, $presetTypeId: UUID) {
  superuserUpdatePreset(
    id: $id
    name: $name
    notes: $notes
    presetData: $presetData
    previewImage: $previewImage
    presetTypeId: $presetTypeId
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type SuperuserEditPresetMutationFn = Apollo.MutationFunction<SuperuserEditPresetMutation, SuperuserEditPresetMutationVariables>;

/**
 * __useSuperuserEditPresetMutation__
 *
 * To run a mutation, you first call `useSuperuserEditPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserEditPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserEditPresetMutation, { data, loading, error }] = useSuperuserEditPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *      presetData: // value for 'presetData'
 *      previewImage: // value for 'previewImage'
 *      presetTypeId: // value for 'presetTypeId'
 *   },
 * });
 */
export function useSuperuserEditPresetMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserEditPresetMutation, SuperuserEditPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserEditPresetMutation, SuperuserEditPresetMutationVariables>(SuperuserEditPresetDocument, options);
      }
export type SuperuserEditPresetMutationHookResult = ReturnType<typeof useSuperuserEditPresetMutation>;
export type SuperuserEditPresetMutationResult = Apollo.MutationResult<SuperuserEditPresetMutation>;
export type SuperuserEditPresetMutationOptions = Apollo.BaseMutationOptions<SuperuserEditPresetMutation, SuperuserEditPresetMutationVariables>;
export const SuperuserDeletePresetDocument = gql`
    mutation SuperuserDeletePreset($id: UUID!) {
  superuserDeletePreset(id: $id) {
    ok
  }
}
    `;
export type SuperuserDeletePresetMutationFn = Apollo.MutationFunction<SuperuserDeletePresetMutation, SuperuserDeletePresetMutationVariables>;

/**
 * __useSuperuserDeletePresetMutation__
 *
 * To run a mutation, you first call `useSuperuserDeletePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserDeletePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserDeletePresetMutation, { data, loading, error }] = useSuperuserDeletePresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperuserDeletePresetMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserDeletePresetMutation, SuperuserDeletePresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserDeletePresetMutation, SuperuserDeletePresetMutationVariables>(SuperuserDeletePresetDocument, options);
      }
export type SuperuserDeletePresetMutationHookResult = ReturnType<typeof useSuperuserDeletePresetMutation>;
export type SuperuserDeletePresetMutationResult = Apollo.MutationResult<SuperuserDeletePresetMutation>;
export type SuperuserDeletePresetMutationOptions = Apollo.BaseMutationOptions<SuperuserDeletePresetMutation, SuperuserDeletePresetMutationVariables>;
export const SuperuserRedisHealthDocument = gql`
    query SuperuserRedisHealth {
  superuserRedisHealth {
    server {
      usedMemory
      totalSystemMemory
      maxmemory
      fragmentationRatio
      aofEnabled
      aofLastWriteStatus
      keys
    }
    archiverLastPass {
      startedAt
      completedAt
      elapsedMs
      devices
      flushed
      backlogged
      finished
      heldBack
      failed
      noMetadata
    }
    audit {
      completedAt
      totalKeys
      families {
        family
        keys
        bytes
      }
      orphans {
        eventDeviceId
        category
        rawKeys
        summaryKeys
        bytes
        firstSampleAt
        lastSampleAt
      }
    }
    eventDevices {
      eventDevice {
        id
        startTime
        endTime
        device {
          id
          name
        }
        event {
          id
          name
        }
      }
      transport
      live
      newestSampleAt
      frontierAt
      archiveCursorAt
      trimmedThroughAt
      verifiedCursorAt
      archiveLagSeconds
      state
      held {
        reason
        message
        since
        updatedAt
      }
      bytes
      memoryMeasuredAt
    }
  }
}
    `;

/**
 * __useSuperuserRedisHealthQuery__
 *
 * To run a query within a React component, call `useSuperuserRedisHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserRedisHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserRedisHealthQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuperuserRedisHealthQuery(baseOptions?: Apollo.QueryHookOptions<SuperuserRedisHealthQuery, SuperuserRedisHealthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserRedisHealthQuery, SuperuserRedisHealthQueryVariables>(SuperuserRedisHealthDocument, options);
      }
export function useSuperuserRedisHealthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserRedisHealthQuery, SuperuserRedisHealthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserRedisHealthQuery, SuperuserRedisHealthQueryVariables>(SuperuserRedisHealthDocument, options);
        }
export type SuperuserRedisHealthQueryHookResult = ReturnType<typeof useSuperuserRedisHealthQuery>;
export type SuperuserRedisHealthLazyQueryHookResult = ReturnType<typeof useSuperuserRedisHealthLazyQuery>;
export type SuperuserRedisHealthQueryResult = Apollo.QueryResult<SuperuserRedisHealthQuery, SuperuserRedisHealthQueryVariables>;
export const SuperuserEventDeviceRedisTimelineDocument = gql`
    query SuperuserEventDeviceRedisTimeline($eventDeviceId: UUID!, $startTime: DateTime!, $endTime: DateTime!) {
  superuserEventDeviceRedisTimeline(
    eventDeviceId: $eventDeviceId
    startTime: $startTime
    endTime: $endTime
  ) {
    transport
    bucketSeconds
    startTime
    endTime
    markers {
      newestSampleAt
      frontierAt
      archiveCursorAt
      trimmedThroughAt
      verifiedCursorAt
      windowStart
      windowEnd
    }
    buckets {
      startAt
      endAt
      state
      received
      expected
      repairAttempts
    }
  }
}
    `;

/**
 * __useSuperuserEventDeviceRedisTimelineQuery__
 *
 * To run a query within a React component, call `useSuperuserEventDeviceRedisTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserEventDeviceRedisTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserEventDeviceRedisTimelineQuery({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useSuperuserEventDeviceRedisTimelineQuery(baseOptions: Apollo.QueryHookOptions<SuperuserEventDeviceRedisTimelineQuery, SuperuserEventDeviceRedisTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserEventDeviceRedisTimelineQuery, SuperuserEventDeviceRedisTimelineQueryVariables>(SuperuserEventDeviceRedisTimelineDocument, options);
      }
export function useSuperuserEventDeviceRedisTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserEventDeviceRedisTimelineQuery, SuperuserEventDeviceRedisTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserEventDeviceRedisTimelineQuery, SuperuserEventDeviceRedisTimelineQueryVariables>(SuperuserEventDeviceRedisTimelineDocument, options);
        }
export type SuperuserEventDeviceRedisTimelineQueryHookResult = ReturnType<typeof useSuperuserEventDeviceRedisTimelineQuery>;
export type SuperuserEventDeviceRedisTimelineLazyQueryHookResult = ReturnType<typeof useSuperuserEventDeviceRedisTimelineLazyQuery>;
export type SuperuserEventDeviceRedisTimelineQueryResult = Apollo.QueryResult<SuperuserEventDeviceRedisTimelineQuery, SuperuserEventDeviceRedisTimelineQueryVariables>;
export const SubscriptionPlansDocument = gql`
    query SubscriptionPlans {
  subscriptionPlans {
    id
    name
    prettyName
    notes
    priceMonth
    priceYear
    features {
      code
    }
  }
}
    `;

/**
 * __useSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionPlansQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(SubscriptionPlansDocument, options);
      }
export function useSubscriptionPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(SubscriptionPlansDocument, options);
        }
export type SubscriptionPlansQueryHookResult = ReturnType<typeof useSubscriptionPlansQuery>;
export type SubscriptionPlansLazyQueryHookResult = ReturnType<typeof useSubscriptionPlansLazyQuery>;
export type SubscriptionPlansQueryResult = Apollo.QueryResult<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>;
export const FeaturesDocument = gql`
    query Features {
  features {
    code
    description
  }
}
    `;

/**
 * __useFeaturesQuery__
 *
 * To run a query within a React component, call `useFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<FeaturesQuery, FeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturesQuery, FeaturesQueryVariables>(FeaturesDocument, options);
      }
export function useFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturesQuery, FeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturesQuery, FeaturesQueryVariables>(FeaturesDocument, options);
        }
export type FeaturesQueryHookResult = ReturnType<typeof useFeaturesQuery>;
export type FeaturesLazyQueryHookResult = ReturnType<typeof useFeaturesLazyQuery>;
export type FeaturesQueryResult = Apollo.QueryResult<FeaturesQuery, FeaturesQueryVariables>;
export const ViewerEntitlementsDocument = gql`
    query ViewerEntitlements {
  viewerFeatures
  viewerAccountAttributes
}
    `;

/**
 * __useViewerEntitlementsQuery__
 *
 * To run a query within a React component, call `useViewerEntitlementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerEntitlementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerEntitlementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerEntitlementsQuery(baseOptions?: Apollo.QueryHookOptions<ViewerEntitlementsQuery, ViewerEntitlementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerEntitlementsQuery, ViewerEntitlementsQueryVariables>(ViewerEntitlementsDocument, options);
      }
export function useViewerEntitlementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerEntitlementsQuery, ViewerEntitlementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerEntitlementsQuery, ViewerEntitlementsQueryVariables>(ViewerEntitlementsDocument, options);
        }
export type ViewerEntitlementsQueryHookResult = ReturnType<typeof useViewerEntitlementsQuery>;
export type ViewerEntitlementsLazyQueryHookResult = ReturnType<typeof useViewerEntitlementsLazyQuery>;
export type ViewerEntitlementsQueryResult = Apollo.QueryResult<ViewerEntitlementsQuery, ViewerEntitlementsQueryVariables>;
export const AccountSubscriptionDocument = gql`
    query AccountSubscription {
  accountSubscription {
    isManuallySet
    stripeRenewalFailed
    stripeCurrentPeriodEnd
    stripeCancelAtPeriodEnd
    subscriptionPlan {
      id
      name
      features {
        code
      }
    }
  }
}
    `;

/**
 * __useAccountSubscriptionQuery__
 *
 * To run a query within a React component, call `useAccountSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<AccountSubscriptionQuery, AccountSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSubscriptionQuery, AccountSubscriptionQueryVariables>(AccountSubscriptionDocument, options);
      }
export function useAccountSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSubscriptionQuery, AccountSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSubscriptionQuery, AccountSubscriptionQueryVariables>(AccountSubscriptionDocument, options);
        }
export type AccountSubscriptionQueryHookResult = ReturnType<typeof useAccountSubscriptionQuery>;
export type AccountSubscriptionLazyQueryHookResult = ReturnType<typeof useAccountSubscriptionLazyQuery>;
export type AccountSubscriptionQueryResult = Apollo.QueryResult<AccountSubscriptionQuery, AccountSubscriptionQueryVariables>;
export const SubscriptionManagmentSessionUrlDocument = gql`
    mutation SubscriptionManagmentSessionUrl($subscriptionPlanId: UUID!, $isMonthly: Boolean) {
  subscriptionManagmentSessionUrl(
    subscriptionPlanId: $subscriptionPlanId
    isMonthly: $isMonthly
  ) {
    ok
    stripeSessionUrl
  }
}
    `;
export type SubscriptionManagmentSessionUrlMutationFn = Apollo.MutationFunction<SubscriptionManagmentSessionUrlMutation, SubscriptionManagmentSessionUrlMutationVariables>;

/**
 * __useSubscriptionManagmentSessionUrlMutation__
 *
 * To run a mutation, you first call `useSubscriptionManagmentSessionUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionManagmentSessionUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionManagmentSessionUrlMutation, { data, loading, error }] = useSubscriptionManagmentSessionUrlMutation({
 *   variables: {
 *      subscriptionPlanId: // value for 'subscriptionPlanId'
 *      isMonthly: // value for 'isMonthly'
 *   },
 * });
 */
export function useSubscriptionManagmentSessionUrlMutation(baseOptions?: Apollo.MutationHookOptions<SubscriptionManagmentSessionUrlMutation, SubscriptionManagmentSessionUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscriptionManagmentSessionUrlMutation, SubscriptionManagmentSessionUrlMutationVariables>(SubscriptionManagmentSessionUrlDocument, options);
      }
export type SubscriptionManagmentSessionUrlMutationHookResult = ReturnType<typeof useSubscriptionManagmentSessionUrlMutation>;
export type SubscriptionManagmentSessionUrlMutationResult = Apollo.MutationResult<SubscriptionManagmentSessionUrlMutation>;
export type SubscriptionManagmentSessionUrlMutationOptions = Apollo.BaseMutationOptions<SubscriptionManagmentSessionUrlMutation, SubscriptionManagmentSessionUrlMutationVariables>;
export const SuperuserUpdateAccountSubscriptionDocument = gql`
    mutation SuperuserUpdateAccountSubscription($accountId: UUID!, $subscriptionPlanId: UUID!) {
  superuserUpdateAccountSubscription(
    accountId: $accountId
    subscriptionPlanId: $subscriptionPlanId
  ) {
    ok
    errors {
      field
      message
    }
    accountSubscription {
      id
      isManuallySet
      stripeCurrentPeriodEnd
      subscriptionPlan {
        id
        name
        prettyName
      }
    }
  }
}
    `;
export type SuperuserUpdateAccountSubscriptionMutationFn = Apollo.MutationFunction<SuperuserUpdateAccountSubscriptionMutation, SuperuserUpdateAccountSubscriptionMutationVariables>;

/**
 * __useSuperuserUpdateAccountSubscriptionMutation__
 *
 * To run a mutation, you first call `useSuperuserUpdateAccountSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserUpdateAccountSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserUpdateAccountSubscriptionMutation, { data, loading, error }] = useSuperuserUpdateAccountSubscriptionMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      subscriptionPlanId: // value for 'subscriptionPlanId'
 *   },
 * });
 */
export function useSuperuserUpdateAccountSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserUpdateAccountSubscriptionMutation, SuperuserUpdateAccountSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserUpdateAccountSubscriptionMutation, SuperuserUpdateAccountSubscriptionMutationVariables>(SuperuserUpdateAccountSubscriptionDocument, options);
      }
export type SuperuserUpdateAccountSubscriptionMutationHookResult = ReturnType<typeof useSuperuserUpdateAccountSubscriptionMutation>;
export type SuperuserUpdateAccountSubscriptionMutationResult = Apollo.MutationResult<SuperuserUpdateAccountSubscriptionMutation>;
export type SuperuserUpdateAccountSubscriptionMutationOptions = Apollo.BaseMutationOptions<SuperuserUpdateAccountSubscriptionMutation, SuperuserUpdateAccountSubscriptionMutationVariables>;
export const AdminPolicyDocumentsDocument = gql`
    query AdminPolicyDocuments($documentType: String) {
  superuserPolicyDocuments(documentType: $documentType) {
    id
    documentType
    version
    effectiveDate
    isPublished
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAdminPolicyDocumentsQuery__
 *
 * To run a query within a React component, call `useAdminPolicyDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPolicyDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPolicyDocumentsQuery({
 *   variables: {
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useAdminPolicyDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<AdminPolicyDocumentsQuery, AdminPolicyDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPolicyDocumentsQuery, AdminPolicyDocumentsQueryVariables>(AdminPolicyDocumentsDocument, options);
      }
export function useAdminPolicyDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPolicyDocumentsQuery, AdminPolicyDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPolicyDocumentsQuery, AdminPolicyDocumentsQueryVariables>(AdminPolicyDocumentsDocument, options);
        }
export type AdminPolicyDocumentsQueryHookResult = ReturnType<typeof useAdminPolicyDocumentsQuery>;
export type AdminPolicyDocumentsLazyQueryHookResult = ReturnType<typeof useAdminPolicyDocumentsLazyQuery>;
export type AdminPolicyDocumentsQueryResult = Apollo.QueryResult<AdminPolicyDocumentsQuery, AdminPolicyDocumentsQueryVariables>;
export const AdminPolicyDocumentDocument = gql`
    query AdminPolicyDocument($id: UUID!) {
  superuserPolicyDocument(id: $id) {
    id
    documentType
    version
    effectiveDate
    body
    isPublished
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAdminPolicyDocumentQuery__
 *
 * To run a query within a React component, call `useAdminPolicyDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPolicyDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPolicyDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminPolicyDocumentQuery(baseOptions: Apollo.QueryHookOptions<AdminPolicyDocumentQuery, AdminPolicyDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPolicyDocumentQuery, AdminPolicyDocumentQueryVariables>(AdminPolicyDocumentDocument, options);
      }
export function useAdminPolicyDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPolicyDocumentQuery, AdminPolicyDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPolicyDocumentQuery, AdminPolicyDocumentQueryVariables>(AdminPolicyDocumentDocument, options);
        }
export type AdminPolicyDocumentQueryHookResult = ReturnType<typeof useAdminPolicyDocumentQuery>;
export type AdminPolicyDocumentLazyQueryHookResult = ReturnType<typeof useAdminPolicyDocumentLazyQuery>;
export type AdminPolicyDocumentQueryResult = Apollo.QueryResult<AdminPolicyDocumentQuery, AdminPolicyDocumentQueryVariables>;
export const AdminCreatePolicyDocumentDocument = gql`
    mutation AdminCreatePolicyDocument($documentType: String!, $effectiveDate: Date!, $body: String!) {
  superuserCreatePolicyDocument(
    documentType: $documentType
    effectiveDate: $effectiveDate
    body: $body
  ) {
    ok
    errors {
      field
      message
    }
    document {
      id
      documentType
      version
    }
  }
}
    `;
export type AdminCreatePolicyDocumentMutationFn = Apollo.MutationFunction<AdminCreatePolicyDocumentMutation, AdminCreatePolicyDocumentMutationVariables>;

/**
 * __useAdminCreatePolicyDocumentMutation__
 *
 * To run a mutation, you first call `useAdminCreatePolicyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreatePolicyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreatePolicyDocumentMutation, { data, loading, error }] = useAdminCreatePolicyDocumentMutation({
 *   variables: {
 *      documentType: // value for 'documentType'
 *      effectiveDate: // value for 'effectiveDate'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useAdminCreatePolicyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreatePolicyDocumentMutation, AdminCreatePolicyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreatePolicyDocumentMutation, AdminCreatePolicyDocumentMutationVariables>(AdminCreatePolicyDocumentDocument, options);
      }
export type AdminCreatePolicyDocumentMutationHookResult = ReturnType<typeof useAdminCreatePolicyDocumentMutation>;
export type AdminCreatePolicyDocumentMutationResult = Apollo.MutationResult<AdminCreatePolicyDocumentMutation>;
export type AdminCreatePolicyDocumentMutationOptions = Apollo.BaseMutationOptions<AdminCreatePolicyDocumentMutation, AdminCreatePolicyDocumentMutationVariables>;
export const AdminUpdatePolicyDocumentDocument = gql`
    mutation AdminUpdatePolicyDocument($id: UUID!, $body: String, $effectiveDate: Date) {
  superuserUpdatePolicyDocument(
    id: $id
    body: $body
    effectiveDate: $effectiveDate
  ) {
    ok
    errors {
      field
      message
    }
    document {
      id
      version
      isPublished
    }
  }
}
    `;
export type AdminUpdatePolicyDocumentMutationFn = Apollo.MutationFunction<AdminUpdatePolicyDocumentMutation, AdminUpdatePolicyDocumentMutationVariables>;

/**
 * __useAdminUpdatePolicyDocumentMutation__
 *
 * To run a mutation, you first call `useAdminUpdatePolicyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdatePolicyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdatePolicyDocumentMutation, { data, loading, error }] = useAdminUpdatePolicyDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *      effectiveDate: // value for 'effectiveDate'
 *   },
 * });
 */
export function useAdminUpdatePolicyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdatePolicyDocumentMutation, AdminUpdatePolicyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdatePolicyDocumentMutation, AdminUpdatePolicyDocumentMutationVariables>(AdminUpdatePolicyDocumentDocument, options);
      }
export type AdminUpdatePolicyDocumentMutationHookResult = ReturnType<typeof useAdminUpdatePolicyDocumentMutation>;
export type AdminUpdatePolicyDocumentMutationResult = Apollo.MutationResult<AdminUpdatePolicyDocumentMutation>;
export type AdminUpdatePolicyDocumentMutationOptions = Apollo.BaseMutationOptions<AdminUpdatePolicyDocumentMutation, AdminUpdatePolicyDocumentMutationVariables>;
export const AdminPublishPolicyDocumentDocument = gql`
    mutation AdminPublishPolicyDocument($id: UUID!) {
  superuserPublishPolicyDocument(id: $id) {
    ok
    errors {
      field
      message
    }
    document {
      id
      version
      isPublished
    }
  }
}
    `;
export type AdminPublishPolicyDocumentMutationFn = Apollo.MutationFunction<AdminPublishPolicyDocumentMutation, AdminPublishPolicyDocumentMutationVariables>;

/**
 * __useAdminPublishPolicyDocumentMutation__
 *
 * To run a mutation, you first call `useAdminPublishPolicyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishPolicyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminPublishPolicyDocumentMutation, { data, loading, error }] = useAdminPublishPolicyDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminPublishPolicyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminPublishPolicyDocumentMutation, AdminPublishPolicyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminPublishPolicyDocumentMutation, AdminPublishPolicyDocumentMutationVariables>(AdminPublishPolicyDocumentDocument, options);
      }
export type AdminPublishPolicyDocumentMutationHookResult = ReturnType<typeof useAdminPublishPolicyDocumentMutation>;
export type AdminPublishPolicyDocumentMutationResult = Apollo.MutationResult<AdminPublishPolicyDocumentMutation>;
export type AdminPublishPolicyDocumentMutationOptions = Apollo.BaseMutationOptions<AdminPublishPolicyDocumentMutation, AdminPublishPolicyDocumentMutationVariables>;
export const AdminUnpublishPolicyDocumentDocument = gql`
    mutation AdminUnpublishPolicyDocument($id: UUID!) {
  superuserUnpublishPolicyDocument(id: $id) {
    ok
    errors {
      field
      message
    }
    document {
      id
      version
      isPublished
    }
  }
}
    `;
export type AdminUnpublishPolicyDocumentMutationFn = Apollo.MutationFunction<AdminUnpublishPolicyDocumentMutation, AdminUnpublishPolicyDocumentMutationVariables>;

/**
 * __useAdminUnpublishPolicyDocumentMutation__
 *
 * To run a mutation, you first call `useAdminUnpublishPolicyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUnpublishPolicyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUnpublishPolicyDocumentMutation, { data, loading, error }] = useAdminUnpublishPolicyDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminUnpublishPolicyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminUnpublishPolicyDocumentMutation, AdminUnpublishPolicyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUnpublishPolicyDocumentMutation, AdminUnpublishPolicyDocumentMutationVariables>(AdminUnpublishPolicyDocumentDocument, options);
      }
export type AdminUnpublishPolicyDocumentMutationHookResult = ReturnType<typeof useAdminUnpublishPolicyDocumentMutation>;
export type AdminUnpublishPolicyDocumentMutationResult = Apollo.MutationResult<AdminUnpublishPolicyDocumentMutation>;
export type AdminUnpublishPolicyDocumentMutationOptions = Apollo.BaseMutationOptions<AdminUnpublishPolicyDocumentMutation, AdminUnpublishPolicyDocumentMutationVariables>;
export const AdminDeletePolicyDocumentDocument = gql`
    mutation AdminDeletePolicyDocument($id: UUID!) {
  superuserDeletePolicyDocument(id: $id) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type AdminDeletePolicyDocumentMutationFn = Apollo.MutationFunction<AdminDeletePolicyDocumentMutation, AdminDeletePolicyDocumentMutationVariables>;

/**
 * __useAdminDeletePolicyDocumentMutation__
 *
 * To run a mutation, you first call `useAdminDeletePolicyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeletePolicyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeletePolicyDocumentMutation, { data, loading, error }] = useAdminDeletePolicyDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeletePolicyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeletePolicyDocumentMutation, AdminDeletePolicyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeletePolicyDocumentMutation, AdminDeletePolicyDocumentMutationVariables>(AdminDeletePolicyDocumentDocument, options);
      }
export type AdminDeletePolicyDocumentMutationHookResult = ReturnType<typeof useAdminDeletePolicyDocumentMutation>;
export type AdminDeletePolicyDocumentMutationResult = Apollo.MutationResult<AdminDeletePolicyDocumentMutation>;
export type AdminDeletePolicyDocumentMutationOptions = Apollo.BaseMutationOptions<AdminDeletePolicyDocumentMutation, AdminDeletePolicyDocumentMutationVariables>;
export const AdminUpdateLegalEntitySettingsDocument = gql`
    mutation AdminUpdateLegalEntitySettings($entityName: String, $address: String, $contactEmail: String, $euRepresentative: String) {
  superuserUpdateLegalEntitySettings(
    entityName: $entityName
    address: $address
    contactEmail: $contactEmail
    euRepresentative: $euRepresentative
  ) {
    ok
    errors {
      field
      message
    }
    settings {
      entityName
      address
      contactEmail
      euRepresentative
      updatedAt
    }
  }
}
    `;
export type AdminUpdateLegalEntitySettingsMutationFn = Apollo.MutationFunction<AdminUpdateLegalEntitySettingsMutation, AdminUpdateLegalEntitySettingsMutationVariables>;

/**
 * __useAdminUpdateLegalEntitySettingsMutation__
 *
 * To run a mutation, you first call `useAdminUpdateLegalEntitySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateLegalEntitySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateLegalEntitySettingsMutation, { data, loading, error }] = useAdminUpdateLegalEntitySettingsMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      address: // value for 'address'
 *      contactEmail: // value for 'contactEmail'
 *      euRepresentative: // value for 'euRepresentative'
 *   },
 * });
 */
export function useAdminUpdateLegalEntitySettingsMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateLegalEntitySettingsMutation, AdminUpdateLegalEntitySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateLegalEntitySettingsMutation, AdminUpdateLegalEntitySettingsMutationVariables>(AdminUpdateLegalEntitySettingsDocument, options);
      }
export type AdminUpdateLegalEntitySettingsMutationHookResult = ReturnType<typeof useAdminUpdateLegalEntitySettingsMutation>;
export type AdminUpdateLegalEntitySettingsMutationResult = Apollo.MutationResult<AdminUpdateLegalEntitySettingsMutation>;
export type AdminUpdateLegalEntitySettingsMutationOptions = Apollo.BaseMutationOptions<AdminUpdateLegalEntitySettingsMutation, AdminUpdateLegalEntitySettingsMutationVariables>;
export const SuperuserEventDeviceTelemetrySummaryDocument = gql`
    query SuperuserEventDeviceTelemetrySummary($eventDeviceId: UUID!, $channels: [String!], $maxPoints: Int! = 2000) {
  superuserEventDeviceTelemetrySummary(
    eventDeviceId: $eventDeviceId
    channels: $channels
    maxPoints: $maxPoints
  ) {
    summaryData
    source
    bucketSeconds
    verifiedThrough
  }
}
    `;

/**
 * __useSuperuserEventDeviceTelemetrySummaryQuery__
 *
 * To run a query within a React component, call `useSuperuserEventDeviceTelemetrySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserEventDeviceTelemetrySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserEventDeviceTelemetrySummaryQuery({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *      channels: // value for 'channels'
 *      maxPoints: // value for 'maxPoints'
 *   },
 * });
 */
export function useSuperuserEventDeviceTelemetrySummaryQuery(baseOptions: Apollo.QueryHookOptions<SuperuserEventDeviceTelemetrySummaryQuery, SuperuserEventDeviceTelemetrySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperuserEventDeviceTelemetrySummaryQuery, SuperuserEventDeviceTelemetrySummaryQueryVariables>(SuperuserEventDeviceTelemetrySummaryDocument, options);
      }
export function useSuperuserEventDeviceTelemetrySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperuserEventDeviceTelemetrySummaryQuery, SuperuserEventDeviceTelemetrySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperuserEventDeviceTelemetrySummaryQuery, SuperuserEventDeviceTelemetrySummaryQueryVariables>(SuperuserEventDeviceTelemetrySummaryDocument, options);
        }
export type SuperuserEventDeviceTelemetrySummaryQueryHookResult = ReturnType<typeof useSuperuserEventDeviceTelemetrySummaryQuery>;
export type SuperuserEventDeviceTelemetrySummaryLazyQueryHookResult = ReturnType<typeof useSuperuserEventDeviceTelemetrySummaryLazyQuery>;
export type SuperuserEventDeviceTelemetrySummaryQueryResult = Apollo.QueryResult<SuperuserEventDeviceTelemetrySummaryQuery, SuperuserEventDeviceTelemetrySummaryQueryVariables>;
export const PreferenceCategoriesDocument = gql`
    query PreferenceCategories {
  preferenceCategories {
    key
    label
    description
  }
}
    `;

/**
 * __usePreferenceCategoriesQuery__
 *
 * To run a query within a React component, call `usePreferenceCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreferenceCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreferenceCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePreferenceCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<PreferenceCategoriesQuery, PreferenceCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreferenceCategoriesQuery, PreferenceCategoriesQueryVariables>(PreferenceCategoriesDocument, options);
      }
export function usePreferenceCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreferenceCategoriesQuery, PreferenceCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreferenceCategoriesQuery, PreferenceCategoriesQueryVariables>(PreferenceCategoriesDocument, options);
        }
export type PreferenceCategoriesQueryHookResult = ReturnType<typeof usePreferenceCategoriesQuery>;
export type PreferenceCategoriesLazyQueryHookResult = ReturnType<typeof usePreferenceCategoriesLazyQuery>;
export type PreferenceCategoriesQueryResult = Apollo.QueryResult<PreferenceCategoriesQuery, PreferenceCategoriesQueryVariables>;
export const MyPreferencesDocument = gql`
    query MyPreferences($category: String) {
  myPreferences(category: $category) {
    ...UserPreferenceFields
  }
}
    ${UserPreferenceFieldsFragmentDoc}`;

/**
 * __useMyPreferencesQuery__
 *
 * To run a query within a React component, call `useMyPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPreferencesQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useMyPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<MyPreferencesQuery, MyPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPreferencesQuery, MyPreferencesQueryVariables>(MyPreferencesDocument, options);
      }
export function useMyPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPreferencesQuery, MyPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPreferencesQuery, MyPreferencesQueryVariables>(MyPreferencesDocument, options);
        }
export type MyPreferencesQueryHookResult = ReturnType<typeof useMyPreferencesQuery>;
export type MyPreferencesLazyQueryHookResult = ReturnType<typeof useMyPreferencesLazyQuery>;
export type MyPreferencesQueryResult = Apollo.QueryResult<MyPreferencesQuery, MyPreferencesQueryVariables>;
export const UpdateUserPreferenceDocument = gql`
    mutation UpdateUserPreference($key: String!, $value: String!) {
  updateUserPreference(key: $key, value: $value) {
    ok
    errors {
      field
      message
    }
    preference {
      ...UserPreferenceFields
    }
  }
}
    ${UserPreferenceFieldsFragmentDoc}`;
export type UpdateUserPreferenceMutationFn = Apollo.MutationFunction<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>;

/**
 * __useUpdateUserPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPreferenceMutation, { data, loading, error }] = useUpdateUserPreferenceMutation({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateUserPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>(UpdateUserPreferenceDocument, options);
      }
export type UpdateUserPreferenceMutationHookResult = ReturnType<typeof useUpdateUserPreferenceMutation>;
export type UpdateUserPreferenceMutationResult = Apollo.MutationResult<UpdateUserPreferenceMutation>;
export type UpdateUserPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>;
export const ResetUserPreferenceDocument = gql`
    mutation ResetUserPreference($key: String!) {
  resetUserPreference(key: $key) {
    ok
    errors {
      field
      message
    }
    preference {
      ...UserPreferenceFields
    }
  }
}
    ${UserPreferenceFieldsFragmentDoc}`;
export type ResetUserPreferenceMutationFn = Apollo.MutationFunction<ResetUserPreferenceMutation, ResetUserPreferenceMutationVariables>;

/**
 * __useResetUserPreferenceMutation__
 *
 * To run a mutation, you first call `useResetUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPreferenceMutation, { data, loading, error }] = useResetUserPreferenceMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useResetUserPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserPreferenceMutation, ResetUserPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserPreferenceMutation, ResetUserPreferenceMutationVariables>(ResetUserPreferenceDocument, options);
      }
export type ResetUserPreferenceMutationHookResult = ReturnType<typeof useResetUserPreferenceMutation>;
export type ResetUserPreferenceMutationResult = Apollo.MutationResult<ResetUserPreferenceMutation>;
export type ResetUserPreferenceMutationOptions = Apollo.BaseMutationOptions<ResetUserPreferenceMutation, ResetUserPreferenceMutationVariables>;
export const NavbarMeDocument = gql`
    query NavbarMe {
  userMe {
    id
    firstName
  }
}
    `;

/**
 * __useNavbarMeQuery__
 *
 * To run a query within a React component, call `useNavbarMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavbarMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavbarMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useNavbarMeQuery(baseOptions?: Apollo.QueryHookOptions<NavbarMeQuery, NavbarMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavbarMeQuery, NavbarMeQueryVariables>(NavbarMeDocument, options);
      }
export function useNavbarMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavbarMeQuery, NavbarMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavbarMeQuery, NavbarMeQueryVariables>(NavbarMeDocument, options);
        }
export type NavbarMeQueryHookResult = ReturnType<typeof useNavbarMeQuery>;
export type NavbarMeLazyQueryHookResult = ReturnType<typeof useNavbarMeLazyQuery>;
export type NavbarMeQueryResult = Apollo.QueryResult<NavbarMeQuery, NavbarMeQueryVariables>;
export const MeDocument = gql`
    query Me {
  userMe {
    id
    firstName
    lastName
    email
    isActive
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MyProfileMeDocument = gql`
    query MyProfileMe {
  userMe {
    id
    email
    slug
    firstName
    lastName
    bio
    links
    avatarSmall
    avatarMedium
    avatarLarge
    profilePictureSmall
    profilePictureMedium
    profilePictureLarge
  }
}
    `;

/**
 * __useMyProfileMeQuery__
 *
 * To run a query within a React component, call `useMyProfileMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyProfileMeQuery(baseOptions?: Apollo.QueryHookOptions<MyProfileMeQuery, MyProfileMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProfileMeQuery, MyProfileMeQueryVariables>(MyProfileMeDocument, options);
      }
export function useMyProfileMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileMeQuery, MyProfileMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProfileMeQuery, MyProfileMeQueryVariables>(MyProfileMeDocument, options);
        }
export type MyProfileMeQueryHookResult = ReturnType<typeof useMyProfileMeQuery>;
export type MyProfileMeLazyQueryHookResult = ReturnType<typeof useMyProfileMeLazyQuery>;
export type MyProfileMeQueryResult = Apollo.QueryResult<MyProfileMeQuery, MyProfileMeQueryVariables>;
export const SignUpDocument = gql`
    mutation SignUp($accountName: String!, $firstName: String!, $lastName: String!, $email: String!, $password1: String!, $password2: String!, $turnstileToken: String, $acceptedPolicies: [PolicyAcceptanceInput!], $ageConfirmed: Boolean, $marketingOptIn: Boolean) {
  registerWithAccount(
    accountName: $accountName
    firstName: $firstName
    lastName: $lastName
    email: $email
    password1: $password1
    password2: $password2
    turnstileToken: $turnstileToken
    acceptedPolicies: $acceptedPolicies
    ageConfirmed: $ageConfirmed
    marketingOptIn: $marketingOptIn
  ) {
    success
    errors
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      accountName: // value for 'accountName'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password1: // value for 'password1'
 *      password2: // value for 'password2'
 *      turnstileToken: // value for 'turnstileToken'
 *      acceptedPolicies: // value for 'acceptedPolicies'
 *      ageConfirmed: // value for 'ageConfirmed'
 *      marketingOptIn: // value for 'marketingOptIn'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const UpdateUserMeDocument = gql`
    mutation UpdateUserMe($firstName: String, $lastName: String, $bio: String, $links: [String!], $password: String, $avatar: Upload, $profilePicture: Upload) {
  updateUserMe(
    firstName: $firstName
    lastName: $lastName
    bio: $bio
    links: $links
    password: $password
    avatar: $avatar
    profilePicture: $profilePicture
  ) {
    user {
      id
      email
      slug
      firstName
      lastName
      bio
      links
      avatarSmall
      avatarMedium
      avatarLarge
      profilePictureSmall
      profilePictureMedium
      profilePictureLarge
    }
  }
}
    `;
export type UpdateUserMeMutationFn = Apollo.MutationFunction<UpdateUserMeMutation, UpdateUserMeMutationVariables>;

/**
 * __useUpdateUserMeMutation__
 *
 * To run a mutation, you first call `useUpdateUserMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMeMutation, { data, loading, error }] = useUpdateUserMeMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      bio: // value for 'bio'
 *      links: // value for 'links'
 *      password: // value for 'password'
 *      avatar: // value for 'avatar'
 *      profilePicture: // value for 'profilePicture'
 *   },
 * });
 */
export function useUpdateUserMeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMeMutation, UpdateUserMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMeMutation, UpdateUserMeMutationVariables>(UpdateUserMeDocument, options);
      }
export type UpdateUserMeMutationHookResult = ReturnType<typeof useUpdateUserMeMutation>;
export type UpdateUserMeMutationResult = Apollo.MutationResult<UpdateUserMeMutation>;
export type UpdateUserMeMutationOptions = Apollo.BaseMutationOptions<UpdateUserMeMutation, UpdateUserMeMutationVariables>;
export const UserListDocument = gql`
    query UserList($search: String, $accountId: UUID, $orderBy: String, $rowsPerPage: Int, $page: Int) {
  superuserUsers(
    search: $search
    accountId: $accountId
    orderBy: $orderBy
    rowsPerPage: $rowsPerPage
    page: $page
  ) {
    items {
      id
      firstName
      lastName
      email
      lastLogin
      createdAt
      isSuperuser
      isActive
      account {
        subscriptionPlan {
          prettyName
        }
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useUserListQuery__
 *
 * To run a query within a React component, call `useUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      accountId: // value for 'accountId'
 *      orderBy: // value for 'orderBy'
 *      rowsPerPage: // value for 'rowsPerPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useUserListQuery(baseOptions?: Apollo.QueryHookOptions<UserListQuery, UserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
      }
export function useUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListQuery, UserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
        }
export type UserListQueryHookResult = ReturnType<typeof useUserListQuery>;
export type UserListLazyQueryHookResult = ReturnType<typeof useUserListLazyQuery>;
export type UserListQueryResult = Apollo.QueryResult<UserListQuery, UserListQueryVariables>;
export const UserDocument = gql`
    query User($id: UUID!) {
  superuserUserById(id: $id) {
    id
    email
    lastLogin
    createdAt
    firstName
    lastName
    links
    isActive
    isSuperuser
    account {
      id
      name
      subscriptionPlan {
        id
        name
        prettyName
      }
    }
    devices {
      id
      name
      createdAt
    }
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserProfileDocument = gql`
    query UserProfile($slug: String!) {
  userBySlug(slug: $slug) {
    id
    slug
    firstName
    lastName
    bio
    links
    followersCount
    followingCount
    isFollowing
    followsViewer
    isViewer
    createdAt
    avatarSmall
    avatarMedium
    avatarLarge
    profilePictureSmall
    profilePictureMedium
    profilePictureLarge
  }
}
    `;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useUserProfileQuery(baseOptions: Apollo.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
      }
export function useUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>;
export type UserProfileQueryResult = Apollo.QueryResult<UserProfileQuery, UserProfileQueryVariables>;
export const PublicUserFollowersDocument = gql`
    query PublicUserFollowers($slug: String!, $rowsPerPage: Int, $page: Int) {
  publicUserFollowers(slug: $slug, rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      slug
      firstName
      lastName
      bio
      followersCount
      followingCount
      isFollowing
      followsViewer
      isViewer
      avatarSmall
      avatarMedium
      avatarLarge
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

/**
 * __usePublicUserFollowersQuery__
 *
 * To run a query within a React component, call `usePublicUserFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicUserFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicUserFollowersQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      rowsPerPage: // value for 'rowsPerPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePublicUserFollowersQuery(baseOptions: Apollo.QueryHookOptions<PublicUserFollowersQuery, PublicUserFollowersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicUserFollowersQuery, PublicUserFollowersQueryVariables>(PublicUserFollowersDocument, options);
      }
export function usePublicUserFollowersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicUserFollowersQuery, PublicUserFollowersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicUserFollowersQuery, PublicUserFollowersQueryVariables>(PublicUserFollowersDocument, options);
        }
export type PublicUserFollowersQueryHookResult = ReturnType<typeof usePublicUserFollowersQuery>;
export type PublicUserFollowersLazyQueryHookResult = ReturnType<typeof usePublicUserFollowersLazyQuery>;
export type PublicUserFollowersQueryResult = Apollo.QueryResult<PublicUserFollowersQuery, PublicUserFollowersQueryVariables>;
export const PublicUserFollowingDocument = gql`
    query PublicUserFollowing($slug: String!, $rowsPerPage: Int, $page: Int) {
  publicUserFollowing(slug: $slug, rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      slug
      firstName
      lastName
      bio
      followersCount
      followingCount
      isFollowing
      followsViewer
      isViewer
      avatarSmall
      avatarMedium
      avatarLarge
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

/**
 * __usePublicUserFollowingQuery__
 *
 * To run a query within a React component, call `usePublicUserFollowingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicUserFollowingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicUserFollowingQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      rowsPerPage: // value for 'rowsPerPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePublicUserFollowingQuery(baseOptions: Apollo.QueryHookOptions<PublicUserFollowingQuery, PublicUserFollowingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicUserFollowingQuery, PublicUserFollowingQueryVariables>(PublicUserFollowingDocument, options);
      }
export function usePublicUserFollowingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicUserFollowingQuery, PublicUserFollowingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicUserFollowingQuery, PublicUserFollowingQueryVariables>(PublicUserFollowingDocument, options);
        }
export type PublicUserFollowingQueryHookResult = ReturnType<typeof usePublicUserFollowingQuery>;
export type PublicUserFollowingLazyQueryHookResult = ReturnType<typeof usePublicUserFollowingLazyQuery>;
export type PublicUserFollowingQueryResult = Apollo.QueryResult<PublicUserFollowingQuery, PublicUserFollowingQueryVariables>;
export const FollowUserDocument = gql`
    mutation FollowUser($slug: String!) {
  followUser(slug: $slug) {
    ok
  }
}
    `;
export type FollowUserMutationFn = Apollo.MutationFunction<FollowUserMutation, FollowUserMutationVariables>;

/**
 * __useFollowUserMutation__
 *
 * To run a mutation, you first call `useFollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followUserMutation, { data, loading, error }] = useFollowUserMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useFollowUserMutation(baseOptions?: Apollo.MutationHookOptions<FollowUserMutation, FollowUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowUserMutation, FollowUserMutationVariables>(FollowUserDocument, options);
      }
export type FollowUserMutationHookResult = ReturnType<typeof useFollowUserMutation>;
export type FollowUserMutationResult = Apollo.MutationResult<FollowUserMutation>;
export type FollowUserMutationOptions = Apollo.BaseMutationOptions<FollowUserMutation, FollowUserMutationVariables>;
export const UnfollowUserDocument = gql`
    mutation UnfollowUser($slug: String!) {
  unfollowUser(slug: $slug) {
    ok
  }
}
    `;
export type UnfollowUserMutationFn = Apollo.MutationFunction<UnfollowUserMutation, UnfollowUserMutationVariables>;

/**
 * __useUnfollowUserMutation__
 *
 * To run a mutation, you first call `useUnfollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowUserMutation, { data, loading, error }] = useUnfollowUserMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useUnfollowUserMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowUserMutation, UnfollowUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowUserMutation, UnfollowUserMutationVariables>(UnfollowUserDocument, options);
      }
export type UnfollowUserMutationHookResult = ReturnType<typeof useUnfollowUserMutation>;
export type UnfollowUserMutationResult = Apollo.MutationResult<UnfollowUserMutation>;
export type UnfollowUserMutationOptions = Apollo.BaseMutationOptions<UnfollowUserMutation, UnfollowUserMutationVariables>;
export const SendPasswordResetEmailDocument = gql`
    mutation SendPasswordResetEmail($email: String!) {
  sendPasswordResetEmail(email: $email) {
    success
    errors
  }
}
    `;
export type SendPasswordResetEmailMutationFn = Apollo.MutationFunction<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;

/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(SendPasswordResetEmailDocument, options);
      }
export type SendPasswordResetEmailMutationHookResult = ReturnType<typeof useSendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationResult = Apollo.MutationResult<SendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;
export const ElevateUserDocument = gql`
    mutation ElevateUser($id: UUID!) {
  superuserElevateUser(id: $id) {
    ok
  }
}
    `;
export type ElevateUserMutationFn = Apollo.MutationFunction<ElevateUserMutation, ElevateUserMutationVariables>;

/**
 * __useElevateUserMutation__
 *
 * To run a mutation, you first call `useElevateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useElevateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [elevateUserMutation, { data, loading, error }] = useElevateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useElevateUserMutation(baseOptions?: Apollo.MutationHookOptions<ElevateUserMutation, ElevateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ElevateUserMutation, ElevateUserMutationVariables>(ElevateUserDocument, options);
      }
export type ElevateUserMutationHookResult = ReturnType<typeof useElevateUserMutation>;
export type ElevateUserMutationResult = Apollo.MutationResult<ElevateUserMutation>;
export type ElevateUserMutationOptions = Apollo.BaseMutationOptions<ElevateUserMutation, ElevateUserMutationVariables>;
export const DowngradeUserDocument = gql`
    mutation DowngradeUser($id: UUID!) {
  superuserDowngradeUser(id: $id) {
    ok
  }
}
    `;
export type DowngradeUserMutationFn = Apollo.MutationFunction<DowngradeUserMutation, DowngradeUserMutationVariables>;

/**
 * __useDowngradeUserMutation__
 *
 * To run a mutation, you first call `useDowngradeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDowngradeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downgradeUserMutation, { data, loading, error }] = useDowngradeUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDowngradeUserMutation(baseOptions?: Apollo.MutationHookOptions<DowngradeUserMutation, DowngradeUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DowngradeUserMutation, DowngradeUserMutationVariables>(DowngradeUserDocument, options);
      }
export type DowngradeUserMutationHookResult = ReturnType<typeof useDowngradeUserMutation>;
export type DowngradeUserMutationResult = Apollo.MutationResult<DowngradeUserMutation>;
export type DowngradeUserMutationOptions = Apollo.BaseMutationOptions<DowngradeUserMutation, DowngradeUserMutationVariables>;
export const DeactivateUserDocument = gql`
    mutation DeactivateUser($id: UUID!) {
  superuserDeactivateUser(id: $id) {
    ok
  }
}
    `;
export type DeactivateUserMutationFn = Apollo.MutationFunction<DeactivateUserMutation, DeactivateUserMutationVariables>;

/**
 * __useDeactivateUserMutation__
 *
 * To run a mutation, you first call `useDeactivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUserMutation, { data, loading, error }] = useDeactivateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateUserMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateUserMutation, DeactivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateUserMutation, DeactivateUserMutationVariables>(DeactivateUserDocument, options);
      }
export type DeactivateUserMutationHookResult = ReturnType<typeof useDeactivateUserMutation>;
export type DeactivateUserMutationResult = Apollo.MutationResult<DeactivateUserMutation>;
export type DeactivateUserMutationOptions = Apollo.BaseMutationOptions<DeactivateUserMutation, DeactivateUserMutationVariables>;
export const ReactivateUserDocument = gql`
    mutation ReactivateUser($id: UUID!) {
  superuserReactivateUser(id: $id) {
    ok
  }
}
    `;
export type ReactivateUserMutationFn = Apollo.MutationFunction<ReactivateUserMutation, ReactivateUserMutationVariables>;

/**
 * __useReactivateUserMutation__
 *
 * To run a mutation, you first call `useReactivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateUserMutation, { data, loading, error }] = useReactivateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReactivateUserMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateUserMutation, ReactivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateUserMutation, ReactivateUserMutationVariables>(ReactivateUserDocument, options);
      }
export type ReactivateUserMutationHookResult = ReturnType<typeof useReactivateUserMutation>;
export type ReactivateUserMutationResult = Apollo.MutationResult<ReactivateUserMutation>;
export type ReactivateUserMutationOptions = Apollo.BaseMutationOptions<ReactivateUserMutation, ReactivateUserMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($firstName: String!, $lastName: String!, $email: String!, $password1: String!, $password2: String!) {
  superuserCreateUser(
    firstName: $firstName
    lastName: $lastName
    email: $email
    password1: $password1
    password2: $password2
  ) {
    ok
    user {
      id
      email
      lastLogin
    }
    errors {
      field
      message
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password1: // value for 'password1'
 *      password2: // value for 'password2'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const SuperuserUpdateUserDocument = gql`
    mutation SuperuserUpdateUser($id: UUID!, $firstName: String!, $lastName: String!, $email: String!, $links: [String!]) {
  superuserUpdateUser(
    id: $id
    firstName: $firstName
    lastName: $lastName
    email: $email
    links: $links
  ) {
    ok
    user {
      id
      email
      firstName
      lastName
      links
    }
    errors {
      field
      message
    }
  }
}
    `;
export type SuperuserUpdateUserMutationFn = Apollo.MutationFunction<SuperuserUpdateUserMutation, SuperuserUpdateUserMutationVariables>;

/**
 * __useSuperuserUpdateUserMutation__
 *
 * To run a mutation, you first call `useSuperuserUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserUpdateUserMutation, { data, loading, error }] = useSuperuserUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      links: // value for 'links'
 *   },
 * });
 */
export function useSuperuserUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserUpdateUserMutation, SuperuserUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserUpdateUserMutation, SuperuserUpdateUserMutationVariables>(SuperuserUpdateUserDocument, options);
      }
export type SuperuserUpdateUserMutationHookResult = ReturnType<typeof useSuperuserUpdateUserMutation>;
export type SuperuserUpdateUserMutationResult = Apollo.MutationResult<SuperuserUpdateUserMutation>;
export type SuperuserUpdateUserMutationOptions = Apollo.BaseMutationOptions<SuperuserUpdateUserMutation, SuperuserUpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: UUID!) {
  superuserDeleteUser(id: $id) {
    ok
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const VenuesDocument = gql`
    query Venues($name: String, $region: [LocationInputType!], $rowsPerPage: Int, $page: Int) {
  venues(name: $name, region: $region, rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      name
      configuration
      location
      country
      countryName
      length
      trackMapThumbnail
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

/**
 * __useVenuesQuery__
 *
 * To run a query within a React component, call `useVenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenuesQuery({
 *   variables: {
 *      name: // value for 'name'
 *      region: // value for 'region'
 *      rowsPerPage: // value for 'rowsPerPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useVenuesQuery(baseOptions?: Apollo.QueryHookOptions<VenuesQuery, VenuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenuesQuery, VenuesQueryVariables>(VenuesDocument, options);
      }
export function useVenuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenuesQuery, VenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenuesQuery, VenuesQueryVariables>(VenuesDocument, options);
        }
export type VenuesQueryHookResult = ReturnType<typeof useVenuesQuery>;
export type VenuesLazyQueryHookResult = ReturnType<typeof useVenuesLazyQuery>;
export type VenuesQueryResult = Apollo.QueryResult<VenuesQuery, VenuesQueryVariables>;
export const VenuesByNameDocument = gql`
    query VenuesByName($name: String!) {
  venuesByName(name: $name) {
    id
    name
  }
}
    `;

/**
 * __useVenuesByNameQuery__
 *
 * To run a query within a React component, call `useVenuesByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenuesByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenuesByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useVenuesByNameQuery(baseOptions: Apollo.QueryHookOptions<VenuesByNameQuery, VenuesByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenuesByNameQuery, VenuesByNameQueryVariables>(VenuesByNameDocument, options);
      }
export function useVenuesByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenuesByNameQuery, VenuesByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenuesByNameQuery, VenuesByNameQueryVariables>(VenuesByNameDocument, options);
        }
export type VenuesByNameQueryHookResult = ReturnType<typeof useVenuesByNameQuery>;
export type VenuesByNameLazyQueryHookResult = ReturnType<typeof useVenuesByNameLazyQuery>;
export type VenuesByNameQueryResult = Apollo.QueryResult<VenuesByNameQuery, VenuesByNameQueryVariables>;
export const MyVenuesDocument = gql`
    query MyVenues($rowsPerPage: Int, $page: Int) {
  myVenues(rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      name
      configuration
      country
      countryName
      length
      trackMapThumbnail
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

/**
 * __useMyVenuesQuery__
 *
 * To run a query within a React component, call `useMyVenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyVenuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyVenuesQuery({
 *   variables: {
 *      rowsPerPage: // value for 'rowsPerPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useMyVenuesQuery(baseOptions?: Apollo.QueryHookOptions<MyVenuesQuery, MyVenuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyVenuesQuery, MyVenuesQueryVariables>(MyVenuesDocument, options);
      }
export function useMyVenuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyVenuesQuery, MyVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyVenuesQuery, MyVenuesQueryVariables>(MyVenuesDocument, options);
        }
export type MyVenuesQueryHookResult = ReturnType<typeof useMyVenuesQuery>;
export type MyVenuesLazyQueryHookResult = ReturnType<typeof useMyVenuesLazyQuery>;
export type MyVenuesQueryResult = Apollo.QueryResult<MyVenuesQuery, MyVenuesQueryVariables>;
export const VenueDocument = gql`
    query Venue($id: UUID!) {
  venueById(id: $id) {
    id
    name
    location
    country
    countryName
    startFinish
    finish
    length
    trackMapThumbnail
    trackMap
    sectorPoints
    configuration
    minLapTime
    primarySectorScheme
    geometryVersion
    geometryAlgorithm
    geometryGeneratedAt
    geometryStale
    sectorSchemes {
      ...SectorSchemeFields
    }
  }
}
    ${SectorSchemeFieldsFragmentDoc}`;

/**
 * __useVenueQuery__
 *
 * To run a query within a React component, call `useVenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVenueQuery(baseOptions: Apollo.QueryHookOptions<VenueQuery, VenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueQuery, VenueQueryVariables>(VenueDocument, options);
      }
export function useVenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueQuery, VenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueQuery, VenueQueryVariables>(VenueDocument, options);
        }
export type VenueQueryHookResult = ReturnType<typeof useVenueQuery>;
export type VenueLazyQueryHookResult = ReturnType<typeof useVenueLazyQuery>;
export type VenueQueryResult = Apollo.QueryResult<VenueQuery, VenueQueryVariables>;
export const CreateVenueDocument = gql`
    mutation CreateVenue($name: String!, $location: String!, $country: String, $startFinish: String, $finish: String, $length: Float, $trackMap: String, $sectorPoints: String, $configuration: String) {
  createVenue(
    name: $name
    location: $location
    country: $country
    startFinish: $startFinish
    finish: $finish
    length: $length
    trackMap: $trackMap
    sectorPoints: $sectorPoints
    configuration: $configuration
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type CreateVenueMutationFn = Apollo.MutationFunction<CreateVenueMutation, CreateVenueMutationVariables>;

/**
 * __useCreateVenueMutation__
 *
 * To run a mutation, you first call `useCreateVenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVenueMutation, { data, loading, error }] = useCreateVenueMutation({
 *   variables: {
 *      name: // value for 'name'
 *      location: // value for 'location'
 *      country: // value for 'country'
 *      startFinish: // value for 'startFinish'
 *      finish: // value for 'finish'
 *      length: // value for 'length'
 *      trackMap: // value for 'trackMap'
 *      sectorPoints: // value for 'sectorPoints'
 *      configuration: // value for 'configuration'
 *   },
 * });
 */
export function useCreateVenueMutation(baseOptions?: Apollo.MutationHookOptions<CreateVenueMutation, CreateVenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVenueMutation, CreateVenueMutationVariables>(CreateVenueDocument, options);
      }
export type CreateVenueMutationHookResult = ReturnType<typeof useCreateVenueMutation>;
export type CreateVenueMutationResult = Apollo.MutationResult<CreateVenueMutation>;
export type CreateVenueMutationOptions = Apollo.BaseMutationOptions<CreateVenueMutation, CreateVenueMutationVariables>;
export const EditVenueDocument = gql`
    mutation EditVenue($id: UUID!, $name: String!, $location: String!, $country: String, $startFinish: String, $finish: String, $length: Float, $trackMap: String, $sectorPoints: String, $configuration: String) {
  updateVenue(
    id: $id
    name: $name
    location: $location
    country: $country
    startFinish: $startFinish
    finish: $finish
    length: $length
    trackMap: $trackMap
    sectorPoints: $sectorPoints
    configuration: $configuration
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type EditVenueMutationFn = Apollo.MutationFunction<EditVenueMutation, EditVenueMutationVariables>;

/**
 * __useEditVenueMutation__
 *
 * To run a mutation, you first call `useEditVenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVenueMutation, { data, loading, error }] = useEditVenueMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      location: // value for 'location'
 *      country: // value for 'country'
 *      startFinish: // value for 'startFinish'
 *      finish: // value for 'finish'
 *      length: // value for 'length'
 *      trackMap: // value for 'trackMap'
 *      sectorPoints: // value for 'sectorPoints'
 *      configuration: // value for 'configuration'
 *   },
 * });
 */
export function useEditVenueMutation(baseOptions?: Apollo.MutationHookOptions<EditVenueMutation, EditVenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditVenueMutation, EditVenueMutationVariables>(EditVenueDocument, options);
      }
export type EditVenueMutationHookResult = ReturnType<typeof useEditVenueMutation>;
export type EditVenueMutationResult = Apollo.MutationResult<EditVenueMutation>;
export type EditVenueMutationOptions = Apollo.BaseMutationOptions<EditVenueMutation, EditVenueMutationVariables>;
export const DeleteVenueDocument = gql`
    mutation DeleteVenue($id: UUID!) {
  deleteVenue(id: $id) {
    ok
  }
}
    `;
export type DeleteVenueMutationFn = Apollo.MutationFunction<DeleteVenueMutation, DeleteVenueMutationVariables>;

/**
 * __useDeleteVenueMutation__
 *
 * To run a mutation, you first call `useDeleteVenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVenueMutation, { data, loading, error }] = useDeleteVenueMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVenueMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVenueMutation, DeleteVenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVenueMutation, DeleteVenueMutationVariables>(DeleteVenueDocument, options);
      }
export type DeleteVenueMutationHookResult = ReturnType<typeof useDeleteVenueMutation>;
export type DeleteVenueMutationResult = Apollo.MutationResult<DeleteVenueMutation>;
export type DeleteVenueMutationOptions = Apollo.BaseMutationOptions<DeleteVenueMutation, DeleteVenueMutationVariables>;
export const VenueGeometryStatusDocument = gql`
    query VenueGeometryStatus {
  superuserVenueGeometryStatus {
    totalWithTrackMap
    stale
  }
}
    `;

/**
 * __useVenueGeometryStatusQuery__
 *
 * To run a query within a React component, call `useVenueGeometryStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueGeometryStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueGeometryStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useVenueGeometryStatusQuery(baseOptions?: Apollo.QueryHookOptions<VenueGeometryStatusQuery, VenueGeometryStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueGeometryStatusQuery, VenueGeometryStatusQueryVariables>(VenueGeometryStatusDocument, options);
      }
export function useVenueGeometryStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueGeometryStatusQuery, VenueGeometryStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueGeometryStatusQuery, VenueGeometryStatusQueryVariables>(VenueGeometryStatusDocument, options);
        }
export type VenueGeometryStatusQueryHookResult = ReturnType<typeof useVenueGeometryStatusQuery>;
export type VenueGeometryStatusLazyQueryHookResult = ReturnType<typeof useVenueGeometryStatusLazyQuery>;
export type VenueGeometryStatusQueryResult = Apollo.QueryResult<VenueGeometryStatusQuery, VenueGeometryStatusQueryVariables>;
export const UpdateVenueSectorSchemeDocument = gql`
    mutation UpdateVenueSectorScheme($venueId: UUID!, $key: String!, $points: [SectorPointInput!]!, $label: String) {
  updateVenueSectorScheme(
    venueId: $venueId
    key: $key
    points: $points
    label: $label
  ) {
    ok
    errors {
      field
      message
    }
    scheme {
      ...SectorSchemeFields
    }
  }
}
    ${SectorSchemeFieldsFragmentDoc}`;
export type UpdateVenueSectorSchemeMutationFn = Apollo.MutationFunction<UpdateVenueSectorSchemeMutation, UpdateVenueSectorSchemeMutationVariables>;

/**
 * __useUpdateVenueSectorSchemeMutation__
 *
 * To run a mutation, you first call `useUpdateVenueSectorSchemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVenueSectorSchemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVenueSectorSchemeMutation, { data, loading, error }] = useUpdateVenueSectorSchemeMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      key: // value for 'key'
 *      points: // value for 'points'
 *      label: // value for 'label'
 *   },
 * });
 */
export function useUpdateVenueSectorSchemeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVenueSectorSchemeMutation, UpdateVenueSectorSchemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVenueSectorSchemeMutation, UpdateVenueSectorSchemeMutationVariables>(UpdateVenueSectorSchemeDocument, options);
      }
export type UpdateVenueSectorSchemeMutationHookResult = ReturnType<typeof useUpdateVenueSectorSchemeMutation>;
export type UpdateVenueSectorSchemeMutationResult = Apollo.MutationResult<UpdateVenueSectorSchemeMutation>;
export type UpdateVenueSectorSchemeMutationOptions = Apollo.BaseMutationOptions<UpdateVenueSectorSchemeMutation, UpdateVenueSectorSchemeMutationVariables>;
export const RegenerateVenueSectorSchemeDocument = gql`
    mutation RegenerateVenueSectorScheme($venueId: UUID!, $key: String!) {
  regenerateVenueSectorScheme(venueId: $venueId, key: $key) {
    ok
    errors {
      field
      message
    }
    scheme {
      ...SectorSchemeFields
    }
  }
}
    ${SectorSchemeFieldsFragmentDoc}`;
export type RegenerateVenueSectorSchemeMutationFn = Apollo.MutationFunction<RegenerateVenueSectorSchemeMutation, RegenerateVenueSectorSchemeMutationVariables>;

/**
 * __useRegenerateVenueSectorSchemeMutation__
 *
 * To run a mutation, you first call `useRegenerateVenueSectorSchemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateVenueSectorSchemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateVenueSectorSchemeMutation, { data, loading, error }] = useRegenerateVenueSectorSchemeMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useRegenerateVenueSectorSchemeMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateVenueSectorSchemeMutation, RegenerateVenueSectorSchemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateVenueSectorSchemeMutation, RegenerateVenueSectorSchemeMutationVariables>(RegenerateVenueSectorSchemeDocument, options);
      }
export type RegenerateVenueSectorSchemeMutationHookResult = ReturnType<typeof useRegenerateVenueSectorSchemeMutation>;
export type RegenerateVenueSectorSchemeMutationResult = Apollo.MutationResult<RegenerateVenueSectorSchemeMutation>;
export type RegenerateVenueSectorSchemeMutationOptions = Apollo.BaseMutationOptions<RegenerateVenueSectorSchemeMutation, RegenerateVenueSectorSchemeMutationVariables>;
export const SetPrimarySectorSchemeDocument = gql`
    mutation SetPrimarySectorScheme($venueId: UUID!, $key: String!) {
  setPrimarySectorScheme(venueId: $venueId, key: $key) {
    ok
    errors {
      field
      message
    }
    scheme {
      key
    }
  }
}
    `;
export type SetPrimarySectorSchemeMutationFn = Apollo.MutationFunction<SetPrimarySectorSchemeMutation, SetPrimarySectorSchemeMutationVariables>;

/**
 * __useSetPrimarySectorSchemeMutation__
 *
 * To run a mutation, you first call `useSetPrimarySectorSchemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimarySectorSchemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPrimarySectorSchemeMutation, { data, loading, error }] = useSetPrimarySectorSchemeMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useSetPrimarySectorSchemeMutation(baseOptions?: Apollo.MutationHookOptions<SetPrimarySectorSchemeMutation, SetPrimarySectorSchemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPrimarySectorSchemeMutation, SetPrimarySectorSchemeMutationVariables>(SetPrimarySectorSchemeDocument, options);
      }
export type SetPrimarySectorSchemeMutationHookResult = ReturnType<typeof useSetPrimarySectorSchemeMutation>;
export type SetPrimarySectorSchemeMutationResult = Apollo.MutationResult<SetPrimarySectorSchemeMutation>;
export type SetPrimarySectorSchemeMutationOptions = Apollo.BaseMutationOptions<SetPrimarySectorSchemeMutation, SetPrimarySectorSchemeMutationVariables>;
export const CreateVenueSectorSchemeDocument = gql`
    mutation CreateVenueSectorScheme($venueId: UUID!, $key: String!, $label: String!, $copyFrom: String) {
  createVenueSectorScheme(
    venueId: $venueId
    key: $key
    label: $label
    copyFrom: $copyFrom
  ) {
    ok
    errors {
      field
      message
    }
    scheme {
      ...SectorSchemeFields
    }
  }
}
    ${SectorSchemeFieldsFragmentDoc}`;
export type CreateVenueSectorSchemeMutationFn = Apollo.MutationFunction<CreateVenueSectorSchemeMutation, CreateVenueSectorSchemeMutationVariables>;

/**
 * __useCreateVenueSectorSchemeMutation__
 *
 * To run a mutation, you first call `useCreateVenueSectorSchemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVenueSectorSchemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVenueSectorSchemeMutation, { data, loading, error }] = useCreateVenueSectorSchemeMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      key: // value for 'key'
 *      label: // value for 'label'
 *      copyFrom: // value for 'copyFrom'
 *   },
 * });
 */
export function useCreateVenueSectorSchemeMutation(baseOptions?: Apollo.MutationHookOptions<CreateVenueSectorSchemeMutation, CreateVenueSectorSchemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVenueSectorSchemeMutation, CreateVenueSectorSchemeMutationVariables>(CreateVenueSectorSchemeDocument, options);
      }
export type CreateVenueSectorSchemeMutationHookResult = ReturnType<typeof useCreateVenueSectorSchemeMutation>;
export type CreateVenueSectorSchemeMutationResult = Apollo.MutationResult<CreateVenueSectorSchemeMutation>;
export type CreateVenueSectorSchemeMutationOptions = Apollo.BaseMutationOptions<CreateVenueSectorSchemeMutation, CreateVenueSectorSchemeMutationVariables>;
export const DeleteVenueSectorSchemeDocument = gql`
    mutation DeleteVenueSectorScheme($venueId: UUID!, $key: String!) {
  deleteVenueSectorScheme(venueId: $venueId, key: $key) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type DeleteVenueSectorSchemeMutationFn = Apollo.MutationFunction<DeleteVenueSectorSchemeMutation, DeleteVenueSectorSchemeMutationVariables>;

/**
 * __useDeleteVenueSectorSchemeMutation__
 *
 * To run a mutation, you first call `useDeleteVenueSectorSchemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVenueSectorSchemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVenueSectorSchemeMutation, { data, loading, error }] = useDeleteVenueSectorSchemeMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteVenueSectorSchemeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVenueSectorSchemeMutation, DeleteVenueSectorSchemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVenueSectorSchemeMutation, DeleteVenueSectorSchemeMutationVariables>(DeleteVenueSectorSchemeDocument, options);
      }
export type DeleteVenueSectorSchemeMutationHookResult = ReturnType<typeof useDeleteVenueSectorSchemeMutation>;
export type DeleteVenueSectorSchemeMutationResult = Apollo.MutationResult<DeleteVenueSectorSchemeMutation>;
export type DeleteVenueSectorSchemeMutationOptions = Apollo.BaseMutationOptions<DeleteVenueSectorSchemeMutation, DeleteVenueSectorSchemeMutationVariables>;
export const SuperuserRegenerateVenueGeometryDocument = gql`
    mutation SuperuserRegenerateVenueGeometry($limit: Int!, $force: Boolean!) {
  superuserRegenerateVenueGeometry(limit: $limit, force: $force) {
    processed
    remaining
    results {
      venueId
      name
      status
      message
    }
  }
}
    `;
export type SuperuserRegenerateVenueGeometryMutationFn = Apollo.MutationFunction<SuperuserRegenerateVenueGeometryMutation, SuperuserRegenerateVenueGeometryMutationVariables>;

/**
 * __useSuperuserRegenerateVenueGeometryMutation__
 *
 * To run a mutation, you first call `useSuperuserRegenerateVenueGeometryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperuserRegenerateVenueGeometryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superuserRegenerateVenueGeometryMutation, { data, loading, error }] = useSuperuserRegenerateVenueGeometryMutation({
 *   variables: {
 *      limit: // value for 'limit'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useSuperuserRegenerateVenueGeometryMutation(baseOptions?: Apollo.MutationHookOptions<SuperuserRegenerateVenueGeometryMutation, SuperuserRegenerateVenueGeometryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperuserRegenerateVenueGeometryMutation, SuperuserRegenerateVenueGeometryMutationVariables>(SuperuserRegenerateVenueGeometryDocument, options);
      }
export type SuperuserRegenerateVenueGeometryMutationHookResult = ReturnType<typeof useSuperuserRegenerateVenueGeometryMutation>;
export type SuperuserRegenerateVenueGeometryMutationResult = Apollo.MutationResult<SuperuserRegenerateVenueGeometryMutation>;
export type SuperuserRegenerateVenueGeometryMutationOptions = Apollo.BaseMutationOptions<SuperuserRegenerateVenueGeometryMutation, SuperuserRegenerateVenueGeometryMutationVariables>;
export const VideoViewerAccessDocument = gql`
    query VideoViewerAccess($eventDeviceId: UUID!, $preferHls: Boolean!) {
  videoViewerAccess(eventDeviceId: $eventDeviceId, preferHls: $preferHls) {
    mode
    signalingUrl
    viewerToken
    liveDelayHintSec
    tracks {
      cameraName
      playlistUrl
    }
  }
}
    `;

/**
 * __useVideoViewerAccessQuery__
 *
 * To run a query within a React component, call `useVideoViewerAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoViewerAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoViewerAccessQuery({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *      preferHls: // value for 'preferHls'
 *   },
 * });
 */
export function useVideoViewerAccessQuery(baseOptions: Apollo.QueryHookOptions<VideoViewerAccessQuery, VideoViewerAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoViewerAccessQuery, VideoViewerAccessQueryVariables>(VideoViewerAccessDocument, options);
      }
export function useVideoViewerAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoViewerAccessQuery, VideoViewerAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoViewerAccessQuery, VideoViewerAccessQueryVariables>(VideoViewerAccessDocument, options);
        }
export type VideoViewerAccessQueryHookResult = ReturnType<typeof useVideoViewerAccessQuery>;
export type VideoViewerAccessLazyQueryHookResult = ReturnType<typeof useVideoViewerAccessLazyQuery>;
export type VideoViewerAccessQueryResult = Apollo.QueryResult<VideoViewerAccessQuery, VideoViewerAccessQueryVariables>;
export const VideoStreamSessionsDocument = gql`
    query VideoStreamSessions($eventDeviceId: UUID!, $overlapsStart: DateTime, $overlapsEnd: DateTime) {
  videoStreamSessions(
    eventDeviceId: $eventDeviceId
    overlapsStart: $overlapsStart
    overlapsEnd: $overlapsEnd
  ) {
    id
    sessionKey
    status
    startedAt
    endedAt
    tracks {
      cameraName
      role
      vodPlaylistKey
      livePlaylistKey
      firstPdt
      lastPdt
      segmentDurationMs
      segmentCount
    }
  }
}
    `;

/**
 * __useVideoStreamSessionsQuery__
 *
 * To run a query within a React component, call `useVideoStreamSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoStreamSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoStreamSessionsQuery({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *      overlapsStart: // value for 'overlapsStart'
 *      overlapsEnd: // value for 'overlapsEnd'
 *   },
 * });
 */
export function useVideoStreamSessionsQuery(baseOptions: Apollo.QueryHookOptions<VideoStreamSessionsQuery, VideoStreamSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoStreamSessionsQuery, VideoStreamSessionsQueryVariables>(VideoStreamSessionsDocument, options);
      }
export function useVideoStreamSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoStreamSessionsQuery, VideoStreamSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoStreamSessionsQuery, VideoStreamSessionsQueryVariables>(VideoStreamSessionsDocument, options);
        }
export type VideoStreamSessionsQueryHookResult = ReturnType<typeof useVideoStreamSessionsQuery>;
export type VideoStreamSessionsLazyQueryHookResult = ReturnType<typeof useVideoStreamSessionsLazyQuery>;
export type VideoStreamSessionsQueryResult = Apollo.QueryResult<VideoStreamSessionsQuery, VideoStreamSessionsQueryVariables>;
export const MyWorkspacesDocument = gql`
    query MyWorkspaces {
  myWorkspaces {
    id
    name
    lastOpenedAt
    deviceCount
    locked
    venue {
      id
      name
      configuration
      trackMapThumbnail
    }
    eventDevices {
      id
      available
      venueMismatch
      label
      eventDevice {
        id
        device {
          id
          name
        }
        event {
          id
          name
          startAt
        }
      }
    }
    laps {
      id
      workspaceEventDeviceId
    }
  }
}
    `;

/**
 * __useMyWorkspacesQuery__
 *
 * To run a query within a React component, call `useMyWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyWorkspacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyWorkspacesQuery(baseOptions?: Apollo.QueryHookOptions<MyWorkspacesQuery, MyWorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyWorkspacesQuery, MyWorkspacesQueryVariables>(MyWorkspacesDocument, options);
      }
export function useMyWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyWorkspacesQuery, MyWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyWorkspacesQuery, MyWorkspacesQueryVariables>(MyWorkspacesDocument, options);
        }
export type MyWorkspacesQueryHookResult = ReturnType<typeof useMyWorkspacesQuery>;
export type MyWorkspacesLazyQueryHookResult = ReturnType<typeof useMyWorkspacesLazyQuery>;
export type MyWorkspacesQueryResult = Apollo.QueryResult<MyWorkspacesQuery, MyWorkspacesQueryVariables>;
export const WorkspaceDocument = gql`
    query Workspace($id: UUID!) {
  workspace(id: $id) {
    ...WorkspaceFields
  }
}
    ${WorkspaceFieldsFragmentDoc}`;

/**
 * __useWorkspaceQuery__
 *
 * To run a query within a React component, call `useWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceQuery, WorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceQuery, WorkspaceQueryVariables>(WorkspaceDocument, options);
      }
export function useWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceQuery, WorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceQuery, WorkspaceQueryVariables>(WorkspaceDocument, options);
        }
export type WorkspaceQueryHookResult = ReturnType<typeof useWorkspaceQuery>;
export type WorkspaceLazyQueryHookResult = ReturnType<typeof useWorkspaceLazyQuery>;
export type WorkspaceQueryResult = Apollo.QueryResult<WorkspaceQuery, WorkspaceQueryVariables>;
export const WorkspacesForEventDeviceDocument = gql`
    query WorkspacesForEventDevice($eventDeviceId: UUID!) {
  workspacesForEventDevice(eventDeviceId: $eventDeviceId) {
    ...WorkspaceAlternativeFields
  }
}
    ${WorkspaceAlternativeFieldsFragmentDoc}`;

/**
 * __useWorkspacesForEventDeviceQuery__
 *
 * To run a query within a React component, call `useWorkspacesForEventDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesForEventDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacesForEventDeviceQuery({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *   },
 * });
 */
export function useWorkspacesForEventDeviceQuery(baseOptions: Apollo.QueryHookOptions<WorkspacesForEventDeviceQuery, WorkspacesForEventDeviceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspacesForEventDeviceQuery, WorkspacesForEventDeviceQueryVariables>(WorkspacesForEventDeviceDocument, options);
      }
export function useWorkspacesForEventDeviceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspacesForEventDeviceQuery, WorkspacesForEventDeviceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspacesForEventDeviceQuery, WorkspacesForEventDeviceQueryVariables>(WorkspacesForEventDeviceDocument, options);
        }
export type WorkspacesForEventDeviceQueryHookResult = ReturnType<typeof useWorkspacesForEventDeviceQuery>;
export type WorkspacesForEventDeviceLazyQueryHookResult = ReturnType<typeof useWorkspacesForEventDeviceLazyQuery>;
export type WorkspacesForEventDeviceQueryResult = Apollo.QueryResult<WorkspacesForEventDeviceQuery, WorkspacesForEventDeviceQueryVariables>;
export const AnalyzeEventDeviceDocument = gql`
    mutation AnalyzeEventDevice($eventDeviceId: UUID!) {
  analyzeEventDevice(eventDeviceId: $eventDeviceId) {
    ok
    errors {
      field
      message
    }
    created
    added
    followedLive
    workspace {
      id
      name
      venue {
        id
        name
        configuration
      }
    }
    alternatives {
      ...WorkspaceAlternativeFields
    }
  }
}
    ${WorkspaceAlternativeFieldsFragmentDoc}`;
export type AnalyzeEventDeviceMutationFn = Apollo.MutationFunction<AnalyzeEventDeviceMutation, AnalyzeEventDeviceMutationVariables>;

/**
 * __useAnalyzeEventDeviceMutation__
 *
 * To run a mutation, you first call `useAnalyzeEventDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyzeEventDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyzeEventDeviceMutation, { data, loading, error }] = useAnalyzeEventDeviceMutation({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *   },
 * });
 */
export function useAnalyzeEventDeviceMutation(baseOptions?: Apollo.MutationHookOptions<AnalyzeEventDeviceMutation, AnalyzeEventDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyzeEventDeviceMutation, AnalyzeEventDeviceMutationVariables>(AnalyzeEventDeviceDocument, options);
      }
export type AnalyzeEventDeviceMutationHookResult = ReturnType<typeof useAnalyzeEventDeviceMutation>;
export type AnalyzeEventDeviceMutationResult = Apollo.MutationResult<AnalyzeEventDeviceMutation>;
export type AnalyzeEventDeviceMutationOptions = Apollo.BaseMutationOptions<AnalyzeEventDeviceMutation, AnalyzeEventDeviceMutationVariables>;
export const CreateWorkspaceDocument = gql`
    mutation CreateWorkspace($name: String, $venueId: UUID) {
  createWorkspace(name: $name, venueId: $venueId) {
    ok
    errors {
      field
      message
    }
    workspace {
      id
      name
      venue {
        id
      }
    }
  }
}
    `;
export type CreateWorkspaceMutationFn = Apollo.MutationFunction<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;

/**
 * __useCreateWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceMutation, { data, loading, error }] = useCreateWorkspaceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useCreateWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>(CreateWorkspaceDocument, options);
      }
export type CreateWorkspaceMutationHookResult = ReturnType<typeof useCreateWorkspaceMutation>;
export type CreateWorkspaceMutationResult = Apollo.MutationResult<CreateWorkspaceMutation>;
export type CreateWorkspaceMutationOptions = Apollo.BaseMutationOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;
export const RenameWorkspaceDocument = gql`
    mutation RenameWorkspace($id: UUID!, $name: String!) {
  renameWorkspace(id: $id, name: $name) {
    ok
    errors {
      field
      message
    }
    workspace {
      id
      name
    }
  }
}
    `;
export type RenameWorkspaceMutationFn = Apollo.MutationFunction<RenameWorkspaceMutation, RenameWorkspaceMutationVariables>;

/**
 * __useRenameWorkspaceMutation__
 *
 * To run a mutation, you first call `useRenameWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameWorkspaceMutation, { data, loading, error }] = useRenameWorkspaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<RenameWorkspaceMutation, RenameWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameWorkspaceMutation, RenameWorkspaceMutationVariables>(RenameWorkspaceDocument, options);
      }
export type RenameWorkspaceMutationHookResult = ReturnType<typeof useRenameWorkspaceMutation>;
export type RenameWorkspaceMutationResult = Apollo.MutationResult<RenameWorkspaceMutation>;
export type RenameWorkspaceMutationOptions = Apollo.BaseMutationOptions<RenameWorkspaceMutation, RenameWorkspaceMutationVariables>;
export const DeleteWorkspaceDocument = gql`
    mutation DeleteWorkspace($id: UUID!) {
  deleteWorkspace(id: $id) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type DeleteWorkspaceMutationFn = Apollo.MutationFunction<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;

/**
 * __useDeleteWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceMutation, { data, loading, error }] = useDeleteWorkspaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>(DeleteWorkspaceDocument, options);
      }
export type DeleteWorkspaceMutationHookResult = ReturnType<typeof useDeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationResult = Apollo.MutationResult<DeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationOptions = Apollo.BaseMutationOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;
export const TouchWorkspaceDocument = gql`
    mutation TouchWorkspace($id: UUID!) {
  touchWorkspace(id: $id) {
    ok
  }
}
    `;
export type TouchWorkspaceMutationFn = Apollo.MutationFunction<TouchWorkspaceMutation, TouchWorkspaceMutationVariables>;

/**
 * __useTouchWorkspaceMutation__
 *
 * To run a mutation, you first call `useTouchWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTouchWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [touchWorkspaceMutation, { data, loading, error }] = useTouchWorkspaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTouchWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<TouchWorkspaceMutation, TouchWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TouchWorkspaceMutation, TouchWorkspaceMutationVariables>(TouchWorkspaceDocument, options);
      }
export type TouchWorkspaceMutationHookResult = ReturnType<typeof useTouchWorkspaceMutation>;
export type TouchWorkspaceMutationResult = Apollo.MutationResult<TouchWorkspaceMutation>;
export type TouchWorkspaceMutationOptions = Apollo.BaseMutationOptions<TouchWorkspaceMutation, TouchWorkspaceMutationVariables>;
export const AddWorkspaceEventDeviceDocument = gql`
    mutation AddWorkspaceEventDevice($workspaceId: UUID!, $eventDeviceId: UUID!) {
  addWorkspaceEventDevice(
    workspaceId: $workspaceId
    eventDeviceId: $eventDeviceId
  ) {
    ok
    errors {
      field
      message
    }
    workspace {
      id
      name
    }
  }
}
    `;
export type AddWorkspaceEventDeviceMutationFn = Apollo.MutationFunction<AddWorkspaceEventDeviceMutation, AddWorkspaceEventDeviceMutationVariables>;

/**
 * __useAddWorkspaceEventDeviceMutation__
 *
 * To run a mutation, you first call `useAddWorkspaceEventDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkspaceEventDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkspaceEventDeviceMutation, { data, loading, error }] = useAddWorkspaceEventDeviceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      eventDeviceId: // value for 'eventDeviceId'
 *   },
 * });
 */
export function useAddWorkspaceEventDeviceMutation(baseOptions?: Apollo.MutationHookOptions<AddWorkspaceEventDeviceMutation, AddWorkspaceEventDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWorkspaceEventDeviceMutation, AddWorkspaceEventDeviceMutationVariables>(AddWorkspaceEventDeviceDocument, options);
      }
export type AddWorkspaceEventDeviceMutationHookResult = ReturnType<typeof useAddWorkspaceEventDeviceMutation>;
export type AddWorkspaceEventDeviceMutationResult = Apollo.MutationResult<AddWorkspaceEventDeviceMutation>;
export type AddWorkspaceEventDeviceMutationOptions = Apollo.BaseMutationOptions<AddWorkspaceEventDeviceMutation, AddWorkspaceEventDeviceMutationVariables>;
export const AddEventDeviceToWorkspacesDocument = gql`
    mutation AddEventDeviceToWorkspaces($eventDeviceId: UUID!, $workspaceIds: [UUID!]!) {
  addEventDeviceToWorkspaces(
    eventDeviceId: $eventDeviceId
    workspaceIds: $workspaceIds
  ) {
    ok
    errors {
      field
      message
    }
    workspaces {
      id
      name
    }
  }
}
    `;
export type AddEventDeviceToWorkspacesMutationFn = Apollo.MutationFunction<AddEventDeviceToWorkspacesMutation, AddEventDeviceToWorkspacesMutationVariables>;

/**
 * __useAddEventDeviceToWorkspacesMutation__
 *
 * To run a mutation, you first call `useAddEventDeviceToWorkspacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventDeviceToWorkspacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventDeviceToWorkspacesMutation, { data, loading, error }] = useAddEventDeviceToWorkspacesMutation({
 *   variables: {
 *      eventDeviceId: // value for 'eventDeviceId'
 *      workspaceIds: // value for 'workspaceIds'
 *   },
 * });
 */
export function useAddEventDeviceToWorkspacesMutation(baseOptions?: Apollo.MutationHookOptions<AddEventDeviceToWorkspacesMutation, AddEventDeviceToWorkspacesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventDeviceToWorkspacesMutation, AddEventDeviceToWorkspacesMutationVariables>(AddEventDeviceToWorkspacesDocument, options);
      }
export type AddEventDeviceToWorkspacesMutationHookResult = ReturnType<typeof useAddEventDeviceToWorkspacesMutation>;
export type AddEventDeviceToWorkspacesMutationResult = Apollo.MutationResult<AddEventDeviceToWorkspacesMutation>;
export type AddEventDeviceToWorkspacesMutationOptions = Apollo.BaseMutationOptions<AddEventDeviceToWorkspacesMutation, AddEventDeviceToWorkspacesMutationVariables>;
export const RemoveWorkspaceEventDeviceDocument = gql`
    mutation RemoveWorkspaceEventDevice($workspaceId: UUID!, $workspaceEventDeviceId: UUID!) {
  removeWorkspaceEventDevice(
    workspaceId: $workspaceId
    workspaceEventDeviceId: $workspaceEventDeviceId
  ) {
    ok
    errors {
      field
      message
    }
    workspace {
      ...WorkspaceFields
    }
  }
}
    ${WorkspaceFieldsFragmentDoc}`;
export type RemoveWorkspaceEventDeviceMutationFn = Apollo.MutationFunction<RemoveWorkspaceEventDeviceMutation, RemoveWorkspaceEventDeviceMutationVariables>;

/**
 * __useRemoveWorkspaceEventDeviceMutation__
 *
 * To run a mutation, you first call `useRemoveWorkspaceEventDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkspaceEventDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkspaceEventDeviceMutation, { data, loading, error }] = useRemoveWorkspaceEventDeviceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      workspaceEventDeviceId: // value for 'workspaceEventDeviceId'
 *   },
 * });
 */
export function useRemoveWorkspaceEventDeviceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkspaceEventDeviceMutation, RemoveWorkspaceEventDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkspaceEventDeviceMutation, RemoveWorkspaceEventDeviceMutationVariables>(RemoveWorkspaceEventDeviceDocument, options);
      }
export type RemoveWorkspaceEventDeviceMutationHookResult = ReturnType<typeof useRemoveWorkspaceEventDeviceMutation>;
export type RemoveWorkspaceEventDeviceMutationResult = Apollo.MutationResult<RemoveWorkspaceEventDeviceMutation>;
export type RemoveWorkspaceEventDeviceMutationOptions = Apollo.BaseMutationOptions<RemoveWorkspaceEventDeviceMutation, RemoveWorkspaceEventDeviceMutationVariables>;
export const LabelWorkspaceEventDeviceDocument = gql`
    mutation LabelWorkspaceEventDevice($workspaceId: UUID!, $workspaceEventDeviceId: UUID!, $label: String!) {
  labelWorkspaceEventDevice(
    workspaceId: $workspaceId
    workspaceEventDeviceId: $workspaceEventDeviceId
    label: $label
  ) {
    ok
    errors {
      field
      message
    }
    workspace {
      ...WorkspaceFields
    }
  }
}
    ${WorkspaceFieldsFragmentDoc}`;
export type LabelWorkspaceEventDeviceMutationFn = Apollo.MutationFunction<LabelWorkspaceEventDeviceMutation, LabelWorkspaceEventDeviceMutationVariables>;

/**
 * __useLabelWorkspaceEventDeviceMutation__
 *
 * To run a mutation, you first call `useLabelWorkspaceEventDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLabelWorkspaceEventDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [labelWorkspaceEventDeviceMutation, { data, loading, error }] = useLabelWorkspaceEventDeviceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      workspaceEventDeviceId: // value for 'workspaceEventDeviceId'
 *      label: // value for 'label'
 *   },
 * });
 */
export function useLabelWorkspaceEventDeviceMutation(baseOptions?: Apollo.MutationHookOptions<LabelWorkspaceEventDeviceMutation, LabelWorkspaceEventDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LabelWorkspaceEventDeviceMutation, LabelWorkspaceEventDeviceMutationVariables>(LabelWorkspaceEventDeviceDocument, options);
      }
export type LabelWorkspaceEventDeviceMutationHookResult = ReturnType<typeof useLabelWorkspaceEventDeviceMutation>;
export type LabelWorkspaceEventDeviceMutationResult = Apollo.MutationResult<LabelWorkspaceEventDeviceMutation>;
export type LabelWorkspaceEventDeviceMutationOptions = Apollo.BaseMutationOptions<LabelWorkspaceEventDeviceMutation, LabelWorkspaceEventDeviceMutationVariables>;
export const SetWorkspaceEventDeviceLiveDocument = gql`
    mutation SetWorkspaceEventDeviceLive($workspaceId: UUID!, $eventDeviceId: UUID!, $enabled: Boolean!) {
  setWorkspaceEventDeviceLive(
    workspaceId: $workspaceId
    eventDeviceId: $eventDeviceId
    enabled: $enabled
  ) {
    ok
    errors {
      field
      message
    }
    workspace {
      ...WorkspaceFields
    }
  }
}
    ${WorkspaceFieldsFragmentDoc}`;
export type SetWorkspaceEventDeviceLiveMutationFn = Apollo.MutationFunction<SetWorkspaceEventDeviceLiveMutation, SetWorkspaceEventDeviceLiveMutationVariables>;

/**
 * __useSetWorkspaceEventDeviceLiveMutation__
 *
 * To run a mutation, you first call `useSetWorkspaceEventDeviceLiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkspaceEventDeviceLiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkspaceEventDeviceLiveMutation, { data, loading, error }] = useSetWorkspaceEventDeviceLiveMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      eventDeviceId: // value for 'eventDeviceId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetWorkspaceEventDeviceLiveMutation(baseOptions?: Apollo.MutationHookOptions<SetWorkspaceEventDeviceLiveMutation, SetWorkspaceEventDeviceLiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWorkspaceEventDeviceLiveMutation, SetWorkspaceEventDeviceLiveMutationVariables>(SetWorkspaceEventDeviceLiveDocument, options);
      }
export type SetWorkspaceEventDeviceLiveMutationHookResult = ReturnType<typeof useSetWorkspaceEventDeviceLiveMutation>;
export type SetWorkspaceEventDeviceLiveMutationResult = Apollo.MutationResult<SetWorkspaceEventDeviceLiveMutation>;
export type SetWorkspaceEventDeviceLiveMutationOptions = Apollo.BaseMutationOptions<SetWorkspaceEventDeviceLiveMutation, SetWorkspaceEventDeviceLiveMutationVariables>;
export const SelectWorkspaceLapDocument = gql`
    mutation SelectWorkspaceLap($workspaceId: UUID!, $lapId: UUID!) {
  selectWorkspaceLap(workspaceId: $workspaceId, lapId: $lapId) {
    ok
    errors {
      field
      message
    }
    workspace {
      ...WorkspaceFields
    }
  }
}
    ${WorkspaceFieldsFragmentDoc}`;
export type SelectWorkspaceLapMutationFn = Apollo.MutationFunction<SelectWorkspaceLapMutation, SelectWorkspaceLapMutationVariables>;

/**
 * __useSelectWorkspaceLapMutation__
 *
 * To run a mutation, you first call `useSelectWorkspaceLapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectWorkspaceLapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectWorkspaceLapMutation, { data, loading, error }] = useSelectWorkspaceLapMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      lapId: // value for 'lapId'
 *   },
 * });
 */
export function useSelectWorkspaceLapMutation(baseOptions?: Apollo.MutationHookOptions<SelectWorkspaceLapMutation, SelectWorkspaceLapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectWorkspaceLapMutation, SelectWorkspaceLapMutationVariables>(SelectWorkspaceLapDocument, options);
      }
export type SelectWorkspaceLapMutationHookResult = ReturnType<typeof useSelectWorkspaceLapMutation>;
export type SelectWorkspaceLapMutationResult = Apollo.MutationResult<SelectWorkspaceLapMutation>;
export type SelectWorkspaceLapMutationOptions = Apollo.BaseMutationOptions<SelectWorkspaceLapMutation, SelectWorkspaceLapMutationVariables>;
export const DeselectWorkspaceLapDocument = gql`
    mutation DeselectWorkspaceLap($workspaceId: UUID!, $lapId: UUID!) {
  deselectWorkspaceLap(workspaceId: $workspaceId, lapId: $lapId) {
    ok
    errors {
      field
      message
    }
    workspace {
      ...WorkspaceFields
    }
  }
}
    ${WorkspaceFieldsFragmentDoc}`;
export type DeselectWorkspaceLapMutationFn = Apollo.MutationFunction<DeselectWorkspaceLapMutation, DeselectWorkspaceLapMutationVariables>;

/**
 * __useDeselectWorkspaceLapMutation__
 *
 * To run a mutation, you first call `useDeselectWorkspaceLapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeselectWorkspaceLapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deselectWorkspaceLapMutation, { data, loading, error }] = useDeselectWorkspaceLapMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      lapId: // value for 'lapId'
 *   },
 * });
 */
export function useDeselectWorkspaceLapMutation(baseOptions?: Apollo.MutationHookOptions<DeselectWorkspaceLapMutation, DeselectWorkspaceLapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeselectWorkspaceLapMutation, DeselectWorkspaceLapMutationVariables>(DeselectWorkspaceLapDocument, options);
      }
export type DeselectWorkspaceLapMutationHookResult = ReturnType<typeof useDeselectWorkspaceLapMutation>;
export type DeselectWorkspaceLapMutationResult = Apollo.MutationResult<DeselectWorkspaceLapMutation>;
export type DeselectWorkspaceLapMutationOptions = Apollo.BaseMutationOptions<DeselectWorkspaceLapMutation, DeselectWorkspaceLapMutationVariables>;
export const SetWorkspaceScreensDocument = gql`
    mutation SetWorkspaceScreens($workspaceId: UUID!, $screens: JSON!) {
  setWorkspaceScreens(workspaceId: $workspaceId, screens: $screens) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export type SetWorkspaceScreensMutationFn = Apollo.MutationFunction<SetWorkspaceScreensMutation, SetWorkspaceScreensMutationVariables>;

/**
 * __useSetWorkspaceScreensMutation__
 *
 * To run a mutation, you first call `useSetWorkspaceScreensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkspaceScreensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkspaceScreensMutation, { data, loading, error }] = useSetWorkspaceScreensMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      screens: // value for 'screens'
 *   },
 * });
 */
export function useSetWorkspaceScreensMutation(baseOptions?: Apollo.MutationHookOptions<SetWorkspaceScreensMutation, SetWorkspaceScreensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWorkspaceScreensMutation, SetWorkspaceScreensMutationVariables>(SetWorkspaceScreensDocument, options);
      }
export type SetWorkspaceScreensMutationHookResult = ReturnType<typeof useSetWorkspaceScreensMutation>;
export type SetWorkspaceScreensMutationResult = Apollo.MutationResult<SetWorkspaceScreensMutation>;
export type SetWorkspaceScreensMutationOptions = Apollo.BaseMutationOptions<SetWorkspaceScreensMutation, SetWorkspaceScreensMutationVariables>;
export const ApplyCollectionToWorkspaceDocument = gql`
    mutation ApplyCollectionToWorkspace($workspaceId: UUID!, $presetId: UUID!) {
  applyCollectionToWorkspace(workspaceId: $workspaceId, presetId: $presetId) {
    ok
    errors {
      field
      message
    }
    workspace {
      ...WorkspaceFields
    }
  }
}
    ${WorkspaceFieldsFragmentDoc}`;
export type ApplyCollectionToWorkspaceMutationFn = Apollo.MutationFunction<ApplyCollectionToWorkspaceMutation, ApplyCollectionToWorkspaceMutationVariables>;

/**
 * __useApplyCollectionToWorkspaceMutation__
 *
 * To run a mutation, you first call `useApplyCollectionToWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCollectionToWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCollectionToWorkspaceMutation, { data, loading, error }] = useApplyCollectionToWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      presetId: // value for 'presetId'
 *   },
 * });
 */
export function useApplyCollectionToWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<ApplyCollectionToWorkspaceMutation, ApplyCollectionToWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyCollectionToWorkspaceMutation, ApplyCollectionToWorkspaceMutationVariables>(ApplyCollectionToWorkspaceDocument, options);
      }
export type ApplyCollectionToWorkspaceMutationHookResult = ReturnType<typeof useApplyCollectionToWorkspaceMutation>;
export type ApplyCollectionToWorkspaceMutationResult = Apollo.MutationResult<ApplyCollectionToWorkspaceMutation>;
export type ApplyCollectionToWorkspaceMutationOptions = Apollo.BaseMutationOptions<ApplyCollectionToWorkspaceMutation, ApplyCollectionToWorkspaceMutationVariables>;
export const WorkspaceQuotaDocument = gql`
    query WorkspaceQuota {
  workspaceQuota {
    limit
    used
    canCreate
  }
}
    `;

/**
 * __useWorkspaceQuotaQuery__
 *
 * To run a query within a React component, call `useWorkspaceQuotaQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceQuotaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceQuotaQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceQuotaQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceQuotaQuery, WorkspaceQuotaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceQuotaQuery, WorkspaceQuotaQueryVariables>(WorkspaceQuotaDocument, options);
      }
export function useWorkspaceQuotaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceQuotaQuery, WorkspaceQuotaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceQuotaQuery, WorkspaceQuotaQueryVariables>(WorkspaceQuotaDocument, options);
        }
export type WorkspaceQuotaQueryHookResult = ReturnType<typeof useWorkspaceQuotaQuery>;
export type WorkspaceQuotaLazyQueryHookResult = ReturnType<typeof useWorkspaceQuotaLazyQuery>;
export type WorkspaceQuotaQueryResult = Apollo.QueryResult<WorkspaceQuotaQuery, WorkspaceQuotaQueryVariables>;